webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/wkIssI/%3F1737196001647&title=The%20Book%20of%20Jeremiah%2C%20New%20International%20Commentary%20on%20the%20Old%20Testament%20%28NICOT%29&summary=Of%20the%20Major%20Prophets%2C%20Jeremiah%20is%20perhaps%20the%20least%20straightforward.%20It%20is%20variously%20comprised%20of%20stories%20about%20the%20prophet%20Jeremiah%2C%20exchanges%20between%20Jeremiah%20and%20Yahweh%2C%20and%20messages%20directly%20from%20Yahweh%26mdash%3Bmeaning%20a%20consciousness%20of%20form%20is%20ess&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/wkIssI/%3F1737196001647",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Of%20the%20Major%20Prophets%2C%20Jeremiah%20is%20perhaps%20the%20least%20straightforward.%20It%20is%20variously%20comprised%20of%20stories%20about%20the%20prophet%20Jeremiah%2C%20exchan%0Dhttps://textcafe.co/books/wkIssI/%3F1737196001647&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/wkIssI/%3F1737196001647&posttype=link&caption=Of%20the%20Major%20Prophets%2C%20Jeremiah%20is%20perhaps%20the%20least%20straightforward.%20It%20is%20variously%20comprised%20of%20stories%20about%20the%20prophet%20Jeremiah%2C%20exchanges%20between%20Jeremiah%20and%20Yahweh%2C%20and%20messages%20directly%20from%20Yahweh%26mdash%3Bmeaning%20a%20consciousness%20of%20form%20is%20ess",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/wkIssI/%3F1737196001647&description=Of%20the%20Major%20Prophets%2C%20Jeremiah%20is%20perhaps%20the%20least%20straightforward.%20It%20is%20variously%20comprised%20of%20stories%20about%20the%20prophet%20Jeremiah%2C%20exchanges%20between%20Jeremiah%20and%20Yahweh%2C%20and%20messages%20directly%20from%20Yahweh%26mdash%3Bmeaning%20a%20consciousness%20of%20form%20is%20ess&media=https://textcafe.co/books/wkIssI/tc-custom/9781467462471.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781467462471&i=stripbooks&linkCode=qs',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=acuAEAAAQBAJ&amp;rdid=book-acuAEAAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781467462471').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/wkIssI/tc-custom/9781467462471.jpg?1737196001647',
        alt: 'The Book of Jeremiah, New International Commentary on the Old Testament (NICOT)'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "005_Contents", "006_Preface", "007_Abbreviations", "008_Bibliography", "009_Map", "010_Introduction", "010_Part", "011_Text", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/wkIssI/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_000_Cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_000_Cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_001_Halftitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM01__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_002_FM01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_002_FM01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_003_TitlePage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_004_Copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_004_Copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_005_Contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_006_Preface__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Bibliography__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_008_Bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_008_Bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Map__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_009_Map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_009_Map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Introduction__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_010_Introduction___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_010_Introduction__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_010_Part__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_010_Part___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_010_Part__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_011_Text__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_011_Text___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_011_Text__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_012_Part01a__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_012_Part01a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_012_Part01a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Part01b__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_012_Part01b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_012_Part01b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Part02a__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_013_Part02a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_013_Part02a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_013_Part02b__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_013_Part02b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_013_Part02b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_013_Part02c__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_013_Part02c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_013_Part02c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_013_Part02d__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_013_Part02d___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_013_Part02d__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_013_Part02e__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_013_Part02e___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_013_Part02e__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_013_Part02f__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_013_Part02f___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_013_Part02f__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_014_Part03a__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_014_Part03a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_014_Part03a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_014_Part03b__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_014_Part03b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_014_Part03b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_014_Part03c__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_014_Part03c___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_014_Part03c__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_015_Part04__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_015_Part04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_015_Part04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_016_Part05a__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_016_Part05a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_016_Part05a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_016_Part05b__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_016_Part05b___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_016_Part05b__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_017_Epilogue__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_017_Epilogue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_017_Epilogue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_last__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_last__);
/*jshint esversion: 6 */



































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/005_Contents",
    "name": "005_Contents",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_005_Contents___default.a
  }, {
    "path": "/006_Preface",
    "name": "006_Preface",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_006_Preface___default.a
  }, {
    "path": "/007_Abbreviations",
    "name": "007_Abbreviations",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_007_Abbreviations___default.a
  }, {
    "path": "/008_Bibliography",
    "name": "008_Bibliography",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_008_Bibliography___default.a
  }, {
    "path": "/009_Map",
    "name": "009_Map",
    "component": __WEBPACK_IMPORTED_MODULE_13__components_009_Map___default.a
  }, {
    "path": "/010_Introduction",
    "name": "010_Introduction",
    "component": __WEBPACK_IMPORTED_MODULE_14__components_010_Introduction___default.a
  }, {
    "path": "/010_Part",
    "name": "010_Part",
    "component": __WEBPACK_IMPORTED_MODULE_15__components_010_Part___default.a
  }, {
    "path": "/011_Text",
    "name": "011_Text",
    "component": __WEBPACK_IMPORTED_MODULE_16__components_011_Text___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_32__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John Goldingay\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("John Goldingay")]), _vm._v(" is David Allan Hubbard Professor Emeritus of Old Testament at Fuller Seminary.   ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wkIssI/tc-custom/9781467462471.jpg?1737196001647",
      "alt": "This image is the cover for the book The Book of Jeremiah, New International Commentary on the Old Testament (NICOT)"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("The Book of Jeremiah, New International Commentary on the Old Testament (NICOT)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Of the Major Prophets, Jeremiah is perhaps the least straightforward. It is variously comprised of stories about the prophet Jeremiah, exchanges between Jeremiah and Yahweh, and messages directly from Yahweh—meaning a consciousness of form is essential to the understanding of its content. At times it is written in poetry, resembling Isaiah, while at other times it is written in prose, more similar to Ezekiel. And it is without doubt the darkest and most threatening of the Major Prophets, inviting comparisons to Amos and Hosea. ")]), _c('p', [_vm._v("John Goldingay, a widely respected biblical scholar who has written extensively on the entire Old Testament, navigates these complexities in the same spirit as other volumes of the New International Commentary on the Old Testament series—rooted in Jeremiah’s historical context but with an eye always trained on its meaning and use as Christian Scripture. After a thorough introduction that explores matters of background, composition, and theology, Goldingay provides an original translation and verse-by-verse commentary of all fifty-two chapters, making this an authoritative and indispensable reference for scholars and pastors as they engage with Jeremiah from a contemporary Christian standpoint.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/006_Preface#fm-1"
    }
  }, [_c('em', [_vm._v("Series Editor’s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/007_Abbreviations#fm-2"
    }
  }, [_c('em', [_vm._v("List of Abbreviations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Bibliography#fm-3"
    }
  }, [_c('em', [_vm._v("Select Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Map#fm-4"
    }
  }, [_c('em', [_vm._v("Maps")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#ch-1"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-1"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("I."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ACKGROUND")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-1"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Josiah, Jehoiakim, Zedekiah, and the Fall of Jerusalem")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-2"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh’s Message Came")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-2"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("II."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("U"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NITY OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMPOSITION")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-3"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Three Horizons")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-4"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Composition of Jeremiah and the Composition of the Gospels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-5"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Persian Period: A Fourth Horizon?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-6"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Disunity of Composition (A Fifth Horizon)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-7"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Torah, the Prophets, and the Psalms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-8"
    }
  }, [_vm._v("F."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Was Jeremiah a Historical Figure?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-3"
    }
  }, [_c('span', {
    staticClass: "toc3"
  }, [_vm._v("III."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHORSHIP AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ATE")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-9"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah as Poet")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-10"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah as Preacher")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-11"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah as Crusader")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-12"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah as Persuader")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-13"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah and His Curators as Anthologists")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-4"
    }
  }, [_c('span', {
    staticClass: "toc2a"
  }, [_vm._v("IV."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LACE OF")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RIGIN")]), _vm._v(", O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CCASION")]), _vm._v(", "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AND")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTINATION")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-5"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("V."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ANONICITY")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-14"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Scroll as Message from Yahweh")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-15"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Scroll and the Scriptures")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-16"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Jeremiah Scroll in the Canons of Judaism and of the Church")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-6"
    }
  }, [_c('span', {
    staticClass: "toc3"
  }, [_vm._v("VI."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EBREW")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXT")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-17"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Two Versions")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-18"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Behind the Masoretic Text")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-7"
    }
  }, [_c('span', {
    staticClass: "toc4"
  }, [_vm._v("VII."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEOLOGY")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-19"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The God of Israel")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-20"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Israel of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-21"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Nations")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-22"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Present, the Past, and the Future")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-8"
    }
  }, [_vm._v("VIII."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AIN")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEMES AND")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HEIR")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("MPLICATIONS")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-23"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Theology Embodied: Jeremiah as Subject")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-24"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Theology Imaged")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-25"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Theology of a Both-and Character")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec-9"
    }
  }, [_c('span', {
    staticClass: "toc3"
  }, [_vm._v("IX."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NALYSIS OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONTENTS")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-26"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah 1–25")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Introduction#sec2-27"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah 25–52")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Text#ch-2"
    }
  }, [_vm._v("TEXT AND COMMENTARY")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Text#sec-10"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ROLOGUE")]), _vm._v(": A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTRODUCTION TO THE")]), _vm._v(" S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CROLL")]), _vm._v(" (1:1–19)")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Text#sec2-28"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Preface (1:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Text#sec2-29"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Gives an Account of His Commission (1:4–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Text#sec2-30"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Reports a Message from Yahweh: He Is Going to Do What He Has Said (1:11–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Text#sec2-31"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Reports a Second Message from Yahweh: He Intends to Bring Disaster on Judah, and Jeremiah Must Be Bold (1:13–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc1"
  }, [_vm._v("I."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NE")]), _vm._v(": C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONFRONTATION")]), _vm._v(", E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("XHORTATION")]), _vm._v(", W"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ARNING")]), _vm._v(" (2:1–6:30)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec2-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Mostly Confrontation (2:1–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Wistful Remembering (2:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("An Extension to the Argument (2:9–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("An Explanation of Israel’s Becoming Plunder (2:14–20b)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Defilement (2:20c–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Shameful Community (2:26–31a)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Shaming to Come (2:31b–37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec2-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Mostly Exhortation: Turning and Turning Back (3:1–4:4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Impossible Possibility? (3:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Implausibility (3:2–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Judah’s Faulty Turning (3:6–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Implausible Model (3:11–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Explicit Urging (3:19–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01a#sec3-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Make It Genuine (4:1–4)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec2-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Mostly Warning: The Whole Country Desolate (4:5–31)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("It’s War (4:5–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Formless and Empty (4:19–31)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec2-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Mostly Confrontation (5:1–31)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Universal Deceptiveness (5:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Foreign Service (5:10–19)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Way People Became Big and Wealthy (5:20–31)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec2-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Mostly (Final) Warning (6:1–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Sanctify a Battle (6:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Strip the Vine (6:9–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Put Things in Place to Trip People (6:16–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("All Around Is Terror (6:22–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/012_Part01b#sec3-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Reject Silver (6:27–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("II."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WO")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("WENTY")]), _vm._v(" M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ORE")]), _vm._v(" Y"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EARS")]), _vm._v(" (7:1–24:10)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec2-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 2a: Exhortations and Exchanges (7:1–10:25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec3-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Five Exhortations, Confrontations, and Warnings about Worship (7:1–8:3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About the Temple (7:1–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Whether It’s Possible to Pray (7:16–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Yahweh’s Priorities (7:21–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About an Ultimate Sacrifice (7:29–34)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Looking to the Sun, the Moon, and the Stars (8:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec3-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Three Exchanges (8:4–9:26[25])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Opening Challenge and Exchanges between Yahweh and Judah (8:4–20)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Exchanges between Yahweh and Jeremiah (8:21–9:16[15])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Exchanges between Yahweh and Judah and the Closing Challenge (9:17–26[16–25])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec3-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Another Exhortation and Another Exchange (10:1–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("An Exhortation about Images (10:1–16)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02a#sec4-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("An Exchange between Yahweh and Judah (10:17–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec2-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 2b: Jeremiah’s Arguments (11:1–13:27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec3-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Another Confrontation and Warning, about the Pledge (11:1–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec3-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Three Exchanges (Protests and Responses) (11:18–12:17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Lamb Led to Slaughtering/I Will Attend to Them (11:18–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Why Does the Path of Faithless People Succeed/How Will You Compete with Horses? (12:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("I Have Abandoned My House/I Will Again Have Compassion (12:7–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec3-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Five More Warnings (13:1–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Name, Praise, and Splendor (13:1–12a)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Ruin or Devastation (13:12b–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Exaltedness (13:15–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About the Flock (13:18–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02b#sec4-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Exposure (13:23–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec2-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 2c: Drought, Hunger, Sword (14:1–17:27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec3-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Four More Exchanges (Protests and Responses) (14:1–15:21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Dearths, the Plea, and the Response (14:1–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Prophets (14:13–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Wound and the Threat (14:19–15:9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Persecutors (15:10–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec3-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Confrontations and Warnings: This Country and Domain (16:1–17:11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Joy and Favor Suspended Here (16:1–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Restoration, Cleansing, and Revelation Here (16:14–21)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec4-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Forfeit Here (17:1–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02c#sec3-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Another Exchange: Three Ironies (17:12–27)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec2-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 2d: Concerning Plans and Counsels (18:1–20:18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec3-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Potter: When Your Decisions Can Make a Difference (18:1–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah and the Potter: Yahweh’s Flexible Plans (18:1–12)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Verse Postscript: Yahweh’s Assessment of Judah (18:13–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Protest Responding to What Has Preceded: An Ultimate Prayer (18:18–23)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec3-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Pot: And When It’s Too Late (19:1–20:18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah, the Decanter, and Yahweh’s Counsel (19:1–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Story Postscript: The Reaction and the Identity of the Invader (19:14–20:6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Protests Responding to What Has Preceded: Two Ultimate Prayers (20:7–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec2-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 2e: On Kings and Prophets (21:1–24:10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec3-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Kings (and Their People) (21:1–23:8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Zedekiah (and the City) (21:1–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("David’s Household (and the City) (21:11–22:9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Three Kings (22:10–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02d#sec4-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Good Shepherd, a Faithful Shoot, a New Exodus (23:1–8)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02e#sec3-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Prophets (and Their People) (23:9–24:10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02e#sec4-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("About Prophets (23:9–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02e#sec4-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Two Lots of Figs (24:1–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02f#sec-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("N")]), _vm._v(" I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NTERIM")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ONCLUSION")]), _vm._v(" (25:1–38 [LXX 25:1–13; 32:1–24])")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02f#sec2-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Climactic Warning (25:1–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02f#sec2-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Chalice (25:15–29 [LXX 32:1–15])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/013_Part02f#sec2-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Prophecy (25:30–38 [LXX 32:16–24])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec-14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc3"
  }, [_vm._v("III."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HREE")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" D"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("AST AND THE")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OSSIBILITY OF")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESTORATION")]), _vm._v(" (26:1–36:32)")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec2-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 3a: Stories about Prophets (26:1–29:32 [LXX 33:1–36:32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("How Jeremiah Almost Lost His Life (26:1–27:1a [LXX 33:1–24])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Bids Judah Submit to the Babylonians (27:1b–22 [LXX 34:2–22])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("How Hananiah Lost His Life (28:1–17 [LXX 35:1–17])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Bids the Exile Community to Settle Down (29:1–32 [LXX 36:1–32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec2-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 3b: At Last, A Focus on Hope (30:1–33:26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Introduction to the Document (30:1–4 [LXX 37:1–4])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Reversal for Zion (30:5–31:1 [LXX 37:5–38:1])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec4-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Trembling Terminated (30:5–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec4-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("You Deserve Your Injuries, but I Will Heal (30:12–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec4-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Restored City and Relationship (30:18–31:1)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec3-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Reversal for Ephraim (31:2–22 [LXX 38:2–22])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03a#sec4-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Building and Planting (31:2–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Redeeming and Restoring (31:7–14)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Turning and Compassion (31:15–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec3-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Reversal for Israel and Judah (31:23–40 [LXX 38:23–40])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Renewal of Blessing (31:23–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("New Sowing (31:27–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Present Redress (31:29–30)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A New Pledge (31:31–34)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Israel’s Permanence (31:35–36)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Israel’s Security (31:37)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("g."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The City’s Rebuilding (31:38–40)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec3-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Acquisition of Land (32:1–44 [LXX 39:1–44])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Background (32:1–5)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Acquires Some Land (32:6–15)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Quizzes Yahweh (32:16–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh Replies: First, the Bad News (32:26–35)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh Replies: Second, the Good News of Reaffirmation (32:36–41)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh Replies: Third, the Good News about Land (32:42–44)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec3-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Some Vital Afterthoughts (33:1–26 [LXX 40:1–13])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("I Will Bring Healing and Purification to Judah and Ephraim (33:1–9)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Rejoicing and Praise Will Again Resound in Jerusalem (33:10–11)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Flocks Will Pasture Again All Over the Country (33:12–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03b#sec4-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("David and the Levites Will Have Their Successors Ministering for Ephraim and Judah (33:14–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec4-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Those Promises Are as Sure as Yahweh’s Pledge with Day and Night (33:19–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec4-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh Will Keep His Commitment to the Offspring of Jacob and of David (33:23–26)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec2-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 3c: Stories Implying a Reversion to Reality (34:1–36:32 [LXX 41:1–43:32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec3-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Threat and a Promise from the Time of Zedekiah (34:1–7 [LXX 41:1–7])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec3-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Story about Zedekiah and a Threat from His Time (34:8–22 [LXX 41:8–22])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec3-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Reminder About the Rechabites and a Promise from Their Time (35:1–19 [LXX 42:1–19])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Part03c#sec3-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Story about Jehoiakim and a Threat from His Time (36:1–32 [LXX 43:1–32]")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec-15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc3"
  }, [_vm._v("IV."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OUR")]), _vm._v(": T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ALAMITY AND THE")]), _vm._v(" A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("FTERMATH")]), _vm._v(" (37:1–45:5 [LXX 44:1–51:35])")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec2-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 4a: Last Chances, Calamity, and a Footnote for Ebed-melech (37:1–39:18 [LXX 44:1–46:18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Zedekiah Consulting Jeremiah; Jeremiah Locked Up (37:1–21 [LXX 44:1–21])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Jeremiah Locked Up; Zedekiah Consulting Jeremiah (38:1–28a [LXX 45:1–28a])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The City Falls, and the Fates That Follow (38:28b—39:14 [LXX 45:28b—46:14])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Footnote Message for Ebed-melech (39:15–18 [LXX 46:15–18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec2-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 4b: The Aftermath, and Missed Chances (40:1–44:30 [LXX 47:1–51:30])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A New Start at Mizpah, the Watchtower (40:1–12 [LXX 47:1–12])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Things Begin to Fall Apart (40:13–41:18 [LXX 47:13–48:18])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh’s Direction Given and Rejected (42:1–43:13 [LXX 49:1–50:13])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec4-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Judahites Ask for Direction (42:1–6)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec4-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh Gives Them Direction, Promises, and Warnings (42:7–18)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec4-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Yahweh Gives Them a Rebuke (42:19–22)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec4-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Judahites Reject the Message (43:1–3)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec4-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("They Move to Egypt (43:4–13)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Final Confrontation, Exhortation, and Warning (44:1–30 [LXX 51:1–30])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Part04#sec3-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("A Footnote Message for Baruch (45:1–5 [LXX 51:31–35])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec-16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc2"
  }, [_vm._v("V."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ART")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("IVE")]), _vm._v(": M"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ESSAGES ABOUT")]), _vm._v(" O"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("THER")]), _vm._v(" P"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EOPLES")]), _vm._v(" (46:1–51:64 [LXX 26:1–31:44])")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec2-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 5a: Introduction, and Egypt (46:1–28)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Introduction; and Before the Battle of Carchemish (46:1–12 [LXX 26:1–12])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Before Nebuchadrezzar’s Invasion of Egypt (46:13–24 [LXX 26:13–24])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Two Encouraging Footnotes (46:25–28 [LXX 26:25–28])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec2-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 5b: Neighbors and Distant Peoples (47:1–49:39)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Philistia (47:1–7 [LXX 29:1–7])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Moab (48:1–47 [LXX 31:1–44])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("a."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Moab Broken (48:1–10)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("b."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Retrospect and Prospect (48:11–17)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("c."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("What Has Happened? (48:18–25)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("d."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Wine and Arrogance (48:26–32)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("e."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Worship Replaced by Wailing (48:33–39)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("f."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("An Eagle, a Trap, a Fire (48:40–46)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec4"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec4-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("g."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("But Disaster Is Not the End (48:47)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Ammon (49:1–6 [LXX 30:1–5 or 17–21])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Edom (49:7–22 [LXX 29:8–23 or 30:1–16])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Damascus (49:23–27 [LXX 30:12–16 or 29–33])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Kedar and Hazor (49:28–33 [LXX 30:6–11 or 23–28])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05a#sec3-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Elam (49:34–39 [LXX 25:14–19])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec2"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec2-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Part 5c: Babylon, and Three Conclusions (50:1–51:64)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Introduction (50:1 [LXX 27:1])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Fate of Flock, Lions, and Shepherds (50:2–20 [LXX 27:2–20])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Challenges That Yahweh Accepts (50:21–32 [LXX 27:21–32])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Threats That Yahweh Repeats (50:33–46 [LXX 27:33–46])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Faithful and Powerful God (51:1–19 [LXX 28:1–19])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Shatterer Shattered (51:20–33 [LXX 28:20–33])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Zion’s Lament (51:34–44 [LXX 28:34–44])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("So Be Mindful of Jerusalem and of Babylon (51:45–58c [LXX 28:45–58c])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("Conclusion (51:58d [LXX 28:58d])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec3"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Part05b#sec3-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "tab"
  }, [_vm._v("The Story of the Scroll, and Another Conclusion (51:59–64 [LXX 28:59–64])")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-sec"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Epilogue#sec-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PILOGUE")]), _vm._v(" (52:1–34)")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-1"
    }
  }, [_vm._v("Series Editor’s Preface")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("“Do you "), _c('em', [_vm._v("understand")]), _vm._v(" what you’re "), _c('em', [_vm._v("reading")]), _vm._v("?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What a question!")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With this opening line, Philip, one of Christianity’s first evangelists, approached a seeker from Africa, who had been in Jerusalem to worship. Somewhere along the Gaza Road, on his return trip to Ethiopia, the stranger was reading a portion of the Old Testament. Philip asked the question when he heard him “reading” the ancient text, an activity that almost certainly involved verbalizing the text by reciting it aloud ("), _c('em', [_vm._v("anaginōskō")]), _vm._v("; Acts 8:30). An “angel of the Lord” had sent Philip to meet the Ethiopian for this very opportunity (8:26–29).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Realizing that the seeker was reading a difficult text, and yet also realizing how vitally important it was to the stranger’s faith, Philip distinguished between reading and comprehending. “Understanding” is different from simply pronouncing the text aloud; comprehension involves grasping the significance of what is read ("), _c('em', [_vm._v("ginōskō")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such a deep-level understanding of ancient Israel’s Scriptures has always been the goal of The New International Commentary on the Old Testament. Since 1965, the editors of this series—Edward J. Young, Roland K. Harrison, and Robert L. Hubbard Jr.—have guided the series and its authors with the sole purpose of aiding the reader to gain understanding of the text. They have left us a treasured gift. Today a wide readership of scholars, priests, pastors, rabbis, and other serious students of the Bible turn to NICOT volumes for assistance in reading the ancient text.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The aim of the series has always been “to publish biblical scholarship of the highest quality” (to quote the preface of my predecessor, Professor Hubbard) and to do so respectfully from a position of faith seeking understanding. The series appeals to readers across the entire spectrum of theological or philosophical perspectives, and always with the conviction that the Old Testament is more than great literature from the past. Its authors engage the range of traditional methodologies, always sensitive to newer innovations in recent scholarship, and always remembering that the books of the Old Testament constituted the first Bible for the earliest Christians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Specifically, the NICOT authors believe the books they are writing about—ancient Israel’s Scriptures—are God-breathed ("), _c('em', [_vm._v("theopneustos")]), _vm._v(") or “inspired” and therefore “useful for teaching, for reproof, for correction, and for training in righteousness” (2 Timothy 3:16). This high regard of and respect for the authority of Scripture characterizes what has come to be known as “evangelicalism,” together with conversionism, activism, and crucicentrism (according to noted historian David W. Bebbington). While the term “evangelical” today requires considerable qualification, the movement it denotes is of God and is still much needed in the Church universal. The authors of the NICOT come from diverse theological branches of the Church, and yet they hold firmly to this conviction that the Old Testament continues as God’s means of grace for the Church today. In its pages, and by means of its message, God calls readers into an ever-deepening relational intimacy, inviting all who read ("), _c('em', [_vm._v("anaginōskō")]), _vm._v(") to understand ("), _c('em', [_vm._v("ginōskō")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In response to Philip’s question, the Ethiopian seeker admitted that he could not possibly read the ancient text with understanding “unless someone guides me” (Acts 8:31). He was aware of his need to have someone come alongside him to help him acquire the knowledge he desired. He invited Philip to join him in his chariot (and thus in his reading experience), and once he finally understood the Old Testament text, he immediately asked to be baptized (Acts 8:31–38).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This exchange illustrates the difficulty of reading for true understanding, the need for a faithful guide in one’s reading, and the power of the ancient text to lead one into saving faith. The goal of each NICOT volume is to be such a guide. Readers around the world have invited the volumes of this series into their reading experience. The ancient text may seem obscure and distant. But God is still at work in its power, and reading it for understanding still makes a life-changing difference for the reader, as it did for Philip’s new Ethiopian friend.")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ILL")]), _vm._v(" T. A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RNOLD")])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AB")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Anchor Bible")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AcT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Acta Theologica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AIIL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Ancient Israel and Its Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AJSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("American Journal of Semitic Languages and Literatures")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AnBib")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Analecta Biblica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ANET")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ancient Near Eastern Texts Relating to the Old Testament")]), _vm._v(". Edited by James B. Pritchard. 3rd ed. Princeton: Princeton University Press, 1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aq")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aquila’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(" (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("AUSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Andrews University Seminary Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("b.")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("(followed by the name of a tractate) Babylonian Talmud")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BA")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Archaeologist")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BASOR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin of the American Schools of Oriental Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBB")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bonner biblische Beiträge")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bulletin for Biblical Research")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BBRSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bulletin for Biblical Research, Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BDB")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Brown, F., S. R. Driver, and C. A. Briggs. "), _c('em', [_vm._v("A Hebrew and English Lexicon of the Old Testament")]), _vm._v(". Reprinted with corrections. Oxford: Oxford University Press, 1962")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BETL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Bibliotheca ephemeridum theologicarum Lovaniensium")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia Hebraica Stuttgartensia")]), _vm._v(". Edited by K. Elliger and W. Rudolph. Stuttgart: Deutsche Bibelgesellschaft, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BibInt")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblical Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BibInt")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Biblical Interpretation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bib")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblica")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BSac")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Bibliotheca Sacra")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BWANT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beiträge zur Wissenschaft vom Alten und Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("BZ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblische")]), _vm._v(" "), _c('em', [_vm._v("Zeitschrift")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("BZAW")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Church Dogmatics")]), _vm._v(". K. Barth. 4 vols. Edinburgh: T&T Clark, 1936–1969")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CHP")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Classical Hebrew Poetry: A Guide to Its Techniques")]), _vm._v(". W. G. E. Watson. JSOTSup 26. 2nd ed. Sheffield: JSOT Press, 1986")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTAT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Critique textuelle de l’Ancien Testament")]), _vm._v(". D. Barthélemy. Vol. 2. Göttingen: Vandenhoeck & Ruprecht, 1986")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CTJ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Calvin Theological Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("CurBR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Currents in Biblical Research")]), _vm._v(" (formerly "), _c('em', [_vm._v("Currents in Research: Biblical Studies")]), _vm._v(")")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DCH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Classical Hebrew")]), _vm._v(". Edited by D. J. A. Clines. 9 vols. Vols. 1–5, Sheffield: Sheffield Academic, 1993–2001; vols. 6–9, Sheffield: Sheffield Phoenix, 2007–2016")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DDD")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Dictionary of Deities and Demons in the Bible")]), _vm._v(". Edited by K. van der Toorn, B. Becking, and P. W. van der Horst. 2nd rev. ed. Grand Rapids: Eerdmans, 1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("DG")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Davidson’s Introductory Hebrew Grammar—Syntax")]), _vm._v(". J. C. L. Gibson. Edinburgh: T&T Clark, 1994")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DSS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Dead Sea Scrolls")]), _vm._v(". Edited by F. García Martínez and E. J. C. Tigchelaar. Repr., Leiden: Brill, 2000")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("DTT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Dictionary of the Targumim, the Talmud Babli and Yerushalmi, and the Midrashic Literature")]), _vm._v(". M. Jastrow. New York: Choreb, 1926")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ETL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Ephemerides theologicae Lovanienses")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvQ")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelical Quarterly")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EvT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Evangelische Theologie")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FAT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zum Alten Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("FRLANT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Forschungen zur Religion und Literatur des Alten und Neuen Testaments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GKC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Gesenius’ Hebrew Grammar")]), _vm._v(". Edited by E. Kautzsch. Translated by A. E. Cowley. 2nd ed. Oxford: Clarendon, 1910")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HALOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Hebrew and Aramaic Lexicon of the Old Testament")]), _vm._v(". L. Koehler, W. Baumgartner, and J. J. Stamm. Translated and edited under the supervision of M. E. J. Richardson. 4 vols. Leiden: Brill, 1994–1999")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HAR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Hebrew Annual Review")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("HBT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Horizons in Biblical Theology")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HSM")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Harvard Semitic Monographs")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Hervormde Teologiese Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("HUBP")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Hebrew University Bible Project. C. Rabin. "), _c('em', [_vm._v("The Book of Jeremiah")]), _vm._v(". Jerusalem: Magnes, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("IBHS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("An Introduction to Biblical Hebrew Syntax")]), _vm._v(". B. K. Waltke and M. O’Connor. Winona Lake, IN: Eisenbrauns, 1990")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ICC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Critical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Int")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Interpretation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ITC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Theological Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JANES")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Ancient Near Eastern Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JATS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Adventist Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JBL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Biblical Literature")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of the Evangelical Theological Society")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joüon")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Joüon, P. "), _c('em', [_vm._v("A Grammar of Biblical Hebrew")]), _vm._v(". Translated and revised by T. Muraoka. 2 vols. Rome: Pontifical Biblical Institute, 1991")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JNSL")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Northwest Semitic Languages")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSJSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to the Journal for the Study of Judaism")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSNTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the New Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JSOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal for the Study of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JSOTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for the Study of the Old Testament Supplement Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("JTISup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Journal for Theological Interpretation, Supplements")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("JTS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Journal of Theological Studies")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LHBOTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Library of Hebrew Bible/Old Testament Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LXX")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Septuaginta: Id est Vetus Testamentum graece iuxta LXX interpretes")]), _vm._v(". Edited by A. Rahlfs and R. Hanhart. Rev. ed. Stuttgart: Deutsche Bibelgesellschaft, 2006")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MG")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Miqraot Gedolot (the “Rabbinic Bible”)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Masoretic Text")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT"), _c('sup', [_vm._v("A")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Aleppo Codex")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MT"), _c('sup', [_vm._v("L")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Leningrad Codex")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NETS")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A New English Translation of the Septuagint")]), _vm._v(". Edited by A. Pietersma and B. G. Wright. New York: Oxford University Press, 2007")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NICOT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The New International Commentary on the Old Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NJPS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tanakh: The Holy Scriptures: The New JPS Translation according to the Traditional Hebrew Tex")]), _vm._v("t")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("NPNF")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Select Library of the Nicene and Post-Nicene Fathers of the Christian Church")]), _vm._v(". Repr., Grand Rapids: Eerdmans, 1988")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OBO")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Orbis Biblicus et Orientalis")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Latin text as reported in "), _c('em', [_vm._v("BHS")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OTE")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Old Testament Essays")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("The Old Testament Library")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTM")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Old Testament Message")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("OTS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Oudtestamentische Studiën")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PG")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Graeca [= "), _c('em', [_vm._v("Patrologiae Cursus Completus: Series Graeca")]), _vm._v("]. Edited by J.-P. Migne. 162 vols. Paris, 1857–1886")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Patrologia Latina [= "), _c('em', [_vm._v("Patrologiae Cursus Completus: Series Latina")]), _vm._v("]. Edited by J.-P. Migne. 217 vols. Paris, 1844–1864")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("RevExp")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Review and Expositor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLDS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBLStBL")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Society of Biblical Literature Studies in Biblical Literature")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Theology")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SCS")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Septuagint and Cognate Studies")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("SJOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Scandinavian Journal of the Old Testament")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SSN")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studia Semitica Neerlandica")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("StBibLit")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Biblical Literature (Lang)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("STDJ")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies on the Texts of the Desert of Judah")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Sym")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Symmachus’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(" (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TDOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Dictionary of the Old Testament")]), _vm._v(". Volumes 1–8 edited by G. J. Botterweck and H. Ringgren. Volumes 9–15 and volume 17 edited by G. J. Botterweck, Helmer Ringgren, and Heinz-Josef Fabry. Volume 16 edited by Holger Gzella. Translated by J. T. Willis et al. 17 vols. Grand Rapids: Eerdmans, 1974–2021")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Tg")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Latter Prophets According to Targum Jonathan")]), _vm._v(". A. Sperber. The Bible in Aramaic 3. Leiden: Brill, 1962")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theod")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Theodotion’s Greek translation, as documented in F. Field, "), _c('em', [_vm._v("Origenis Hexaplorum quae supersunt")]), _vm._v(" (Oxford: Clarendon, 1867)")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TLOT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Theological Lexicon of the Old Testament")]), _vm._v(". Edited by E. Jenni with assistance from C. Westermann. Translated by Mark E. Biddle. 3 vols. Peabody, MA: Hendrickson, 1997")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TTH")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("A Treatise on the Use of the Tenses in Hebrew and Some Other Syntactical Questions")]), _vm._v(". S. R. Driver. 3rd ed. Oxford: Oxford University Press, 1892")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("TynB")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Tyndale Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Vg")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Biblia sacra iuxta vulgatam versionem")]), _vm._v(". Edited by R. Weber. 3rd ed. Stuttgart: Deutsche Bibelanstalt, 1983")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("VT")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Vetus Testamentum")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("VTSup")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Supplements to Vetus Testamentum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WBC")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Word Biblical Commentary")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("WMANT")])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Wissenschaftliche Monographien zum Alten und Neuen Testament")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("WW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Word and World")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZABR")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für altorientalische und biblische Rechtsgeschichte")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("ZAW")])])]), _vm._v(" "), _c('td', {
    staticClass: "col80"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Zeitschrift für die alttestamentliche Wissenschaft")])])])])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-3"
    }
  }, [_vm._v("Select Bibliography")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Abravanel, I. "), _c('em', [_vm._v("Commentary on the Latter Prophets")]), _vm._v(". ["), _c('em', [_vm._v("pyrwš ‘al nby’ym ’")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("rwnym")]), _vm._v(".] Jerusalem: Torah vaDa‘at, [? 1955].")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Achtemeier, E. R. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". Knox Preaching Guides. Atlanta: John Knox, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Albertz, R. "), _c('em', [_vm._v("Israel in Exile: The History and Literature of the Sixth Century B. C. E.")]), _vm._v(" SBLStBL 3. Atlanta: Society of Biblical Literature, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Allen, L. C. "), _c('em', [_vm._v("Jeremiah: A Commentary")]), _vm._v(". OTL. Louisville: Westminster John Knox, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Avioz, M. "), _c('em', [_vm._v("“I Sat Alone”: Jeremiah among the Prophets.")]), _vm._v(" Piscataway, NJ: Gorgias, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Baillet, M. “Jérémie.” Pages 62–69 in "), _c('em', [_vm._v("Les “petites grottes” de Qumran")]), _vm._v(". Edited by M. Baillet, J. T. Milik, and R. De Vaux. Discoveries in the Judaean Desert 3. Oxford: Clarendon, 1962.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Barstad, H. M., and R. G. Kratz, eds. "), _c('em', [_vm._v("Prophecy in the Book of Jeremiah.")]), _vm._v(" BZAW 388. Berlin: de Gruyter, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bauer, A. "), _c('em', [_vm._v("Gender in the Book of Jeremiah: A Feminist-Literary Reading")]), _vm._v(". StBibLit 5. New York: Lang, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Berridge, J. M. "), _c('em', [_vm._v("Prophet, People, and the Word of Yahweh: An Examination of Form and Content in the Proclamation of the Prophet Jeremiah.")]), _vm._v(" Basel Studies of Theology 4. Zurich: EVZ, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Berrigan, D. "), _c('em', [_vm._v("Jeremiah: The World, the Wound of God")]), _vm._v(". Minneapolis: Fortress, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Blayney, B. "), _c('em', [_vm._v("Jeremiah and Lamentations")]), _vm._v(". 2nd ed. Edinburgh: Oliphant, 1810.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Boadt, L. "), _c('em', [_vm._v("Jeremiah 1–25")]), _vm._v(". OTM 9. Wilmington, DE: Glazier, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah 26–52, Habakkuk, Zephaniah, Nahum.")]), _vm._v(" OTM 10. Wilmington, DE: Glazier, 1982.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bogaert, P.-M. "), _c('em', [_vm._v("Le livre de Jérémie: Le prophète et son milieu, les oracles et leur transmission.")]), _vm._v(" 2nd ed. BETL 54. Leuven: Peeters, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bright, J. "), _c('em', [_vm._v("Jeremiah: Introduction, Translation, and Notes")]), _vm._v(". AB 21. Garden City, NY: Doubleday, 1965.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Brown, M. L., and P. W. Ferris. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", "), _c('em', [_vm._v("Lamentations")]), _vm._v(". The Expositor’s Bible Commentary. Grand Rapids: Zondervan, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Brueggemann, W. "), _c('em', [_vm._v("Jeremiah 1–25")]), _vm._v(". ITC. Grand Rapids: Eerdmans, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah 26–52")]), _vm._v(". ITC. Grand Rapids: Eerdmans, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Like Fire in the Bones: Listening for the Prophetic Word in Jeremiah.")]), _vm._v(" Minneapolis: Fortress, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Theology of the Book of Jeremiah.")]), _vm._v(" Old Testament Theology. Cambridge: Cambridge University Press, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Bugenhagen, J. "), _c('em', [_vm._v("In Ieremiam Prophetam Commentarium")]), _vm._v(". Wittenberg: Seitz, 1546.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Calvin, J. "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(" "), _c('em', [_vm._v("and Lamentations")]), _vm._v(". Translated by J. Owen. 5 vols. Repr., Grand Rapids: Christian Classics Ethereal Library.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Carroll, R. P. "), _c('em', [_vm._v("From Chaos to Covenant: Uses of Prophecy in the Book of Jeremiah.")]), _vm._v(" London: SCM, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah: A Commentary.")]), _vm._v(" OTL. London: SCM, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah.")]), _vm._v(" Old Testament Guides. Sheffield: JSOT, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Clements, R. E. "), _c('em', [_vm._v("Jeremiah.")]), _vm._v(" Interpretation: A Bible Commentary for Teaching and Preaching. Atlanta: John Knox, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Cloete, W. T. W. "), _c('em', [_vm._v("Versification and Syntax in Jeremiah 2–25: Syntactical Constraints in Hebrew Colometry.")]), _vm._v(" SBLDS 117. Atlanta: Scholars, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Coulibaly, I. “Jeremiah.” Pages 879–950 in "), _c('em', [_vm._v("Africa Bible Commentary")]), _vm._v(". Edited by T. Adeyemo. Nairobi: Word Alive, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Craigie, P. C., P. H. Kelley, and J. F. Drinkard. "), _c('em', [_vm._v("Jeremiah 1–25")]), _vm._v(". WBC 26. Dallas: Word, 1991.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Crouch, C. L. "), _c('em', [_vm._v("An Introduction to the Study of Jeremiah.")]), _vm._v(" T&T Clark Approaches to Biblical Studies. London: T&T Clark, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Cunliffe-Jones, H. "), _c('em', [_vm._v("Jeremiah: God in History")]), _vm._v(". 2nd ed. Torch Bible Commentaries. London: SCM, 1966.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Curtis, A. H. W., and T. Römer, eds. "), _c('em', [_vm._v("The Book of Jeremiah and Its Reception")]), _vm._v(". BETL 128. Leuven: Peeters, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Davidson, R. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". 2 vols. The Daily Study Bible. Edinburgh: Saint Andrew, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Davidson, S. V. "), _c('em', [_vm._v("Empire and Exile: Postcolonial Readings of the Book of Jeremiah.")]), _vm._v(" LHBOTS 542. London: T&T Clark, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Dearman, J. A. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(" "), _c('em', [_vm._v("and Lamentations")]), _vm._v(". The NIV Application Commentary. Grand Rapids: Zondervan, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Dempsey, C. J. "), _c('em', [_vm._v("Jeremiah: Preacher of Grace, Poet of Truth")]), _vm._v(". Interfaces. Collegeville: Liturgical, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Denis the Carthusian. "), _c('em', [_vm._v("Enarratio in Jeremiam")]), _vm._v(". Pages 5–312 in "), _c('em', [_vm._v("Opera Omnia")]), _vm._v(". Vol. 9. Montreuil: Typis Cartusiae S. M. de Pratis, 1900.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Diamond, A. R. P. "), _c('em', [_vm._v("The Confessions of Jeremiah in Context: Scenes of Prophetic Drama.")]), _vm._v(" JSOTSup 45. Sheffield: Sheffield Academic, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Jeremiah.” Pages 543–622 in "), _c('em', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(". Edited by J. D. G. Dunn and J. W. Rogerson. Grand Rapids: Eerdmans, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Diamond, A. R. P., K. M. O’Connor, and L. Stulman, eds. "), _c('em', [_vm._v("Troubling Jeremiah.")]), _vm._v(" JSOTSup 260. Sheffield: Sheffield Academic, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Diamond, A. R. P., and L. Stulman, eds. "), _c('em', [_vm._v("Jeremiah (Dis)placed")]), _vm._v(". LHBOTS 529. London: T&T Clark, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Duhm, B. "), _c('em', [_vm._v("Das Buch Jeremia.")]), _vm._v(" Kurzer Hand-Commentar zum Alten Testament 11. Tübingen: Mohr Siebeck, 1901.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ellison, H. L. “The Prophecy of Jeremiah.” "), _c('em', [_vm._v("EvQ")]), _vm._v(" 31–40 (1959–68).")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Eusebius Hieronymus. "), _c('em', [_vm._v("Commentariorum in Jeremiam Prophetam Libri Sex.")]), _vm._v(" PL 24:679–900.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Finsterbusch, K., and A. Lange, eds. "), _c('em', [_vm._v("Texts and Contexts in Jeremiah")]), _vm._v(". Leuven: Peeters, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Fischer, G. "), _c('em', [_vm._v("Jeremia")]), _vm._v(". 2 vols. Herders Theologischer Kommentar zum Alten Testament. Freiburg: Herder, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Fretheim, T. E. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". Smith and Helwys Bible Commentary. Macon, GA: Smith and Helwys, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Glanz, O. "), _c('em', [_vm._v("Understanding Participant-Reference Shifts in the Book of Jeremiah: A Study of Exegetical Method and Its Consequences for the Interpretation of Referential Incoherence.")]), _vm._v(" SSN 60. Leiden: Brill, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Goldingay, J., ed. "), _c('em', [_vm._v("Uprooting and Planting: Essays on Jeremiah for Leslie")]), _vm._v(" "), _c('em', [_vm._v("Allen")]), _vm._v(". LHBOTS 459. London: T&T Clark, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Green, B. "), _c('em', [_vm._v("Jeremiah and God’s Plans of Well-Being")]), _vm._v(". Studies on Personalities of the Old Testament. Columbia, SC: University of South Carolina, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Gross, W., ed. "), _c('em', [_vm._v("Jeremia und die “deuteronomistische Bewegung.”")]), _vm._v(" BBB 98. Weinheim: Beltz Athenäum, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Harrelson, W. "), _c('em', [_vm._v("Jeremiah: Prophet to the Nations")]), _vm._v(". Philadelphia: Judson, 1959.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Harrison, R. K. "), _c('em', [_vm._v("Jeremiah and Lamentations: An Introduction and Commentary")]), _vm._v(". Tyndale Old Testament Commentaries. London: Tyndale, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Henderson, J. M. "), _c('em', [_vm._v("Jeremiah under the Shadow of Duhm: A Critique of the Use of Poetic Form as a Criterion of Authenticity.")]), _vm._v(" T&T Clark Biblical Studies. London: T&T Clark, 2019.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Herrmann, S. "), _c('em', [_vm._v("Jeremia")]), _vm._v(". 2 fascicles. Biblischer Kommentar: Altes Testament. Neukirchen: Neukirchener, 1986–1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hill, J. "), _c('em', [_vm._v("Friend or Foe? The Figure of Babylon in the Book of Jeremiah MT.")]), _vm._v(" BibInt 40. Leiden: Brill, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Holladay, W. L. "), _c('em', [_vm._v("A Commentary on the Book of the Prophet Jeremiah.")]), _vm._v(" 2 vols. Hermeneia. Philadelphia: Fortress, 1986; Minneapolis: Fortress, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah: Spokesman out of Time")]), _vm._v(". Philadelphia: United Church, 1974.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Text Criticism and Beyond: The Case of Jeremiah.” "), _c('em', [_vm._v("Textus")]), _vm._v(" 23 (2007): 173–210.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Holt, E. K., and C. J. Sharp, eds. "), _c('em', [_vm._v("Jeremiah Invented: Constructions and Deconstructions of Jeremiah.")]), _vm._v(" LHBOTS 595. London: T&T Clark, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Hugh of St. Cher. “Liber Jeremiae.” Pages 175–282 in "), _c('em', [_vm._v("Praedicatorum Tomus Quartus.")]), _vm._v(" Venice: Pezanna, 1703.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Jerome. "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(". Translated by M. Graves. Ancient Christian Texts. Downers Grove, IL: InterVarsity, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Job, J. B. "), _c('em', [_vm._v("Jeremiah’s Kings: A Study of the Monarchy in Jeremiah")]), _vm._v(". Society for Old Testament Study Monographs. Aldershot: Ashgate, 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Jones, D. R. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". The New Century Bible Commentary. Grand Rapids: Eerdmans, 1992.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kalmanovsky, A. "), _c('em', [_vm._v("Terror All Around: The Rhetoric of Horror in the Book of Jeremiah.")]), _vm._v(" LHBOTS 390. London: T&T Clark, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Keown, G. L., P. J. Scalise, and T. G. Smothers. "), _c('em', [_vm._v("Jeremiah 26–52")]), _vm._v(". WBC 27. Dallas: Word, 1995.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kessler, M., ed. "), _c('em', [_vm._v("Reading the Book of Jeremiah: A Search for Coherence")]), _vm._v(". Winona Lake, IN: Eisenbrauns, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Kidner, D. "), _c('em', [_vm._v("The Message of Jeremiah")]), _vm._v(". The Bible Speaks Today. Leicester, UK: InterVarsity, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("King, P. J. "), _c('em', [_vm._v("Jeremiah: An Archaeological Companion")]), _vm._v(". Louisville: Westminster John Knox, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Lalleman-de Winkel, H. "), _c('em', [_vm._v("Jeremiah and Lamentations")]), _vm._v(". Tyndale Old Testament Commentaries. Nottingham: InterVarsity Press, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah in Prophetic Tradition")]), _vm._v(". Contributions to Biblical Exegesis and Theology 26. Leeuven: Peeters, 2000.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Leuchter, M. “Jeremiah.” Pages 171–89 in "), _c('em', [_vm._v("The Oxford Handbook of the Prophets")]), _vm._v(". Edited by C. J. Sharp. Oxford: Oxford University Press, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Polemics of Exile in Jeremiah 26–45.")]), _vm._v(" Cambridge: Cambridge University Press, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Lipschits, O. "), _c('em', [_vm._v("The Fall and Rise of Jerusalem: Judah under Babylonian Rule.")]), _vm._v(" Winona Lake, IN: Eisenbrauns, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Longman, T. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". New International Biblical Commentary. Peabody, MA: Hendrickson, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Lundbom, J. R. "), _c('em', [_vm._v("Jeremiah 1–20: A New Translation with Introduction and Commentary.")]), _vm._v(" AB 21A. New York: Doubleday, 1999.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah 21–36: A New Translation with Introduction and Commentary.")]), _vm._v(" AB 21B. New York: Doubleday, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah 37–52: A New Translation with Introduction and Commentary.")]), _vm._v(" AB 21C. New York: Doubleday, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah: A Study in Ancient Hebrew Rhetoric.")]), _vm._v(" 2nd ed. Winona Lake, IN: Eisenbrauns, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah among the Prophets")]), _vm._v(". Cambridge: James Clarke, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah Closer Up: The Prophet and the Book")]), _vm._v(". Hebrew Bible Monographs 31. Sheffield: Sheffield Phoenix, 2010.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah: Prophet Like Moses")]), _vm._v(". Eugene: Cascade, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Lundbom, J. R., C. A. Evans, and B. A. Anderson, eds. "), _c('em', [_vm._v("The Book of Jeremiah: Composition, Reception, and Interpretation")]), _vm._v(". VTSup 178. Leiden: Brill, 2018.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Maier, C. M. "), _c('em', [_vm._v("Jeremia als Lehrer der Tora: Soziale Gebote des Deuteronomiums in Fortschreibungen des Jeremiabuches.")]), _vm._v(" FRLANT 196. Göttingen: Vandenhoeck & Ruprecht, 2002.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Maier, C. M., and C. J. Sharp, eds. "), _c('em', [_vm._v("Prophecy and Power: Jeremiah in Feminist and Postcolonial Perspective.")]), _vm._v(" LHBOTS 577. London: T&T Clark, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Martens, E. A. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". Believers Church Bible Commentary. Scottdale, PA: Herald, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Mayer, J. "), _c('em', [_vm._v("A Commentary upon All the Prophets both Great and Small.")]), _vm._v(" London: Millar and Cotes, 1652.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("McConville, J. G. "), _c('em', [_vm._v("Judgment and Promise: Interpretation of the Book of Jeremiah.")]), _vm._v(" Leicester: Apollos, 1993.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("McKane, W. "), _c('em', [_vm._v("A Critical and Exegetical Commentary on Jeremiah")]), _vm._v(". 2 vols. ICC. Repr., London: T&T Clark, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Mein, A., E. K. Holt, and H. C. P. Kim, eds. "), _c('em', [_vm._v("Concerning the Nations: Essays on the Oracles against the Nations in Isaiah, Jeremiah and Ezekiel.")]), _vm._v(" LHBOTS 612. London: T&T Clark, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Michaelis, J. D. "), _c('em', [_vm._v("Observationes philologicae et criticae in Jeremiae Vaticinia et Threnos.")]), _vm._v(" Göttingen: Vandenhoeck & Ruprecht, 1793.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Miller, P. D. “Jeremiah.” Pages 553–926 in "), _c('em', [_vm._v("The New Interpreter’s Bible")]), _vm._v(". Edited by L. E. Keck. Vol. 6. Nashville: Abingdon, 2001.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Mills, M. E. "), _c('em', [_vm._v("Jeremiah: An Introduction and Study Guide; Prophecy in a Time of Crisis.")]), _vm._v(" London: T&T Clark, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Mowinckel, S. "), _c('em', [_vm._v("Zur Komposition des Buches Jeremia")]), _vm._v(". Kristiania: Dybward, 1914.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Najman, H., and K. Schmid, eds. "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(". JSJSup 173. Leiden: Brill, 2016.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Nicholson, E. W. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(" "), _c('em', [_vm._v("1–25")]), _vm._v(". The Cambridge Bible Commentary: New English Bible. Cambridge: Cambridge University Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(" "), _c('em', [_vm._v("26–52")]), _vm._v(". The Cambridge Bible Commentary: New English Bible. Cambridge: Cambridge University Press, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Preaching to the Exiles")]), _vm._v(". Oxford: Blackwell, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Nicolai de Lira. "), _c('em', [_vm._v("Secunda pars tractas super toto corpore biblie.")]), _vm._v(" Strasbourg: Grüninger, 1492.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("O’Connor, K. M. "), _c('em', [_vm._v("The Confessions of Jeremiah: Their Interpretation and Role in Chapters 1–25.")]), _vm._v(" SBLDS 94. Atlanta: Scholars, 1988.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “Jeremiah.” Pages 487–528 in "), _c('em', [_vm._v("The Oxford Bible Commentary")]), _vm._v(". Edited by J. Barton and J. Muddiman. Oxford: Oxford University Press, 2007.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Jeremiah: Pain and Promise.")]), _vm._v(" Minneapolis: Fortress, 2011.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Oecolampadius, J. "), _c('em', [_vm._v("In Hieremiam prophetam")]), _vm._v(". Strasbourg: Apiarius, 1533.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Origen of Alexandria. "), _c('em', [_vm._v("Homilies on Jeremiah and 1 Kings 28")]), _vm._v(". Translated by John Clark Smith. The Fathers of the Church 97. Washington: Catholic University of America, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Overholt, T. W. "), _c('em', [_vm._v("The Threat of Falsehood: A Study in the Theology of the Book of Jeremiah.")]), _vm._v(" SBT 2/16. London: SCM, 1970.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Pappus, J. "), _c('em', [_vm._v("In Omnes Prophetas")]), _vm._v(". Frankfurt: Spiessius, 1593.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Perdue, L. G., and B. W Kovacs, eds. "), _c('em', [_vm._v("A Prophet to the Nations: Essays in Jeremiah Studies")]), _vm._v(". Winona Lake, IN: Eisenbrauns, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Pixley, J. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". Chalice Commentaries for Today. St. Louis, MO: Chalice, 2004.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Plant, R. J. R. "), _c('em', [_vm._v("Good Figs, Bad Figs: Judicial Differentiation in the Book of Jeremiah.")]), _vm._v(" LHBOTS 483. London: T&T Clark, 2008.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Pohlmann, K.-F. "), _c('em', [_vm._v("Die Ferne Gottes: Studien zum Jeremiabuch.")]), _vm._v(" BZAW 179. Berlin: de Gruyter, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Studien zum Jeremiabuch: Ein Beitrag zur Frage nach der Entstehung des Jeremiabuches.")]), _vm._v(" FRLANT 118. Göttingen: Vandenhoeck & Ruprecht, 1978.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Polk, T. "), _c('em', [_vm._v("The Prophetic Persona: Jeremiah and the Language of the Self.")]), _vm._v(" JSOTSup 32. Sheffield: JSOT, 1984.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Reventlow, H. G. "), _c('em', [_vm._v("Liturgie und prophetisches Ich bei Jeremia.")]), _vm._v(" Gütersloh: Mohn, 1963.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rosenberg, A. J. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". 2 vols. New York: Judaica, 1985.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Rudolph, W. "), _c('em', [_vm._v("Jeremia.")]), _vm._v(" 3rd ed. Handbuch zum Alten Testament 12. Tübingen: Mohr Siebeck, 1968.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schmidt, W. H. "), _c('em', [_vm._v("Das Buch Jeremia")]), _vm._v(". 2 vols. Das Alte Testament Deutsch. Göttingen: Vandenhoeck & Ruprecht, 2008–2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Schroeder, J. A. "), _c('em', [_vm._v("The Book of Jeremiah")]), _vm._v(". The Bible in Medieval Tradition. Grand Rapids: Eerdmans, 2017.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Seitz, C. R. "), _c('em', [_vm._v("Theology in Conflict: Reactions to the Exile in the Book of Jeremiah.")]), _vm._v(" BZAW 176. Berlin: de Gruyter, 1989.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Sharp, C. J. “Jeremiah.” Pages 223–35 in "), _c('em', [_vm._v("Theological Bible Commentary")]), _vm._v(". Edited by D. L. Petersen and G. R. O’Day. Louisville: Westminster John Knox, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Prophecy and Ideology in Jeremiah: Struggles for Authority in the Deutero-Jeremianic Prose.")]), _vm._v(" Old Testament Studies. London: T&T Clark, 2003.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Shead, A. G. "), _c('em', [_vm._v("A Mouth Full of Fire")]), _vm._v(": "), _c('em', [_vm._v("The Word of God in the Words of Jeremiah")]), _vm._v(". New Studies in Biblical Theology 9. Nottingham: Apollos, 2013.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Skinner, J. "), _c('em', [_vm._v("Prophecy and Religion: Studies in the Life of Jeremiah")]), _vm._v(". Cambridge: Cambridge University Press, 1922.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Smith, M. S. "), _c('em', [_vm._v("The Laments of Jeremiah and Their Contexts")]), _vm._v(". Society of Biblical Literature Monograph Series 42. Atlanta: Scholars, 1990.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stephen, D. "), _c('em', [_vm._v("The Prophet of Hope")]), _vm._v(". Cambridge: Cambridge University Press, 1923.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stipp, H.-J. "), _c('em', [_vm._v("Das masoretische und alexandrinische Sondergut des Jeremiabuches.")]), _vm._v(" OBO 136. Göttingen: Vandenhoeck & Ruprecht, 1994.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Studien zum Jeremiabuch: Text und Redaktion")]), _vm._v(". FAT 96. Tübingen: Mohr Siebeck, 2015.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Stulman, L. "), _c('em', [_vm._v("Jeremiah")]), _vm._v(". Nashville: Abingdon, 2005.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Order amid Chaos: Jeremiah as Symbolic Tapestry")]), _vm._v(". The Biblical Seminar 57. Sheffield: Sheffield Academic, 1998.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("The Prose Sermons of the Book of Jeremiah: A Redescription of the Correspondences with Deuteronomistic Literature in the Light of Recent Text-Critical Research.")]), _vm._v(" SBLDS 83. Atlanta: Scholars, 1986.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Theodoret of Cyrus. "), _c('em', [_vm._v("Ermeneia tēs prophēteias tou Ieremiou.")]), _vm._v(" PG 81:495–806.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Thiel, W. "), _c('em', [_vm._v("Die deuteronomistische Redaktion von Jeremia 1–25.")]), _vm._v(" WMANT 41. Neukirchen: Neukirchener, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. "), _c('em', [_vm._v("Die deuteronomistische Redaktion von Jeremia 26–45.")]), _vm._v(" WMANT 52. Neukirchen: Neukirchener, 1981.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Thomas Aquinas. "), _c('em', [_vm._v("In Jeremiam prophetam expositio")]), _vm._v(". Corpus thomisticum. Parma: Fiaccadori, 1863.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Thompson, J. A. "), _c('em', [_vm._v("The Book of Jeremiah")]), _vm._v(". NICOT. Grand Rapids: Eerdmans, 1980.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Tov, E. “Jeremiah.” Pages 145–207 in "), _c('em', [_vm._v("Qumran Cave 4: X: The Prophets")]), _vm._v(". Edited by E. Tov. Discoveries in the Judaean Desert 15. Oxford: Clarendon, 1997.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("———. “The Jeremiah Scrolls from Qumran.” "), _c('em', [_vm._v("Revue de Qumran")]), _vm._v(" 14 (1989): 189–206.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Trapp, J. "), _c('em', [_vm._v("A Commentary or Exposition upon These Following Books of Holy Scripture: Proverbs of Solomon, Ecclesiastes, the Song of Songs, Isaiah, Jeremiah, Lamentations, Ezekiel & Daniel.")]), _vm._v(" Kidderminster: Simmons, 1660.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Tyler, J. J. "), _c('em', [_vm._v("Jeremiah, Lamentations")]), _vm._v(". Reformation Commentary. Downers Grove, IL: InterVarsity, 2018.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Unterman, J. "), _c('em', [_vm._v("From Repentance to Redemption: Jeremiah’s Thought in Transition")]), _vm._v(". JSOTSup 54. Sheffield: Sheffield Academic, 1987.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Volz, P. "), _c('em', [_vm._v("Der Prophet Jeremia.")]), _vm._v(" Kommentar zum Alten Testament 10. 2nd ed. Leipzig: Deicher, 1928.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Walser, G. A. "), _c('em', [_vm._v("Jeremiah: A Commentary Based on Ieremias in Codex Vaticanus")]), _vm._v(". Septuagint Commentary Series. Leiden: Brill, 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Weippert, H. "), _c('em', [_vm._v("Die Prosareden des Jeremiabuches.")]), _vm._v(" BZAW 132. Berlin: de Gruyter, 1973.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Weiser, A. "), _c('em', [_vm._v("Das Buch des Propheten Jeremia")]), _vm._v(". 2 vols. Das Alte Testament Deutsch. Göttingen: Vandenhoeck & Ruprecht, 1952.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Wenthe, D. O. "), _c('em', [_vm._v("Jeremiah, Lamentations")]), _vm._v(". Ancient Christian Commentary on Scripture: Old Testament 12. Downers Grove, IL: InterVarsity, 2009.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Wright, C. J. H. "), _c('em', [_vm._v("The Message of Jeremiah")]), _vm._v(". The Bible Speaks Today. Nottingham: InterVarsity Press, 2014.")]), _vm._v(" "), _c('p', {
    staticClass: "bib-item"
  }, [_vm._v("Ziegler, J., ed. "), _c('em', [_vm._v("Ieremias, Baruch, Threni, Epistula Ieremiae.")]), _vm._v(" 2nd ed. Septuaginta: Vetus Testamentum Graecum 15. Göttingen: Vandenhoeck & Ruprecht, 1976.")])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pg"
  }, [_c('p', {
    staticClass: "image0",
    attrs: {
      "id": "fm-4"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/xxviii.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-caption"
  }, [_vm._v("Judah in Jeremiah’s Day")])]), _vm._v(" "), _c('div', {
    staticClass: "pg"
  }, [_c('p', {
    staticClass: "image0"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/xxix.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "image-caption"
  }, [_vm._v("Empires of the 6th Century BC")])])])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-1"
    }
  }, [_vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Jeremiah scroll is a compilation of messages from Yahweh, stories about Jeremiah, and exchanges between Jeremiah and Yahweh. I use the word “scroll” since it’s not a “book” in most senses of that word. The majority of the messages are in poetry, which makes the Jeremiah scroll resemble Isaiah, though many are in prose, which makes it resemble Ezekiel. The prominence of stories and exchanges as well as messages makes it unique and contributes to its being the longest of the prophetic scrolls. Further, whereas the Isaiah and Ezekiel scrolls incorporate many messages of an overtly hopeful kind, Jeremiah is dominated by threat and warning, which makes it more like shorter prophetic scrolls such as Hosea and Amos.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-1"
    }
  }, [_vm._v("I. BACKGROUND")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The introduction to the Jeremiah scroll (1:1–3) provides key information concerning its background:")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("The words of Jeremiah ben Hilkiah, one of the priests who were in Anathoth in the territory of Benjamin, to whom Yahweh’s message came in the time of Josiah ben Amon King of Judah, in the thirteenth year of his reign, and came in the time of Jehoiakim ben Josiah King of Judah, until the ending of the eleventh year of Zedekiah ben Josiah King of Judah, until the exile of Jerusalem in the fifth month.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-1"
    }
  }, [_vm._v("A. JOSIAH, JEHOIAKIM, ZEDEKIAH, AND THE FALL OF JERUSALEM")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Jeremiah was born during the reign of Manasseh in Judah (687–642 BC)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2303",
      "id": "footnote-2303-backlink"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" For a century, Judah and its neighbors had been the victims of Assyria’s desire to control the Levant, the area bordering on the Mediterranean. Judah was an Assyrian tribute state and effectively part of the Assyrian Empire even though it still had its own monarchy. One consequence was that Manasseh allowed worship in Jerusalem to take account of Assyrian understandings of the gods and worship practices. In addition, traditional (“Canaanite”) understandings of the gods and related aspects of spirituality continued to be influential in Jerusalem and in people’s everyday lives. Manasseh’s son Amon succeeded him and reigned for two years (642–640) before being assassinated, after which his son Josiah, still a boy, succeeded him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Assyrian power was declining, and Josiah’s mentors and Josiah himself were able to initiate changes in Judah that amounted to both religious reformation and assertion of political independence. Second Kings 22–23 relates how a “Torah scroll” came to light in 622 in the course of restoration work in the Jerusalem temple, and this discovery stimulated further reforms. Overlaps between these reforms and Deuteronomy suggest that the scroll was some form of what we know as Deuteronomy. The discovery came just after Yahweh’s commission of Jeremiah in 626, which was also about the time when Ashurbanipal, the last great king of Assyria, died, and when Nabopolassar, the first great Neo-Babylonian king, asserted control of Babylon and initiated the process whereby Babylon would take over the Assyrian Empire."), _c('a', {
    attrs: {
      "href": "#/#footnote-2302",
      "id": "footnote-2302-backlink"
    }
  }, [_c('sup', [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As Assyria declined, Babylon and Media grew in power, and 609 saw a key battle between these forces. The Egyptian king decided to join in, perceiving that a Babylonian victory would be a threat to him. Josiah thought that Assyria’s losing was desirable, so it seemed in Judah’s interest to back Babylon—ironically, in light of later events. Josiah therefore tried to stop the Egyptian army’s advance but failed and lost his life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His son Jehoahaz thus succeeded him in 609 but was swiftly deposed by the Egyptians (he is unmentioned in Jer 1:1–3) and replaced by his brother Jehoiakim, who encouraged the dismantling of Josiah’s reformation. A key event during his reign was the Battle of Carchemish in 605, when Babylonian and Median forces again defeated the armies of Assyria and Egypt. This event had decisive implications for the future of Judah. Judah would thenceforth come under the domination of the Babylonians, who were from that time the people who wanted to control the Levant. The next year saw Nebuchadrezzar"), _c('a', {
    attrs: {
      "href": "#/#footnote-2301",
      "id": "footnote-2301-backlink"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" campaigning there, and Jer 36 gives a dramatic account of Yahweh’s telling Jeremiah to have his messages written down that year and read to Jehoiakim, only for Jehoiakim to dismiss them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jehoiakim died in 597 and was succeeded by his son Jehoiachin. Like Jehoahaz, he was swiftly deposed, this time by the Babylonians (he is also unmentioned in Jer 1:1–3). They plundered the temple, took Jehoiachin and many leading Judahites to Babylon, and replaced him with his uncle, Zedekiah, another son of Josiah, who continued the religious policies of Jehoiakim. He reigned from 597 to 587. During this decade, there were thus two Judahite communities, both with Davidic kings, one in Babylon and one in Judah, though we have no evidence of tension between them. In 589/588, Zedekiah led Judah in asserting independence from the Babylonians, who again invaded Judah, captured and devastated Jerusalem, and took Zedekiah into exile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The political story that holds together the narrative implied by the Jeremiah scroll is thus the story of three kings, Josiah, Jehoiakim, and Zedekiah, followed by the fall of Jerusalem and the aftershocks in Mizpah, of which we will read in Jeremiah.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-2"
    }
  }, [_vm._v("B. YAHWEH’S MESSAGE CAME")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("According to its introduction, the Jeremiah scroll comprises words of Jeremiah given in this historical context. The words of Jeremiah given in this historical context also comprise the “message,” more literally the “word,” of Yahweh that came to Jeremiah."), _c('a', {
    attrs: {
      "href": "#/#footnote-2300",
      "id": "footnote-2300-backlink"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" The introduction implies that the scroll’s readers need to adopt the position of people who accept that presupposition if they are to understand the scroll."), _c('a', {
    attrs: {
      "href": "#/#footnote-2299",
      "id": "footnote-2299-backlink"
    }
  }, [_c('sup', [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("More literally, the message “happened” ("), _c('em', [_vm._v("hāyâ")]), _vm._v(") to Jeremiah. How did it do so? The introduction goes on to recount a conversation between Yahweh and Jeremiah (1:4–19). If we had been there, would we have heard Yahweh’s voice? Surely not everyone who claims to have heard God’s voice is crazy, and sometimes the Scriptures give a realistic report of God’s speaking aloud: see 1 Sam 3 and the varying accounts of Yahweh’s speaking at Sinai and of Jesus’s appearing to Saul of Tarsus. Or did the conversation happen inside Jeremiah’s head? Either way, Yahweh formulated words and spoke them to Jeremiah, and Jeremiah heard them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The conversation includes Yahweh’s declaring that he will be giving Jeremiah orders about what Jeremiah is to say. He will be dictating messages that Jeremiah will pass on. Many of the messages that we later read in the scroll presumably issued from such dictation. They came “from Yahweh’s mouth,” not from Jeremiah’s mind (23:16).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yahweh also touches Jeremiah’s mouth and says he is putting his words in Jeremiah’s mouth (1:9), which suggests a different model from dictation for the transmitting of a message. It implies that Jeremiah’s lips may utter words he has not heard or consciously formulated; he will open his mouth and will himself listen to what comes out. In a promise of which Jeremiah might be understood as the fulfillment, Yahweh says of the prophet whom he will cause to arise, “I will put my words in his mouth” (Deut 18:18). On the other hand, on some occasions when someone puts words in another person’s mouth (Exod 4:15; 2 Sam 14:19; Ezra 8:17), they seem to indicate the nature of the message, but they leave the messenger to formulate the actual words, like (one suspects) the Rabshakeh in 2 Kgs 18. Jeremiah can thus move between speaking as one directly uttering Yahweh’s words, so that Yahweh is “I,” and speaking about Yahweh as “he.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2298",
      "id": "footnote-2298-backlink"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" Modern preachers may be aware that there are insights and words that they are given and ways in which they themselves develop and formulate these insights and words. Jeremiah’s messages also combined these two aspects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah later suggests yet another model for understanding how Yahweh’s message comes to him. The difference between him and other prophets is that he has stood in Yahweh’s cabinet (23:21–22). He has been in attendance on Yahweh there along with Yahweh’s other aides (mostly supernatural ones), he has listened to debates, and he has taken part in them and in the making of decisions (cf. 1 Kgs 22:19–22). He then functions as someone sent by Yahweh with a role to play in the implementing of these decisions—by declaring Yahweh’s message to people. In what sense did he attend these meetings? When Ezekiel was transported to Jerusalem (Ezek 8–11), I imagine one would still have found him physically in Babylon, and when Paul was transported into the third heaven (2 Cor 12), one would still have found him wherever he had been before this experience began (though he interestingly expresses uncertainty about whether or not it was an out-of-body experience). One’s body and spirit are sufficiently separable for body to be in one place and spirit in another (cf. 1 Cor 5:3–4). So it would be for Jeremiah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A further element in Jeremiah’s account of his commission deserves note as background to his work. In response to Yahweh’s speaking to him, he says, in effect, “Not me, I’m only a kid.” His attempt to resist Yahweh then becomes part of Yahweh’s message in this scroll. Subsequently, he makes other comparable contributions to the message, not least as he protests about things that happen to him. A related possible ambiguity in the scroll’s introduction deserves noting in this connection as background to the idea of the scroll as “Yahweh’s message.” The expression for “the words of Jeremiah” ("), _c('em', [_vm._v("dibrê yirmәyāhû")]), _vm._v(") could be understood to mean “the acts of Jeremiah” (the equivalent expression is applied to Jehoiakim in 2 Kgs 24:5)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2297",
      "id": "footnote-2297-backlink"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" A distinctive feature of the Jeremiah scroll is the extent to which it relates things that Jeremiah does and things that happen to him. Yahweh’s message expresses itself in those actions and experiences.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-2"
    }
  }, [_vm._v("II. UNITY OF COMPOSITION")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The scroll’s introduction indicates that it came into being sometime after the fall of Jerusalem in 587 but that the scroll will refer to events going back over the preceding forty years. Was it composed in one go, or does the story of its composition go back some time? Conversely, the scroll makes no reference to events beyond the immediate aftermath of 587 (except in 52:31–34), but this fact need not imply that it came into being in those immediate years or decades. Does the story of its composition go on for some time? What can we say about its composition and unity?")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-3"
    }
  }, [_vm._v("A. THE THREE HORIZONS")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The scroll directly suggests three horizons"), _c('a', {
    attrs: {
      "href": "#/#footnote-2296",
      "id": "footnote-2296-backlink"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" for reading it; they correspond roughly to three horizons implied by the introduction.")]), _vm._v(" "), _c('p', {
    staticClass: "list-num1"
  }, [_vm._v("(1)"), _c('span', {
    staticClass: "tab"
  }, [_vm._v("There is the series of particular contexts in which Jeremiah delivered his messages, to which the scroll sometimes refers (e.g., 3:6; 21:1; 25:1).")])]), _vm._v(" "), _c('p', {
    staticClass: "list-num2"
  }, [_vm._v("(2)"), _c('span', {
    staticClass: "tab"
  }, [_vm._v("There is Jeremiah’s dictation of his entire message up to that point to Baruch in 604, to which 36:1–4, 32 refers (30:1–2 also refers to his writing, as does 51:59–64—with a date, 594).")])]), _vm._v(" "), _c('p', {
    staticClass: "list-num3"
  }, [_vm._v("(3)"), _c('span', {
    staticClass: "tab"
  }, [_vm._v("There is the production of an expanded scroll sometime after 587 (to judge from 1:1–3) and of its final form as we have it not before 562 (to judge from 52:31–34).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As the scroll reports it, then, Jeremiah uttered his words to Judahite people during the reigns of the kings it names and in the aftermath of the fall of Jerusalem, between the 620s and the 580s. When it reports that Yahweh said something to Jeremiah in the reign of one or another of the kings, it invites us to listen to its words against that context.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yet the scroll as a whole sets Jeremiah’s individual messages in the context of the history that continues until the fall of Jerusalem and its aftermath. They would have a nuanced significance once the catastrophe had actually happened, after which Jeremiah continued to embody Yahweh’s straightness and mercy as he was taken off to Egypt. The scroll itself thus came into being to speak to people some while after the events it threatens and then relates. So we read it against two horizons: the context in which Jeremiah spoke a particular message and the context from which people can look back on his message and on the events surrounding it and ask about their significance. By 562, Jeremiah would have been at least eighty, and he might have still been alive, but the last we hear of him is around 585, in Egypt. After that date, no one preserved any messages he received or told any stories about him that made it into the scroll. In effect, his work and life come to an end about 585.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In between the initial speaking and the final composition, Jer 36 suggests an intervening horizon by telling the story of Jeremiah having his message transcribed by Baruch. The original production of this 604 scroll was designed to bring home in that context the message Jeremiah had been delivering for two decades: “Yahweh is bringing catastrophe on Judah; you must turn back to him.” In that scroll and context, Jeremiah need not have been concerned to anchor individual messages in their original settings. They became part of a message designed to speak in 604. “The mind of Jeremiah is fixed on the situation in 604 BC and he calls the old prophecies to mind entirely in terms of this situation.” He is not aiming to repeat them as he might have uttered them years previously but to speak them as “the divine word to Jehoiakim and his cabinet” now."), _c('a', {
    attrs: {
      "href": "#/#footnote-2295",
      "id": "footnote-2295-backlink"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" Actually, something similar is true about the Jeremiah scroll that eventually emerged after 587. It aims to bring Yahweh’s word to Judah "), _c('em', [_vm._v("now")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Although messages in Jer 1–20 indicate that they speak to concrete settings and events in the decades beginning in 626, only once (3:6) do they mention the reign of a particular king. Jeremiah and the scroll’s compilers apparently saw no reason to preserve his messages in a way that would enable people reading the scroll to place each of them in particular contexts in the time of a particular king. Actually, Jeremiah implies that he has been saying the same thing all through, so what difference would it make? While we might like to set each message in its specific context, and while commentators have sought to do so, it is simply a matter of guesswork, and in this commentary I will not make the attempt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the other hand, if Jeremiah got Baruch to put a collection of his messages into writing in 604, I am going to guess that Jer 2–6 represents Baruch’s subsequent rewritten scroll and keep that possibility in mind as a heuristic device—an aid to imagination. But the Jeremiah scroll does not privilege any one of the three horizons, and interpreters may properly vary over which context they focus on. In connection with any section of the scroll, it is worth asking which context illuminates it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The Jeremiah scroll is one work, but its contents suggest that its composition reflects the contributions of more than one person. One indication is that it incorporates first-person speech (“Yahweh’s word came to me”) and third-person speech (“Yahweh’s word came to Jeremiah”). While first-person speech may mean that these words are Jeremiah’s own, it need not carry that implication; Ecclesiastes uses the “I” form, as ghostwriters and speech writers do. Conversely, while third-person speech may mean that the words come from someone speaking about Jeremiah, this speech form also need not carry the obvious implication; writers sometimes refer to themselves in the third person (Robert Carroll did so in his writings on Jeremiah"), _c('a', {
    attrs: {
      "href": "#/#footnote-2294",
      "id": "footnote-2294-backlink"
    }
  }, [_c('sup', [_vm._v("10")])]), _vm._v("). Rhetorically, the two forms of speech have different affects, but a move between first person and third person need not signify a change in speaker or writer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Likewise, a move between poetry and prose need not signify a change in speaker or writer."), _c('a', {
    attrs: {
      "href": "#/#footnote-2293",
      "id": "footnote-2293-backlink"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" The English author Philip Larkin published both poetry and prose. Nor can one infer from someone’s poetic style what their prose style would be or vice versa. Nor does a change of subject signify a change of author: Larkin wrote extensively on jazz in his prose, but not in his poetry. In the Jeremiah scroll, only the prose speaks of the “temple” (as the "), _c('em', [_vm._v("hêkāl")]), _vm._v(") and of the (old) “covenant”; this difference may signify nothing about whether or not the prose came from the author of the poetry. A difference between the convictions or message expressed in the prose and poetry would be more significant, but the Jeremiah scroll does not manifest divergences of this kind. It is (for instance) capable of speaking both as if the fall of Jerusalem is inevitable and as if people need to turn so that they may avert this catastrophe, but such tensions appear within the poetry and within the prose, not just between them. More significant is, again, the fact that the two forms of speech or writing have different rhetorical affects."), _c('a', {
    attrs: {
      "href": "#/#footnote-2292",
      "id": "footnote-2292-backlink"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I do assume that there is material in the scroll conveying Jeremiah’s own words and also material produced by people who wanted to write about him. One may think of these people as his disciples, though the scroll never says that he had any, and the word’s meaning is vague. One may think of them as his editors, though editors are somewhat distanced from the object of their work, and they may not agree with it. One may think of them as his secretaries or scribes, which is at least a word that comes in the scroll, and it has the advantage and disadvantage of being much used in current scholarly writing on Jeremiah;"), _c('a', {
    attrs: {
      "href": "#/#footnote-2291",
      "id": "footnote-2291-backlink"
    }
  }, [_c('sup', [_vm._v("13")])]), _vm._v(" it thus carries some freight. One may think of them as preachers aiming to interpret Jeremiah to their contemporaries."), _c('a', {
    attrs: {
      "href": "#/#footnote-2290",
      "id": "footnote-2290-backlink"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" Calvin sees them as priests and Levites."), _c('a', {
    attrs: {
      "href": "#/#footnote-2289",
      "id": "footnote-2289-backlink"
    }
  }, [_c('sup', [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I will refer to them as the scroll’s curators and storytellers. Storytellers use imagination to generate a narrative with form and drama that makes it possible for people to appreciate and respond to it; it may be more factual or more fictional. Curators conserve things so as to look after them and make them available, selecting, arranging, and thus enabling them to say what they have to say. If we wish to think more concretely about these storytellers and curators, we could imagine them as embodied in the person of Baruch. The scroll calls him Jeremiah’s scribe, though it never implies that he did the work of storyteller or curator except in compiling the 604 scroll, nor that he thus had anything like the creative role in generating the Jeremiah scroll that has sometimes been imagined for him. Scholarly study has thought of these curators and storytellers as “the Deuteronomists,” the people whose work lies behind the “Deuteronomistic History,” especially 2 Kings, though scholarly thinking about their relationship with the thought and language of Jeremiah has been fraught."), _c('a', {
    attrs: {
      "href": "#/#footnote-2288",
      "id": "footnote-2288-backlink"
    }
  }, [_c('sup', [_vm._v("16")])]), _vm._v(" Nor is it clear whether the Deuteronomists will survive the ferment over the origin of Genesis to Kings that now characterizes First Testament scholarship,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2287",
      "id": "footnote-2287-backlink"
    }
  }, [_c('sup', [_vm._v("17")])]), _vm._v(" though this difficulty does not terminate discussion of intertextual and other forms of relationship between Jeremiah and Deuteronomy or 2 Kings."), _c('a', {
    attrs: {
      "href": "#/#footnote-2286",
      "id": "footnote-2286-backlink"
    }
  }, [_c('sup', [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Scholars traditionally describe the material in the scroll that they think came from Jeremiah as “authentic,” though they sometimes put scare quotes around this word."), _c('a', {
    attrs: {
      "href": "#/#footnote-2285",
      "id": "footnote-2285-backlink"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" Material that came from a curator or storyteller is thus “inauthentic.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2284",
      "id": "footnote-2284-backlink"
    }
  }, [_c('sup', [_vm._v("20")])]), _vm._v(" The two words imply an inappropriate value judgment. Storyteller and curator may be just as authentic messengers of Yahweh and interpreters of Jeremiah as Jeremiah himself. The word “authentic” also gets us into trouble if we cannot distinguish between material that came directly from Jeremiah and material that did not—if this uncertainty leaves us uncertain of the material’s value. Further, the value judgment pushes people who want to affirm that the material is valuable into arguing that it must therefore come directly from Jeremiah. Actually, we do not know which material came from Jeremiah, but this fact does not stop the entire scroll being authentic in the sense of the product of people who worked under God to bring his message to Judah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Therefore, as I pay little attention to establishing the dates of messages that the scroll leaves undated, I also do not pay much attention to determining whether messages came from Jeremiah or a curator or where the boundary lies between fact and imagination in the stories.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If Jeremiah and Baruch produced a scroll comprising messages delivered by Jeremiah over twenty-three years, it would be surprising if Jeremiah or Baruch did not have it in their backpack in 587. In keeping with a pattern that one can infer in regard to Hosea and Amos in connection with the fall of Samaria in 722, one may imagine that the confirmation of Jeremiah’s message by the fall of Jerusalem in 587 led some people in Jerusalem or in locations such as Mizpah, Bethel, Babylon, and Egypt to think more about his message, to make sure it was preserved, to ask what implications it had for the future, and to develop it in a way that provided answers to that question. The people I am calling Jeremiah’s storytellers and curators are such people. In principle, then, one might seek to discern ways in which they have done their work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Mizpah and then in Egypt, Jeremiah himself would surely have been involved in that reflection, while the storytellers and curators will have generated the narratives within Jer 26 to 36 and the complex into which they were incorporated, as well as the longer complex comprising Jer 37–44. While most people in Jeremiah’s day might have had some basic literacy, only a tiny number would be able to write stories such as appear in the Jeremiah scroll or to compile it or read it (as Jer 36 implies)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2283",
      "id": "footnote-2283-backlink"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" One can imagine collections of Jeremiah’s sayings like the 604 scroll and of stories involving him being read “by small groups of trained scribes” or “in acts of public confession and worship”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2282",
      "id": "footnote-2282-backlink"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" in the period following the catastrophe of 587. Treating scribal and liturgical as alternatives may involve a false antithesis if Levites could be scribes and vice versa."), _c('a', {
    attrs: {
      "href": "#/#footnote-2281",
      "id": "footnote-2281-backlink"
    }
  }, [_c('sup', [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Could something like the Jeremiah scroll have been produced in a context like the aftermath of 587 and before the Persian period, or does its production imply a setting where there is a leisured class who can settle down and write books, as some argue?"), _c('a', {
    attrs: {
      "href": "#/#footnote-2280",
      "id": "footnote-2280-backlink"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" That argument works in connection with writing books about the Jeremiah scroll, but writing the scroll itself seems at least as likely to be a response to a religious and social crisis (the picture that Jer 36 gives) or to a community trauma like that of the fall of Jerusalem and the experience of exile. A prophet or a curator needs no great infrastructure in this connection, only a scroll, a pen, a dark evening, and a candle. Accumulating evidence of a significant ongoing community in Judah (outside the devastated capital) in the Babylonian period"), _c('a', {
    attrs: {
      "href": "#/#footnote-2279",
      "id": "footnote-2279-backlink"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" provides a plausible context for such reflection and work—if it did not take place in Egypt. Conversely, there is no direct evidence that Judahites in the Persian period possessed infrastructure for writing a scroll in a way that Judahites in the Babylonian period did not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One possible aim of the curators’ and storytellers’ work is thus to provide a rationale for the sad state of Judah and its people, which reflects their abandonment of Yahweh."), _c('a', {
    attrs: {
      "href": "#/#footnote-2278",
      "id": "footnote-2278-backlink"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" In this respect, the Jeremiah scroll complements the books of Kings."), _c('a', {
    attrs: {
      "href": "#/#footnote-2277",
      "id": "footnote-2277-backlink"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" As German theology flourished (in a way that may seem surprising) after the catastrophe of the First World War and again after the catastrophe of the Second World War, it would not be difficult to imagine that the calamity that came upon Jerusalem in 587 issued in creativity among Judahites in subsequent decades. The scroll itself is then “a ‘thick’ response to disaster…. It names the disaster, interprets the disaster, and portrays the prophet as a survivor of disaster.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2276",
      "id": "footnote-2276-backlink"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" It is “a kind of survival manual.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2275",
      "id": "footnote-2275-backlink"
    }
  }, [_c('sup', [_vm._v("29")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-4"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. THE COMPOSITION OF JEREMIAH AND THE COMPOSITION OF THE GOSPELS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("A process of development generated the composition of the scroll that we have. But intensive study over more than a century has generated no consensus concerning this process or the process whereby individual chapters developed. As is the case with attempts to date messages of Jeremiah in specific contexts and to distinguish between more factual and more fictional in narratives, I therefore do not attempt to adjudicate over theories concerning the process whereby different chapters in the scroll developed or to formulate more theories about it. I do not object to people studying “textual genetics rather than poetics,”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2274",
      "id": "footnote-2274-backlink"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" but I focus on the latter, on what the curators who generated the documents present to us in each chapter and on the understanding of Jeremiah that they set forward. I take their understanding as an “authentic” one. While I include footnote references to some work on the possible development of material in the scroll so that readers may follow it up, in the commentary I focus on the text we have rather than seeking to uncover the compositional process whereby it may have developed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I do have a mental picture of the general compositional process, partly imagined on the basis of the possibility that the New Testament Gospels provide a plausible model (or plausible models) for thinking about the composition of the Jeremiah scroll and about its relationship to events."), _c('a', {
    attrs: {
      "href": "#/#footnote-2273",
      "id": "footnote-2273-backlink"
    }
  }, [_c('sup', [_vm._v("31")])]), _vm._v(" Like the Jeremiah scroll, the Gospels combine messages and stories, though they make the story the framework for the messages whereas the Jeremiah scroll makes the messages the framework for the stories. Like the Jeremiah scroll, the Gospels tell a story about what God was doing and saying historically but do so in a way that brings home its significance for the people of their day. In both respects, their telling corresponds to what one can envisage God wanting and inspiring.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Oddly enough, the time span between the first and the last events that the scroll relates (626 and 562) is not so different from the time span from Jesus’s birth to the writing of the Four Gospels—or at least of the first three. A difference between Jeremiah and Jesus is that the Jeremiah scroll tells of the prophet having his message written down whereas the Gospels do not say that Jesus did so. In other respects, there are partial analogies between the processes of their composition. During Jeremiah’s working life and over succeeding decades, some people held onto his messages while also adapting them so that they spoke in new ways. In addition, they told stories about him that also spoke to their contemporaries, doing so in a way that stayed narratively within the framework of his own life and work. In principle, one can therefore ask about the difference between their version of events and of his teaching on one hand and the actual events and his actual teaching on the other, though opinions differ on the results of such investigation, as in the case of the Gospels.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Again oddly enough, we have more than one version of the Jeremiah scroll, as we do of the Jesus story—a Hebrew version preserved in the Masoretic Text and a shorter Greek version preserved in the LXX (see “The Hebrew Text,” pp. 43–46). Among the Gospels, Mark is the version nearest to actual history (while still being an interpretation of Jesus’s story). Matthew pays more attention to working out the story’s significance for its readers, who were Jews who believe in Jesus. Luke-Acts explicitly takes the story beyond Jesus’s own day. And from Matthew and Luke one may be able to work back to another collection of Jesus’s teaching that they both knew (Q). John is a version that takes a more creative and imaginative approach to narrating Jesus’s significance. Accounts of the feeding of the five thousand (Mark 6; Matt 14; Luke 9; John 6) provide an illustration. Perhaps Jeremiah and Baruch’s 604 scroll is a bit like Mark, LXX Jeremiah is a bit like Matthew, and MT Jeremiah is a bit like Luke. (It is another nice coincidence that Mark wrote before the fall of Jerusalem, Matthew and Luke after it.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This comparison with the Gospels suggests several reflections in connection with Jeremiah.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Our having multiple versions of the Jesus story establishes a richer but also more complicated baseline for thinking about the relationship between Jesus and the way people told his story, whereas we have only the two versions of the Jeremiah scroll.")]), _vm._v(" "), _c('li', [_vm._v("A way of formulating the question about the relationship between Jeremiah and the Jeremiah scroll is to ask whether the scroll is more like Mark, more like Matthew or Luke, or more like John. And a way of categorizing scholarly work on Jeremiah is to classify it according to its answer to that question. But one’s answer to that question is as much the hypothesis from which one starts as the conclusion that one reaches.")]), _vm._v(" "), _c('li', [_vm._v("The presence of all four Gospels in the Scriptures reflects an assumption that God likes all four ways of telling the Jesus story. The place of the Jeremiah scroll among the Scriptures then does not imply that in its relationship to Jeremiah himself it is more like Mark than like John. Either way, it is “authentic.”")]), _vm._v(" "), _c('li', [_vm._v("If MT Jeremiah is an expanded edition of the version lying behind LXX Jeremiah, it is not therefore inferior any more than Matthew is inferior to Mark. Nor is it a basis for emending MT’s text—or for that matter vice versa. Both MT Jeremiah and LXX Jeremiah need to be understood in their own right, like Matthew, Mark, and Luke, though a comparison of the versions may draw attention to significant features.")]), _vm._v(" "), _c('li', [_vm._v("A focus on getting behind the Jeremiah scroll and tracing the process whereby it came into being risks ceasing to pay attention to the scroll itself—as is the case with a focus on getting behind Mark or John. Tracing that process may be interesting and worthwhile, but it is a different enterprise from interpreting the scroll.")]), _vm._v(" "), _c('li', [_vm._v("If getting behind the Gospels to the Jesus of history is complicated (!), then tracing the process whereby the Jeremiah scroll developed is at least as complicated, as is reflected in the scholarly study of the past century or so.")]), _vm._v(" "), _c('li', [_vm._v("Christians may read the Gospels to listen to the message the Gospel writers brought as they reflected on Jesus’s life and ministry with the assumption that in this way we may imagine our way into Jesus’s life and ministry and learn from it. Thus, alongside “suspension of belief” in the “historical Jeremiah” in order to “read the text as if that character were the product of the tradition itself”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2272",
      "id": "footnote-2272-backlink"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" (that is, to read, interpret, and believe the received text as if the Jeremiah in it were the “real” Jeremiah), one might put suspension of belief in a redactional process that we cannot trace in order to read the text that issued from that process (that is, to read, interpret, and believe the received text without wondering if it is the “real” text).")]), _vm._v(" "), _c('li', [_vm._v("A chapter such as Jer 32 is instructive in this connection. It anticipates the form of some chapters in John’s Gospel that open with a symbolic act by Jesus that is the lead-in to a theme relating to the symbolic act. In those chapters, over a period of fifty years or so after Jesus’s death and resurrection, the Holy Spirit inspired John to take events from Jesus’s life and his actual words and make them the basis for a reflection on his significance, which John presents as Jesus’s own words. The Christian community came to recognize the authenticity of that reflection in this connection. It may be anachronistic to imagine the community thinking about this process in a way that made the distinction that I might presuppose between what Jesus said and what John might infer from it,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2271",
      "id": "footnote-2271-backlink"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" but given that I cannot help making that distinction, then the way I express it involves affirming my trust that the Christian community did the right thing when it recognized that John had truly articulated the significance of Jesus and, for that matter, my assumption that Jesus himself would have liked the way John has put things on his lips that he did not say.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In light of this analogy with the Gospels, I picture the composition of the scroll along the following lines. The picture is shrouded in the word "), _c('em', [_vm._v("possibly")]), _vm._v(", though I do not keep repeating that word below.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Between 626 and 604, Yahweh was giving Jeremiah messages that he delivered in the temple courtyards and elsewhere. These messages appear within Jer 2–6. Jeremiah critiqued the Judahite religion that Josiah tried to reform and supported his reformation, but he opposed Josiah’s political and military policies. He opposed the reversion to pre-reformation religious practices after Josiah’s death.")]), _vm._v(" "), _c('li', [_vm._v("In 604, Yahweh told Jeremiah to write up all his messages. Jehoiakim destroyed the resulting document, but Jeremiah rewrote it, and Jer 2–6 is the rewritten version—perhaps annotated after 587. We cannot date most of the messages within Jer 2–6 to particular moments between 626 and 604.")]), _vm._v(" "), _c('li', [_vm._v("Through the reigns of Jehoiakim, Jehoiachin, and Zedekiah, Yahweh continued to give Jeremiah messages to deliver in the temple courtyard and in the palace. They provoked controversy and opposition. In the last years before 587 and the aftermath, Yahweh continued to give Jeremiah messages for Judah, some more promissory as the catastrophe approached and after it happened. Before the city’s fall, he continued to deliver these messages in the temple courtyard and in the palace; afterward, he delivered them in Mizpah.")]), _vm._v(" "), _c('li', [_vm._v("In Mizpah or in Egypt, Jeremiah got Baruch to write down the further messages that he had received during the reigns of Jehoiakim, Jehoiachin, and Zedekiah, which appear within Jer 7–36 and 46–51. They are or include the “many similar words” of 36:32. There is no reason to set verse and prose sharply apart within these chapters as Jeremiah’s method of communication, but prose may more often indicate that curators are summarizing Jeremiah’s message as they understand it.")]), _vm._v(" "), _c('li', [_vm._v("Storytellers in Mizpah or Egypt wrote the stories about Jeremiah up until his move to Egypt and its aftermath, beginning with 1:4–19 but mostly within Jer 26–45. They include messages by Jeremiah in prose whose wording the curators sometimes formulated, based on what they knew Jeremiah had said or on the implications of his message.")]), _vm._v(" "), _c('li', [_vm._v("Curators compiled the complexes of messages and stories that we can discern within the scroll (e.g., 39:1–44:30; 46:1–51:64) and placed the complexes end to end (as happened with the book of Psalms) in bringing together the material in 1:1–52:30 in an organized form. They added 52:31–34 in about 560.")]), _vm._v(" "), _c('li', [_vm._v("The scroll refers to the Medes as a serious power and potential threat for Babylon and to three peoples within the Median Empire; it shows no awareness of the Persians, who took over the Median Empire and turned out to be the actual threat to Babylon; it refers to the release of Jehoiachin as if that were a sign of hope but shows no awareness of the accession of Cyrus to which Ezra 1 can refer as a more telling sign of hope and the fulfillment of Jeremiah’s promises; it speaks much of the fall of Babylon but shows no awareness of how Babylon actually fell and gives no indication that imperial power has passed from Babylon to Persia, that many Judahites have returned to Jerusalem, or that the temple has been rebuilt. By the 550s or 540s, then, the scroll reached something close to the version we have.")]), _vm._v(" "), _c('li', [_vm._v("Copies reached Judah and Babylon, and curators in Egypt, Judah, or Babylon produced the further versions that approximate to the Hebrew text that we have and to the Hebrew text lying behind the LXX version (the LXX "), _c('em', [_vm._v("Vorlage")]), _vm._v(", or LXXV).")]), _vm._v(" "), _c('li', [_vm._v("Both scrolls may have been glossed later. MT Jeremiah includes a distinctive number of small variations between the "), _c('em', [_vm._v("ketiv")]), _vm._v(" and the "), _c('em', [_vm._v("qere")]), _vm._v(", which may reflect this process.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-5"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("C. THE PERSIAN PERIOD: A FOURTH HORIZON?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In the unresolved scholarly debate on the origin of the scroll, views focus more on the Persian and Greek periods than on the decades that more immediately followed the time of Jeremiah’s own activity. In placing the scroll’s finalizing in the Babylonian period, I take the minority opinion."), _c('a', {
    attrs: {
      "href": "#/#footnote-2270",
      "id": "footnote-2270-backlink"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" Much scholarship in the late twentieth and early twenty-first century has seen the Persian period as the key context in which First Testament scrolls in general came into existence. The illumination that emerges from postcolonial perspectives"), _c('a', {
    attrs: {
      "href": "#/#footnote-2269",
      "id": "footnote-2269-backlink"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" and considerations of ideology"), _c('a', {
    attrs: {
      "href": "#/#footnote-2268",
      "id": "footnote-2268-backlink"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" has especially encouraged the making of this connection, not least for Jeremiah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Ezra 1–6 relates that Yahweh fulfilled one of Jeremiah’s declarations when Judahites in Babylon returned to Jerusalem to rebuild the temple. They refused to let people whose ancestors had long ago been forced migrants into Samaria join in the project, and “the people of the country weakened the hands of the people of Judah” in connection with it (Ezra 4:4). They sought to get the Persian authorities to stop this work and the subsequent rebuilding of Jerusalem itself. On the other hand, people who had joined the returned exiles in the building project on the basis of separating themselves from the defilement of “the nations of the country” in order to have recourse to Yahweh did in due course join in the celebration of the temple rebuilding (Ezra 6:21–22). Identifying these groups is difficult, but it is enough to establish that there were tensions and conflicts between different groups in Judah, specifically between people who had returned from Babylon and people who had not gone into exile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One could call them different interest groups. And just as different Christian groups see themselves as the heirs of the New Testament or parts of it, one can imagine different groups in Judah claiming to be the heirs of Jeremiah’s message. One can further ask of the Jeremiah scroll itself the modern and postmodern question, “Whose interests does it serve?”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2267",
      "id": "footnote-2267-backlink"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" If “the political is primary,”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2266",
      "id": "footnote-2266-backlink"
    }
  }, [_c('sup', [_vm._v("38")])]), _vm._v(" and if the scroll came into being in the Persian period, then it would not be surprising if these groups’ claims were expressed in the scroll itself. If, for instance, its curators were people who had come back from Babylon or were their descendants, one can ask how they wrote their claims into their work."), _c('a', {
    attrs: {
      "href": "#/#footnote-2265",
      "id": "footnote-2265-backlink"
    }
  }, [_c('sup', [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Several issues need distinguishing and evaluating here.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The scroll may reflect conflicts and different interests among the Judahite communities over the relative status of the community in Judah, in Babylon, and in Egypt or over the status of Jehoiachin or over attitudes toward the Babylonian Empire itself. But the fact of such conflicts does not imply that they needed a century to emerge or find expression."), _c('a', {
    attrs: {
      "href": "#/#footnote-2264",
      "id": "footnote-2264-backlink"
    }
  }, [_c('sup', [_vm._v("40")])])]), _vm._v(" "), _c('li', [_vm._v("Reference to the tensions and conflicts of which Ezra 1–6 speaks has to be read into the Jeremiah text. While Jer 24 and 29 can be connected with them, they do not require such a connection or point directly to these tensions and conflicts (see the commentary on Jer 24 and 29).")]), _vm._v(" "), _c('li', [_vm._v("The connections can be made on the basis of redaction-critical study of the text. But the redaction-critical study emerges from the theory as much as the other way around.")]), _vm._v(" "), _c('li', [_vm._v("If one explains the scroll’s capacity to combine two contrasting views (e.g., in its attitude toward Jehoiachin or in describing Nebuchadrezzar as Yahweh’s servant and declaring that Yahweh’s wrath is coming on Babylon) as reflecting the view of pro-Babylonian and anti-Babylonian groups, that “explanation” only pushes the question back a stage: if the two attitudes could not be taken by one group, how did both attitudes gain access to the same scroll? (On theological tensions in the scroll, see “Main Themes and Their Implications,” pp. 59–60.)")]), _vm._v(" "), _c('li', [_vm._v("“Why would each of these groups,” who all named the name of the one God, “have chosen to re-establish their identities in such exclusivist ways?” Was it an inevitable aspect of the need to reformulate the faith? Does the reaction seem odd because of our modern, liberal, inclusive tendencies?"), _c('a', {
    attrs: {
      "href": "#/#footnote-2263",
      "id": "footnote-2263-backlink"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Or might we turn this question on its head? Whereas “Whose interests does it serve?” has become a familiar question in the West in the context of conflicts over the past century, perhaps we are imposing it on Ezra and Jeremiah, and people were less preoccupied by power than modern Western people or could disagree without being in conflict.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Further, the following considerations raise difficulties for the idea that the scroll reflects the Persian period.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("It makes no reference to anything we know about in the Persian period. It never refers to the Persians themselves or to the issues that surface in Ezra 7–Nehemiah 13. The First Testament does include material with a background in the Second Temple period (e.g., in Chronicles, Ezra, Nehemiah, Esther, Ecclesiastes, Daniel, Haggai, and Zechariah), which explicitly refers to this background and includes Persian words and represents features of Late Biblical Hebrew. Jeremiah does not have these characteristics."), _c('a', {
    attrs: {
      "href": "#/#footnote-2262",
      "id": "footnote-2262-backlink"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" (It also gives no concrete indication of links with the Greek period, such as Greek words or historical references; the question of development of ideas—specifically eschatological/apocalyptic ideas—involves arguing in a circle."), _c('a', {
    attrs: {
      "href": "#/#footnote-2261",
      "id": "footnote-2261-backlink"
    }
  }, [_c('sup', [_vm._v("43")])]), _vm._v(")")]), _vm._v(" "), _c('li', [_vm._v("“There is thus some effort of the imagination involved in locating the scroll in this context” in that “passages are explained against a variety of proposed backgrounds of which we have little in the way of real knowledge.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2260",
      "id": "footnote-2260-backlink"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" To elaborate the point,")]), _vm._v(" "), _c('li', [_vm._v("“Few periods of biblical history have attracted as much attention in recent years as the Persian era…. As a result of this scholarly interest, many Old Testament texts and the most important processes in the development of the YHWH faith have been (re-)dated to this era…. [But] many of these processes (e.g. the emergence of the Torah in the Persian period) have merely been deduced and therefore remain hypothetical and speculative…. Primary and secondary sources for the approximately 200-year Persian supremacy in the ancient Near East are incredibly sparse, much more so than for the 100-years of Assyrian hegemony…. The scarcer and more problematic the sources, the greater the conjecture and speculation.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2259",
      "id": "footnote-2259-backlink"
    }
  }, [_c('sup', [_vm._v("45")])])]), _vm._v(" "), _c('li', [_vm._v("“The tough circumstance of the community in Judah in the Persian period indeed required Judahite intellectuals to be interacting with Israel’s traditions: “Total abandonment of cultural heritage and identity must have seemed unthinkable.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2258",
      "id": "footnote-2258-backlink"
    }
  }, [_c('sup', [_vm._v("46")])]), _vm._v(" And one can see scrolls such as Chronicles and Ecclesiastes as engaged in such reflection. The problem with suggesting that the Jeremiah scroll’s development was an aspect of this reflection is the wide gap between its contents and the purpose that according to this hypothesis it was designed to fulfill. The content of those works looks quite different from that of the Jeremiah scroll.")]), _vm._v(" "), _c('li', [_vm._v("The quotations from Jeremiah within the First Testament take up the promises rather than the warnings, and the Ezekiel scroll includes much more by way of promise than the Jeremiah scroll. It’s been said that “the prophetic books are about hope”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2257",
      "id": "footnote-2257-backlink"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" and that “predominantly … Jeremiah’s book contains a message of hope.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2256",
      "id": "footnote-2256-backlink"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" Actually, the Jeremiah scroll is closer to being dominated by threat. "), _c('em', [_vm._v("B. Baba Batra")]), _vm._v(" 14b exaggerates only slightly in saying that “it is all of it the destruction” (see “The Jeremiah Scroll in the Canons of Judaism and of the Church,” pp. 42–43). It is at least a “predominantly dystopian text,”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2255",
      "id": "footnote-2255-backlink"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" not the kind of text one would expect to develop to meet the needs of the Persian period.")])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-6"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("D. DISUNITY OF COMPOSITION")]), _vm._v(" ("), _c('span', {
    staticClass: "rh_char2"
  }, [_vm._v("A FIFTH HORIZON")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The suggestion that the Jeremiah scroll relates to the Persian period is an interpretation that arises from a Western scholarly context and reads the text in light of concerns that come from the time of the readers. To put it in anthropological terms, it is etic rather than emic."), _c('a', {
    attrs: {
      "href": "#/#footnote-2254",
      "id": "footnote-2254-backlink"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" It is an “in front of the text” reading rather than an “in the text” reading. Paradoxically, as an “in front of the text” reading, it becomes another “behind the text” reading of the kind that were common in connection with Jeremiah in the twentieth century. There is some irony about Jeremiah study’s moving from a quest for the historical Jeremiah of the First Temple period to a quest for the historical Jeremianic authors and communities of the Second Temple period; the latter quest is another version of the former and is just as doomed. There is a further parallel with study of the Gospels, which moved from a quest for the historical Jesus to a quest for the communities that the Gospels addressed; this also did not work out very well and could thus lead back to asking questions about “the Gospels for all Christians.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2253",
      "id": "footnote-2253-backlink"
    }
  }, [_c('sup', [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is nothing wrong in principle with “in front of the text” readings just as there is nothing wrong with “behind the text” readings. Indeed, there is a sense in which any reading is an “in front of the text” one because, by definition, interpreters all live in front of the text as (e.g.) Western academics sympathetic to postmodern and postcolonial thinking in the twenty-first century. But the image of horizons presupposes that we seek to allow our horizon to merge with that of the text—at least to understand it, even if not necessarily to agree with it. The problem with the “in front of the text” Persian-period understanding of the Jeremiah scroll resembles the problem with an understanding of the Song of Songs as concerned with God’s relationship with Israel or Jesus’s relationship with a believer. It may illumine that relationship, but it loses the thrust of the text itself. And it ends up critiquing the text for fulfilling a different aim from the one that was its concern. The promise and the drawback of “in front of the text” approaches lie in their reading Jeremiah in light of Western insights, experiences, and culture. As they engage in ideological criticism of the scroll and look for ideological considerations that are reflected in the text, they do so in light of their own ideological convictions. Thus, paradoxically, postcolonial interpretation takes an imperial stance in relation to the text. Beginning from a position of power over the text, in the name of marginalized people it marginalizes the text and advances its own ideological concerns.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("If the curators of the Jeremiah scroll did live in the Second Temple period, they avoided drawing direct attention to themselves or their context and invited their readers to read the scroll in the context of the period from Josiah to the aftermath of 587. Readers are free to decide for themselves whether they will do so, but in this commentary, I have accepted the invitation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To do so is not to imply that one abjures “in front of the text” readings, which one could call a fifth horizon. Such readings informed by post-structuralism, feminism, deconstruction, and intertextuality have flourished in the late twentieth and early twenty-first centuries."), _c('a', {
    attrs: {
      "href": "#/#footnote-2252",
      "id": "footnote-2252-backlink"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" In the commentary, I will refer to some exercises in interpretation that reflect the fourth and fifth horizons, but my focus will be on the first three.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-7"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("E. THE TORAH, THE PROPHETS, AND THE PSALMS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Jeremiah has a background in the Torah, the Prophets, and the Psalms,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2251",
      "id": "footnote-2251-backlink"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" though none of these scrolls existed in his day in the form in which we know them. Not surprisingly, the length of the Jeremiah scroll means it has room for allusions to the key moments in the story that appears in the First Testament as we know it: God’s act of creation, his promise to Israel’s ancestors, his destruction of Sodom and Gomorrah, his getting Israel out of Egypt, his leading them through the wilderness, his making a pledge with them, his giving Moses his Ten Words, his listening to Moses and Samuel as intercessors, and his destroying Shiloh. These last references to an Ephraimite person and place remind us that the background information at the beginning of the scroll designates Jeremiah as someone from Anathoth in Benjamin, which could count as Ephraim rather than Judah (see the commentary on 1:1). There could then be some ambiguity about Jeremiah’s position—living in Jerusalem but not quite belonging there. But it would be nice to think that his origin in a priestly family contributed to his wide knowledge of Israel’s story and of the sacred traditions that we know from the Torah, the Prophets, and the Psalms, including priestly material."), _c('a', {
    attrs: {
      "href": "#/#footnote-2250",
      "id": "footnote-2250-backlink"
    }
  }, [_c('sup', [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The most explicit single allusion to them appears in 26:18–19, which refers to Micah and to the story of Hezekiah and associates Micah with the kind of warning about disaster coming to Judah that Jeremiah also uttered. But it is not Jeremiah himself who refers to Micah in the text, but the elders of Judah. Jeremiah’s own way of speaking about Yahweh’s relationship with Israel as like that of a husband with his wife—a relationship that laid on the wife an expectation of submission to her husband that Israel failed to fulfill—recalls the message of the Ephraimite prophet Hosea. It is a plausible assumption that a scroll with Hosea’s teaching was compiled in Jerusalem or taken there before or after the fall of Samaria in 722, which could provide means whereby Jeremiah got to know Hosea’s message."), _c('a', {
    attrs: {
      "href": "#/#footnote-2249",
      "id": "footnote-2249-backlink"
    }
  }, [_c('sup', [_vm._v("55")])]), _vm._v(" Further, Jer 48–49 indicates concrete acquaintance with Isaiah and Obadiah (unless the acquaintance is the other way around), and Jer 48 reflects Num 21. The scroll incorporates many further lines and images that may count as allusions to the messages of other prophets.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In his comments on that quasi-marital relationship, Jeremiah also takes up teaching from the Torah that appears in Deut 24, to which Jer 3:1 constitutes a more or less explicit reference. We have noted that Josiah’s reformation was fueled by the emergence of a Torah scroll that seems to have corresponded with something like Deuteronomy as we know it, and there are various points at which Jeremiah seems to presuppose people’s acquaintance with Deuteronomy. The question of acquaintance and allusion is complicated by the apparent fact that Deuteronomy as a whole as we know it came into existence during or after the time Jeremiah was active, while the Torah as a whole as we know it comes from after Jeremiah’s day. I think of Ezra bringing it to Jerusalem in 458 (see Ezra 7) as the moment when it was propagated in Jerusalem. So Jeremiah’s message may be background to Deuteronomy as well as Deuteronomy being background to Jeremiah. There are particularly close links between Jeremiah and Deut 32, and the influence might go either way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Deuteronomy appears in the First Testament as a lead-in to Joshua through Kings, an account of Israel’s story from Moses to the fall of Jerusalem. The telling of that story reflects the same ways of thinking as Deuteronomy, which provides key clues to understanding why Israel’s story unfolded in the way it did. There is again a close relationship between the narrative in 2 Kgs 17–25 and the Jeremiah scroll. Much of Jer 39 and 52 are virtually identical with 2 Kgs 25, as, for example, Matt 4:1–11 is virtually identical with Luke 4:1–13. More subtly, the story of Josiah’s coming to know that Torah scroll and his reaction to it (2 Kgs 22–23) provides a pattern for the story of Jehoiakim’s coming to know the scroll of Jeremiah’s message and his reaction to it (Jer 36)—a pattern with which the Jehoiakim story constitutes a chilling contrast. The teaching and stories in the Jeremiah scroll are related in ways that indicate more generally the influence of the thinking of Deuteronomy and of those succeeding books.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The praises and protest prayers in Jeremiah compare with their equivalents in the Psalms, against whose background Jeremiah praises and prays. Specific links may indicate that he picks up their phrases or may indicate that he influences them. He also has themes and language in common with Isa 40–55 and with Ezekiel that might indicate influence either way."), _c('a', {
    attrs: {
      "href": "#/#footnote-2248",
      "id": "footnote-2248-backlink"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-8"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("F. WAS JEREMIAH A HISTORICAL FIGURE?")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The contents of the Jeremiah scroll fit against a historical background in events in Judah in the late Assyrian and Babylonian period, the period to which the scroll’s introduction refers. But the plausibility of this background does not determine how historical the Jeremiah story is. Fictional works are often set against a credible historical background, so having a plausible historical background and being history-like say nothing about whether a work presents itself as historical or succeeds in being historical, if it has that aim. And it has sometimes been argued that Jeremiah is more or less a fictional character. In the LXX, the Jeremiah scroll is followed by Baruch, a work in which Jeremiah’s scribe delivers a message to the Judahites in Babylon, and then (after Lamentations) by a Letter of Jeremiah sent to the Judahites in Babylon. But these writings have no actual connection with a historical Jeremiah or Baruch and they never had a place in the Torah, the Prophets, and the Writings. Is Jeremiah comparable to them"), _c('a', {
    attrs: {
      "href": "#/#footnote-2247",
      "id": "footnote-2247-backlink"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v("—essentially a literary creation?"), _c('a', {
    attrs: {
      "href": "#/#footnote-2246",
      "id": "footnote-2246-backlink"
    }
  }, [_c('sup', [_vm._v("58")])]), _vm._v(" Or is the Jeremiah scroll more like the closing chapters of 2 Kings that give a basically factual account of the decades to which the Jeremiah scroll also relates?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The fact that the Jeremiah scroll is Yahweh’s message, Yahweh’s word, does not in itself indicate that it must be presenting itself as historical. Yahweh likes history, but he also likes works of the imagination; they can be a good way of conveying insight. Jonah is such a story about a prophet, and Ecclesiastes is a collection of testimonies and observations that half-invites readers to think they come from Solomon (“half-invites” in that it does not name him). Each of those works takes a historical person as its launching point but then constructs a work of imagination. It is inspired imagination; designating these scrolls in this way does not imply they are untrue. They are like Jesus’s parables. They tell people the truth about Yahweh and about themselves, but they do so in a different way from historical works. “Counterfactual histories” can make it possible to think creatively about a better present."), _c('a', {
    attrs: {
      "href": "#/#footnote-2245",
      "id": "footnote-2245-backlink"
    }
  }, [_c('sup', [_vm._v("59")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But a number of considerations suggest that the Jeremiah scroll is more like the closing chapters of 2 Kings in its relation to history than like Jonah or Ecclesiastes.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Jonah is clearly structured in its literary nature and in its thinking. The Jeremiah scroll has some structure, but its material is much more diverse and variegated."), _c('a', {
    attrs: {
      "href": "#/#footnote-2244",
      "id": "footnote-2244-backlink"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" It has been called “a complicated, untidy accumulation,” a “rolling "), _c('em', [_vm._v("corpus")]), _vm._v(".”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2243",
      "id": "footnote-2243-backlink"
    }
  }, [_c('sup', [_vm._v("61")])])]), _vm._v(" "), _c('li', [_vm._v("Ecclesiastes implicitly attributes its contents to someone whom everyone knew to be important, and even Jonah is a paradoxically appropriate subject for the message conveyed by the story about him. Likewise, by the time Baruch and the Letter of Jeremiah were written, Baruch and Jeremiah were well-known and respected. But in the case of the Jeremiah scroll itself, in the words of Overholt, “what puzzles me is why someone would collect material and then assign it to a ‘fictional’ character” if that is what Jeremiah is."), _c('a', {
    attrs: {
      "href": "#/#footnote-2242",
      "id": "footnote-2242-backlink"
    }
  }, [_c('sup', [_vm._v("62")])])]), _vm._v(" "), _c('li', [_vm._v("Jonah and Ecclesiastes no doubt reflect and interact with concrete historical contexts, but they do not directly refer to these contexts. The material in the Jeremiah scroll interacts explicitly and concretely with Judah in the time from the 620s to the 560s.")]), _vm._v(" "), _c('li', [_vm._v("Jonah and Ecclesiastes do not seek to “explain the People of Israel’s past against the background of God’s presence, and in this way to interpret the present experience of God’s people in order to shape its future” like the bulk of the First Testament."), _c('a', {
    attrs: {
      "href": "#/#footnote-2241",
      "id": "footnote-2241-backlink"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" The Jeremiah scroll does work in this way, and there is some tension between the idea of making the past the basis for looking to the future and the idea that the past in question is not at all a real past.")]), _vm._v(" "), _c('li', [_vm._v("More specifically, the story and message in the Jeremiah scroll concern Yahweh’s involvement with the events of which it speaks, like Exodus, Joshua, and the Gospels. If the message and the narratives are simply fictional, the message deconstructs. It falls apart. Jeremiah’s way of working suggests that the historical and the literary need to be held together."), _c('a', {
    attrs: {
      "href": "#/#footnote-2240",
      "id": "footnote-2240-backlink"
    }
  }, [_c('sup', [_vm._v("64")])])]), _vm._v(" "), _c('li', [_vm._v("Jeremiah, like Exodus, manifests points of connection with otherwise-known facts from Israel’s world. References in the scroll to events and a comparison of names in the scroll with names known from seals at least suggest that a number of passages must have been written close to the time of the events described and written by people involved in those events."), _c('a', {
    attrs: {
      "href": "#/#footnote-2239",
      "id": "footnote-2239-backlink"
    }
  }, [_c('sup', [_vm._v("65")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These considerations suggest that the Jeremiah scroll is more likely to be based on fact and to relate to an actual prophet called Jeremiah than to be purely a work of the imagination. But we may also note a paradoxical parallel with Jonah and Ecclesiastes. While one’s view on whether these scrolls are fact or fiction makes a difference to an understanding of their significance for Judahite history, it may not make so much difference to interpreting the meaning of the scrolls in themselves or the message from God that they bring.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-3"
    }
  }, [_vm._v("III. AUTHORSHIP AND DATE")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In a literal, down-to-earth sense, the authors of the Jeremiah scroll are the curators who did their work in the period that came to an end in the 550s or 540s. But they would not have seen themselves as the scroll’s authors. Their aim was to transmit the message of the real author, the prophet Jeremiah—poet, preacher, crusader, persuader.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-9"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("A. JEREMIAH AS POET")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("The first half of the Jeremiah scroll is dominated by messages in poetic form. It suggests an image of Jeremiah chanting poetic messages as he stands in the temple courtyard, as perhaps did rival prophets. It was a natural way to preach. “The prophets were poets,”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2238",
      "id": "footnote-2238-backlink"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" and with prophets such as Jeremiah, “prophetic poets are most unpleasant people to have in the midst of any society.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2237",
      "id": "footnote-2237-backlink"
    }
  }, [_c('sup', [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Formally, a distinctive feature of poetry in the First Testament is that it comprises sentences averaging four to eight words, divided into two parts. The second half usually complements the first half; the traditional but misleading term for this pattern is parallelism. I call the two parts cola; a sentence or line is then a bicolon, with two, three, or four words in each half. A Hebrew word has one stressed syllable (whereas in English, a word such as “individual” has two stressed syllables), so the number of words establishes the line’s rhythm. In English translation, the lines are longer because Hebrew compounds words in a way that English does not. Hebrew can also hyphenate words, like English, so that two words count as one, and this convention increases the number of Hebrew words in a line but not the number of stresses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A sequence of lines with a short second colon can convey shock or protest; the lines bring the listener up short (see, e.g., 13:18–20). Occasionally, other lines may not fit the pattern of two, three, or four stresses in each colon, and the Jeremiah scroll includes lines that are, for example, 4-1 (16:16), 5-2 (3:3; 4:17; 18:6), 5-3 (15:18), 5-4 (2:8; 16:18; 22:15), or 5-5 (10:11). Such exceptionally short or exceptionally long lines draw attention to themselves. In general, rhythm in prophets such as Jeremiah is looser than it is in the Psalms, Proverbs, and Job, where perhaps liturgical, pedagogical, and poetic/literary considerations generate a greater evenness. Perhaps prophets are more improvisational and less deliberate. I assume that they would chant their messages like rap artists, and the feasibility of such performance depends only on keeping the rhythm going, no matter how many words one uses.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah is also fond of three-part lines (tricola), which draw attention to themselves by the unexpected third colon that brings a surprise. Tricola often begin or end a poem or a section of a poem. Further, Hebrew like English has conventions about word order. In English, the subject comes before the verb, whereas in Hebrew, the verb comes first; but Jeremiah likes varying the word order to make a point. Yet further, many of Jeremiah’s lines are not self-contained—one will run into the next, and maybe into the next, by enjambment:")]), _vm._v(" "), _c('p', {
    staticClass: "pq10"
  }, [_vm._v("I have been mindful about you, of your youthful commitment,")]), _vm._v(" "), _c('p', {
    staticClass: "pq21"
  }, [_vm._v("of your bridal love,")]), _vm._v(" "), _c('p', {
    staticClass: "pq20"
  }, [_vm._v("Of your going after me in the wilderness,")]), _vm._v(" "), _c('p', {
    staticClass: "pq31"
  }, [_vm._v("in a country not sown. (2:2)")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The rhythm of those two lines is 4-2 and 3-3 (or one could read the first as a 2-2-2 tricolon). They also illustrate a key feature of the substance of poetry: that it uses imagery to articulate what it has to say in a profound and communicative fashion (see “Theology Imaged,” pp. 57–58). There are verses in the scroll that are rhythmic or pithy but lack imagery; it then becomes a judgment call whether one designates them as prosaic poetry or poetic prose (see e.g., 5:18–19; 9:23–26[22–25]; 10:11, 18; 11:17; 18:18; 25:33). If I err, it is on the side of being generous in designating verses as poetry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In general, Jeremiah’s poetic style is characterized by “staccato exclamations, rapid changes of scene and vantage point, frequent shifts of voice and discourse, use of invocation, plural command, and rhetorical question, a propensity for assonance and wordplay, a rich array of metaphors and similes from the natural landscapes and from human crafts and trades, and precision of metonymy and synecdoche.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2236",
      "id": "footnote-2236-backlink"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" It is succinct and terse; it is inclined to omit the little words that aid communication, such as the object marker and prepositions. It uses other forms of ellipsis that can produce jerkiness: it omits (say) a verb and expects the listeners to work out what the line means (see, e.g., 4:6; 12:9). Jeremiah’s poetry is also fond of hyperbole (e.g., 5:1–6; 7:21–23; 20:8); while one needs to be wary of imposing figurative interpretation on extreme statements that are meant literally, indisputable examples of hyperbole (e.g., 40:11–12) are a reminder not to treat Jeremiah or his curators as if they are being extreme when they are not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One verse in Jeremiah sometimes corresponds to one poetic line; 4:21 is an example. More often, a verse covers more lines: 4:20 comprises two, but 4:19 has three. Where necessary, I refer to a single line as, for example, 4:20a or 4:20b. If I need to refer to individual cola within those lines, I use Greek letters: I would refer to 4:20a"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("α")]), _vm._v(" and 4:20a"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("β")]), _vm._v(", then to 4:20b"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("α")]), _vm._v(" and 4:20b"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("β")]), _vm._v(". In a verse such as 4:19, with three bicola, I would refer to 4:19a"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("α")]), _vm._v(" and 4:19a"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("β")]), _vm._v(", then to 4:19b"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("α")]), _vm._v(" and 4:19b"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("β")]), _vm._v(", and finally to 40:19c"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("α")]), _vm._v(", and 4:19c"), _c('span', {
    staticClass: "greek"
  }, [_vm._v("β")]), _vm._v(".")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-10"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. JEREMIAH AS PREACHER")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("As Jeremiah was a priest, he could naturally be a teacher and preacher. Interwoven with his messages in poetry are messages in prose, and one can see why it should be so. Poetry communicates figuratively, indirectly, elliptically, obliquely, allegorically. It makes people scratch their heads. They have to work at understanding it. Prose is straightforward, direct, literal, prosaic, intelligible. It hits people between the eyes. They can hardly avoid understanding it."), _c('a', {
    attrs: {
      "href": "#/#footnote-2235",
      "id": "footnote-2235-backlink"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" Thus poetry and prose complement each other, like Jesus’s parables and his ordinary teaching. Whereas the verse in the Jeremiah scroll is economical, the prose is prolix. Repetition is a natural feature of prose that is designed to persuade an audience, so that repetition in the written version of a sermon is as likely to indicate that an author is imitating oral style or incorporating a transcript of the preacher’s actual address as it is to indicate that the text has been expanded and should be abbreviated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Thus, the question whether Jeremiah himself could have communicated both in poetry and in prose is answered as soon as asked; if he wanted to communicate, he would naturally have used both. In wording and in substance, the poetry and the prose overlap, though in wording and in substance, they have distinctive features. In Jer 7, the slogan “Yahweh’s palace/temple” is a novelty, as is the warning about learning the lessons from the fate of Shiloh that recurs in the further prose story in Jer 26 and as are the references to the old “covenant” in Jer 11. There are further instructive features of Jer 11: it refers to a curse and to the response to the curse declaration, to being got out of the iron smelter, to the promise that Yahweh swore to the ancestors, and to “this very day” (11:2–5). These parallels distinguish the passage from other passages in Jeremiah, and in wording and substance such prose messages overlap with Moses’s sermon-like address to Israel in Deuteronomy, with other sermon-like addresses in Joshua through 2 Kings, and with further passages in 1 and 2 Kings. I like the observation that “Jeremiah was a self-proclaimed Deuteronomist.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2234",
      "id": "footnote-2234-backlink"
    }
  }, [_c('sup', [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In Jeremiah, many poetic messages carry introductions such as “Yahweh’s word came to me” (2:1), and some prose messages carry introductions such as “the message that came to Jeremiah from Yahweh” (7:1; 11:1). The former invite the hearers to take what follows as something Jeremiah is dictating—the result of the kind of process described in Jer 36. The latter invite the hearers to take what follows as mediated by a curator. The repetitiveness of 27:1–2, 4 (“This word came to Jeremiah from Yahweh. Yahweh said this to me…. Give them this order for their lords. Yahweh of Armies, the God of Israel, has said this: You will say this to your lords.”) indicates that the curators are keen for us to receive their account as authentic to Jeremiah and authentic to Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The difference in presentation and the comparison of prose with poetry and with Deuteronomy and 1 and 2 Kings again suggest something comparable to the nature of the Gospels. Their authors sometimes tell us exactly what Jesus said (translated into Greek). They sometimes tweak it to communicate his significance for their readers (some differences between Matthew, Mark, and Luke indicate examples). They sometimes put substantial presentations on Jesus’s lips that they have devised on the basis of starting points in things he said and that expound the significance of what he said for their readers. I take it that something similar is true of the prose messages in Jeremiah. Sometimes the curators interpret by arranging: the five sections in 7:1–8:3 are of separate origin, but the curators have brought them together as Matthew and Luke bring together things Jesus said on different occasions to produce “the Sermon on the Mount” and “the Sermon on the Plain.” Sometimes the curators may provide something close to a transcript or paraphrase or summary of what Jeremiah said. Sometimes they may tweak or develop it or translate it into other terminology. Sometimes they may turn a saying into a sermon. Sometimes they may start from their awareness of an aspect of Jeremiah’s significance that he never articulated. One might attempt to put each prose message into the right category, though it would be speculative. I will go with the curators’ account of their master.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-11"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("C. JEREMIAH AS CRUSADER")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Modern readers may assume that prophets such as Jeremiah have one of two functions: either to promise the coming of the Messiah or to challenge people to put things right in their society. While Jeremiah does a little of each of these things, they do not describe more than five percent of his activity. His main focus lies on challenging people to be faithful to Yahweh and not to serve other deities and on declaring the consequences that will follow if they fail to do as he says. “The constant thread throughout the book is the apostasy of Judah.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2233",
      "id": "footnote-2233-backlink"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" The point is clear from the beginning of the scroll (see 1:4–19 and 2:1–37). The scroll is not organized chronologically or topically, and reading it can be confusing or wearying because it keeps coming back to the same issue, to a confrontation of Judah in connection with the way it relates to Yahweh, the way it worships, the way it prays, and the way its people relate to one another—which are all interconnected. The burden of the critique might vary in different decades—for instance, before Josiah’s reformation and during the reigns of later kings. It might vary according to whether Jeremiah is speaking about the Jerusalem temple or other shrines and whether he is addressing official religion or family religion. But critique dominates.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One central critique is that Judahites serve other gods as well as Yahweh, making offerings to them and seeking their blessing. These other gods include the traditional gods of the region, the "), _c('em', [_vm._v("bә")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ālîm")]), _vm._v(" (“Masters”), who are believed to facilitate the natural processes whereby crops grow and women have children. Judahites also consult the deities whose beings lie behind the planets—gods acknowledged by Assyria and Babylon as entities that decide earthly events in political and family life. In eighth-century Israel, the First Testament associates the worship of a variety of deities with Ephraim more than Judah, but in the seventh century, in Manasseh’s day, it associates it also with Judah. Although turning to Yahweh and to no one else was basic to Yahweh’s relation to Israel from the time of the exodus, both the First Testament and archaeological discoveries suggest that most Judahites did not realize it, much as vast numbers of people in “Christian” countries have no clue about Christian faith.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("People can also be engaged in turning to Yahweh himself in ways that clash with who Yahweh is. The most horrific example is their willingness to sacrifice children to Yahweh. A more characteristic feature of their spirituality is their finding it helpful to make images of Yahweh as aids to worship. People’s worship that is formally offered to a deity called Yahweh may thus imply such a distorted understanding of Yahweh that it is tantamount to worshiping a different deity. This ambiguity can make it difficult to be sure about the object of Jeremiah’s critique—whether he refers to people’s conscious recourse to other deities or to worship that they thought they were offering to Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Josiah’s reformation cleaned up aspects of Judahite religion, but Judah reverted to pre-Josianic practice after his death, which hints that not everyone agreed with his reforming activity—including members of his family, to judge from the Jeremiah scroll’s comments about the policies of his sons Jehoiakim and Zedekiah. Taken literalistically, Jeremiah implies that they returned completely to Manassite practices. But 2 Kings does not report a reversion to overt worship of other deities, so Jeremiah’s polemic may indeed presuppose that Judahites thought they were turning to Yahweh but were deceiving themselves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A further aspect to Jeremiah’s crusading is that people can be engaging in worship and prayer that recognizes Yahweh but be conducting their national and communal life in a way that clashes not only with who Yahweh is but also with his expectations of that communal life. So worship has its proper place in their spirituality, but outside worship they live with false attitudes toward property, sex, truthfulness, and so on. Their political policies may presuppose that they must take responsibility for their future by making alliances with other countries, whereas a prophet such as Jeremiah thinks that trust in Yahweh is key to political policies.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s crusade has the demanding and challenging aim of getting the community to turn from the various aspects of this failure to live an authentic life with Yahweh.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-12"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("D. JEREMIAH AS PERSUADER")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("One could get the impression from the scroll’s opening message in 2:1–37 (and other chapters) that Jeremiah simply declares that the pouring out of Yahweh’s wrath is inevitable because of Judah’s ingrained waywardness, but in 3:1–4:4 (and other chapters), Jeremiah raises the question whether Judah is going to turn back to Yahweh, with the implication that it would make a difference to Judah’s fate. And what is the point of prophesying if it cannot? Is it simply to leave people without excuse, and encourage the small number of the faithful?"), _c('a', {
    attrs: {
      "href": "#/#footnote-2232",
      "id": "footnote-2232-backlink"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Is it to enable people after 587 to understand why the city’s fall had to happen and to urge them not to make the mistake that the previous generation made (see “Unity of Composition,” pp. 10–11)? The directness of Jeremiah’s challenge to his contemporaries suggests that those functions of his preaching did not come first. Even when he is declaring that they are incorrigible and that calamity is inevitable, he is aiming to get them to prove him wrong. He knows that Yahweh is still committed to his people; there is little difference between Jeremiah’s and Paul’s convictions about Yahweh’s commitment to Israel."), _c('a', {
    attrs: {
      "href": "#/#footnote-2231",
      "id": "footnote-2231-backlink"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" Jeremiah is involved in persuasion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Metaphor is essential to Jeremiah’s work as a theologian who wants to articulate for himself the nature of Yahweh and his relationship with his people. Imagery makes it possible to think and say things that we could not otherwise think or say. But the pragmatic function of imagery is at least as important for Jeremiah as the theological one: “A problem which Jeremiah shared with all the prophets was that of attracting the audience’s attention.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2230",
      "id": "footnote-2230-backlink"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" Talking in terms that come from the human experience of marriage, family, work, and politics makes it possible to bring home the nature of the relationship between Yahweh and Judah, of what Yahweh has done, of what Judah needs to do, and of the danger it risks by not doing it. Yahweh has married two sisters, Jeremiah suggests, and both are unfaithful (Jer 3). It is an aspect of “the prophets’ rhetoric of horror designed to terrify their audience into reform.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2229",
      "id": "footnote-2229-backlink"
    }
  }, [_c('sup', [_vm._v("75")])]), _vm._v(" Poetic form and the use of imagery are aspects of Jeremiah’s rhetoric, and “biblical prophets are masters of rhetoric. They craft their message to persuade their audience of its truth and to inspire them to reform their behavior.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2228",
      "id": "footnote-2228-backlink"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" To this end, Jeremiah is forceful and unrelenting, shocking and incendiary."), _c('a', {
    attrs: {
      "href": "#/#footnote-2227",
      "id": "footnote-2227-backlink"
    }
  }, [_c('sup', [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like “ideology,” “rhetoric” can be a pejorative word. It can suggest high-flown language to make a case that would not be compelling if put in plain terms, or it can suggest reference to Aristotelian rhetorical theory."), _c('a', {
    attrs: {
      "href": "#/#footnote-2226",
      "id": "footnote-2226-backlink"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" But regarding 14:21, Calvin says, “The Prophet joined together two verbs, not so much for the sake of ornament as rhetoricians do, as for the purpose of expressing the intenseness of his concern and anxiety.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2225",
      "id": "footnote-2225-backlink"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" In a broader sense of rhetoric, expressing his concern in this way is an aspect of his using language to bring home the truth of his case and to persuade people to make the response that the truth deserves.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah does use classical rhetorical devices such as metonymy and synecdoche: people’s houses are full of duplicity—that is, of the fruits of duplicity (5:27); their gateways are fading away—that is, their houses are fading away (14:2). He uses catachresis or transferred epithets: a quiver is like a grave opened up—that is, its arrows bring death (5:16). He uses anaphora, purposeful repetition; an example is the repetition of the word duplicity (9:6[5]). He uses paronomasia (that is, “wordplay,” but his wordplay is deadly serious), juxtaposing similar words or suggesting relationships between homonyms and thus making connections or underlining them (e.g., 1:10, 12). A related phenomenon is the use of a word such as "), _c('em', [_vm._v("rā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("â")]), _vm._v(" that can refer both to the bad things that people do and to the bad things that happen to them. English translations use words such as “wicked” and words such as “trouble,” but Jeremiah suggests the common (though not invariable) link between the two whereby bad actions can lead to bad consequences. I translate by expressions such as “dire action” and “dire experience.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The entirety of the Jeremiah scroll is rhetoric—not in a bad way, in order to manipulate, but in order to move. Jeremiah’s rhetoric is not a way of getting people to avoid thinking but a way of getting them to think.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-13"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("E. JEREMIAH AND HIS CURATORS AS ANTHOLOGISTS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Jeremiah’s poetic messages are typically bite-sized, occupying a couple or a dozen or a score of lines. It is perhaps no coincidence that prophets in the present day, in my experience, bring bite-sized messages. If they are wise, they shut up after their soundbite; the more they go on, the more their message gets diluted and the more one senses their words come from them rather than God. Maybe this phenomenon provokes reflection on the relationship between poetry and prose in Jeremiah, though if so, one would need to add that continuing in one’s own prose words need not exclude the possibility that God affirms the prose development as well as the poetic nucleus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But Jeremiah and his curators have handed down his poetic messages linked to one another in chains. A chain may comprise a series of messages on the same subject, possibly announced by a heading such as “Regarding the household of the king of Judah” or “Regarding the prophets” or “Regarding Egypt” (21:11; 23:9; 46:2). Or the scroll may leave the readers to work out the link between different poems.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A chapter in a modern Bible will typically contain four to six poetic messages. The obvious indicators that we are moving to a different message are phrases such as “listen to Yahweh’s word” or “Yahweh has said this” or “Yahweh’s affirmation,” which can mark a beginning or end. These phrases sometimes provided clues to the scribes who placed section markers in the Hebrew text and to the medieval scholars who added the chapter divisions in printed Bibles. But one needs to keep in mind that Jeremiah also uses these phrases resumptively in the middle of messages and uses them as attention-getters to emphasize a point. He can begin or end a message with no opening or closing phrase. One therefore also looks for changes of addressee, focus, and imagery that may mark a transition to a new message. The first and last sections of poetry in Jeremiah (Jer 2 and 50–51) provide spectacular examples of the scroll’s combining messages to generate a comprehensive whole,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2224",
      "id": "footnote-2224-backlink"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" while they also provoke questions about the chapters’ structure and components and compel interpreters to recognize the ambiguity of the indicators that they offer. Jeremiah 2 thus illustrates the use of the markers we have just referred to, which can indicate transition points within the chapter or points of emphasis:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("“Yahweh’s message came to me” does mark the beginning of the whole chapter.")]), _vm._v(" "), _c('li', [_vm._v("“Yahweh has said this” suggests the beginning of a message.")]), _vm._v(" "), _c('li', [_vm._v("“Yahweh’s affirmation,” emphasizing the importance of what precedes, can mark the end of a message, but it can also have resumptive significance within one.")]), _vm._v(" "), _c('li', [_vm._v("“Listen to Yahweh’s message” can introduce a section, but it can also be a resumptive exhortation.")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Lākēn")]), _vm._v(" commonly means “therefore” and suggests the approaching end of a section, but it can mean “that’s why” or “thus” and have resumptive significance.")]), _vm._v(" "), _c('li', [_c('em', [_vm._v("Kî")]), _vm._v(" usually means “because” and thus suggests continuity with what precedes, but it can be asseverative, meaning “indeed,” and open a section.")]), _vm._v(" "), _c('li', [_vm._v("“So now” or “now” ("), _c('em', [_vm._v("wә")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("attâ")]), _vm._v(" or "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("attâ")]), _vm._v(") suggests the beginning or conclusion of a section.")]), _vm._v(" "), _c('li', [_vm._v("A tricolon commonly conveys emphasis and can mark the beginning or end of a section but can also convey emphasis within one (there are four tricola in four verses in vv. 19–22).")]), _vm._v(" "), _c('li', [_vm._v("The recurrence of words or of similar words can indicate continuity within a section or linkage between separate sections.")]), _vm._v(" "), _c('li', [_vm._v("A change in the gender or number of addressees (masculine/feminine, singular/plural) can indicate transitions between sections.")]), _vm._v(" "), _c('li', [_vm._v("MT itself provides section markers after 2:3, 28; 3:5.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The way themes and arguments develop in the chapter has to be set alongside the presence of such markers in identifying how the chapter may divide, and analysis of structure may turn out to be less objective than one might hope. Interpreters may thus analyze a chapter in varying but complementary ways—as interpreters of a landscape or portrait or musical composition may offer varying but complementary analyses of it.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-4"
    }
  }, [_vm._v("IV. PLACE OF ORIGIN, OCCASION, AND DESTINATION")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("After the fall of Jerusalem, Jeremiah found his way to Mizpah and in due course to northern Egypt (40:1–43:13). There is no mystery about the scroll’s not recording his death; the First Testament records the killing of various prophets, which issues from their work or is a sign of their killers’ attitude to Yahweh’s message, but it does not record the natural death of any prophets. When Jeremiah reached Egypt, he would have been about sixty, and we may infer that he died a natural death there. Were his message and story preserved there or somewhere else? Where did they become the Jeremiah scroll?")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It makes sense to think of the two versions of the scroll, MT and LXX, as originating in different places. The scroll refers to Judahite communities in Babylon and Egypt and also to Judahites who took temporary refuge in places such as Ammon and among people in Samaria who identified themselves with Judahite faith. Oddly, the scroll implies that all the Judahite communities—in Babylon, Egypt, and Judah itself—were small, which might make them all seem unlikely locations for generating the scroll. It gives small numbers regarding the people forced to migrate to Babylon (52:28–30), it suggests hyperbolically that there was no one left in Judah, and it declares a death knell for the community in Egypt. Yet we know that the community in Babylon included as much of the Judahite leadership as the Babylonians could round up (in 597 and 587) and that much of the energy that issued in the rebuilding of the community in Jerusalem came from there (see Ezra, Haggai, Zechariah). Archaeological investigations suggest that Judah was not “an empty land” after the deportations—no doubt partly because refugees drifted back from places such as Ammon—and the composition of the poems in Lamentations suggests religious and theological life there. Whereas Jeremiah’s writing off the communities in Egypt as well as Judah has been taken as an indication that “Jeremiah was "), _c('em', [_vm._v("more frequently wrong than right")]), _vm._v(",”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2223",
      "id": "footnote-2223-backlink"
    }
  }, [_c('sup', [_vm._v("81")])]), _vm._v(" the existence of the story and messages in 40:1–44:30 suggests that we should not be literalistic in interpreting Jeremiah’s warnings in those chapters any more than in others; certainly the Judahite community in Egypt subsequently flourished."), _c('a', {
    attrs: {
      "href": "#/#footnote-2222",
      "id": "footnote-2222-backlink"
    }
  }, [_c('sup', [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A promise such as the one in 7:7 implicitly favors people living in Judah,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2221",
      "id": "footnote-2221-backlink"
    }
  }, [_c('sup', [_vm._v("83")])]), _vm._v(" but it need not have arisen or been preserved there. Conversely, when Jer 24 describes the people in Jerusalem who escaped the 597 exile as the bad figs (the figs with no future) and the 597 exiles as the good figs (the figs with a future), it would again be unwise to be literalistic in interpreting a comment that was devised to give a jolt to the people in Judah. In 587, the people who were the objects of that threat (the confident, prominent Jerusalemites) did have their comeuppance, and “while 24:8–10 promotes a perspective that the people left in the land are not the recipient of God’s promises, this visionary word was related to the first deportation in 597 BC and times can change things.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2220",
      "id": "footnote-2220-backlink"
    }
  }, [_c('sup', [_vm._v("84")])]), _vm._v(" Ezekiel 8 likewise attacks the Jerusalem community between 597 and 587 but hardly in itself provides a basis for inferring the “disenfranchisement” of people who remained in Judah after 587, though no doubt it could be used that way."), _c('a', {
    attrs: {
      "href": "#/#footnote-2219",
      "id": "footnote-2219-backlink"
    }
  }, [_c('sup', [_vm._v("85")])]), _vm._v(" Like Jer 24, Ezek 8 had a function in its context: to warn the 597 exiles against thinking that Yahweh’s action against Jerusalem was finished and they would soon be going home. The prayers in Lamentations suggest a different theology and spirituality in Judah after 587 from the one that Jeremiah and Ezekiel attack before 587. Conversely, Jeremiah also attacks the 597 exiles in Jer 29. Yahweh’s treating Babylon and its king as his servant does not mean Jeremiah is pro-Babylonian or favors the Judahites who have been exiled to Babylon."), _c('a', {
    attrs: {
      "href": "#/#footnote-2218",
      "id": "footnote-2218-backlink"
    }
  }, [_c('sup', [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The observation that “MT [of Jeremiah] is repeatedly oriented toward the Babylonian experience”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2217",
      "id": "footnote-2217-backlink"
    }
  }, [_c('sup', [_vm._v("87")])]), _vm._v(" does not emerge from the text. It is hard to find significant evidence that a recension of the Jeremiah scroll aimed to make the exiles in Babylon “the sole standard-bearer of Yahweh’s community in the future and to write off any participation in it by Judaeans who had emigrated to Egypt.” Such an aim is a “hidden exegetical content which has to be excavated; it is not given by the text and there is nothing explicit in the text which would lead us to conclude that the interests and claims of the Babylonian "), _c('em', [_vm._v("Gôlāh")]), _vm._v(" [exile community] are served by it.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2216",
      "id": "footnote-2216-backlink"
    }
  }, [_c('sup', [_vm._v("88")])]), _vm._v(" The text does not provide a basis for seeing the Babylonian community as the dynamic context in which the message and story of Jeremiah were preserved, developed, and curated."), _c('a', {
    attrs: {
      "href": "#/#footnote-2215",
      "id": "footnote-2215-backlink"
    }
  }, [_c('sup', [_vm._v("89")])]), _vm._v(" While it is possible to imagine someone taking the raw material for the Jeremiah scroll to Babylon and its being developed there, even without that assumption about the aim of the work, this understanding seems unnecessarily complicated. The more obvious view is that Egypt was one location of the process and Judah the other. And if the older version is the one translated into Greek (the more common scholarly view), it would follow that this version had its origin in Egypt—the home of the LXX, where as far as we know Jeremiah and Baruch ended up—while the background of the MT version was Judah."), _c('a', {
    attrs: {
      "href": "#/#footnote-2214",
      "id": "footnote-2214-backlink"
    }
  }, [_c('sup', [_vm._v("90")])]), _vm._v(" But all such possibilities are simply possibilities.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-5"
    }
  }, [_vm._v("V. CANONICITY")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Jeremiah claimed to speak a message from Yahweh and challenged people to respond to it as such. Few people before 587 did so; I have speculated that after the fall of Jerusalem, more did. The eventual wider recognition that he brought such a message and that it had purchase for a time long after his day made it influential on an ongoing basis for the community. The authority and canonicity of the Jeremiah scroll follow from the recognition that it records a message from Yahweh that lays down permanent expectations and offers long-standing insights.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-14"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("A. THE SCROLL AS MESSAGE FROM YAHWEH")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The word “message” points to a classic model for understanding a prophet’s position, role, and authority. Prophets commonly introduce their words by saying, “Yahweh has said this,” which corresponds to the way a messenger might introduce a message from a king (e.g., Isa 36:4, 14, 16). The prophet is Yahweh’s messenger bringing a word from the great King. The word has to be received as such. A messenger represents the king in a strong sense, speaking in his master’s name, using the king’s “I” as if he is the king, though he can switch between this form of speech and a more literal reference to his master as “he” (e.g., 2 Kgs 18:20, 23). Likewise, Jeremiah can move between “I, Yahweh” and “he, Yahweh” or “Yahweh’s affirmation” (e.g., 2:1–3). He can also move between addressing Judah or Jerusalem as “you” and speaking of them as “they” or “it.” His model for understanding his position can be himself as a human being talking with Yahweh (in which case Judah and Jerusalem are “they” or “it”) or it can be him speaking to them “as” Yahweh (in which case Judah and Jerusalem are “you”). The rhetorical effect of the two ways of speaking (the way they have an effect on Judah and Jerusalem) will then vary, but the claim is the same.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Sometimes one may not be able to tell the difference between Jeremiah speaking and Yahweh speaking. As Jer 5 unfolds, at some points the material makes a move from Jeremiah speaking to Yahweh speaking, but sometimes Jeremiah does not make the point of transition clear. One is tempted to try to identify the speaker each time, but Jeremiah’s failure to mark the transitions is not simply a mistake; whether Yahweh or Jeremiah is speaking doesn’t make any difference. It is always Jeremiah speaking, even when he speaks as Yahweh, and it is always Yahweh’s message, even when Jeremiah speaks in his own name. Like other prophets, Jeremiah is also sometimes not specific about who is addressed or about other transitions in accounts of things people say. It may be because he is not sure or because it keeps the audience on their toes or because the content is the important thing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The scroll’s introduction sets Jeremiah as Yahweh’s messenger in the context of a tumultuous half-century in the life of Judah. But its opening words (“the words of Jeremiah”) raise further questions in connection with what directly follows, which indicates that the scroll comprises more than Jeremiah’s words. It tells the story of Yahweh’s commissioning him, which includes his answering Yahweh back. So the phrase “the words of Jeremiah” needs interpreting loosely. A further distinctive feature of the scroll is the number of stories about Jeremiah that it tells. Jeremiah’s delivering his message was integral to the message itself. He embodied the straightness and care of Yahweh that were expressed in his words.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Even when Jeremiah speaks most explicitly in his own name and about himself, he is not sharing entries from a spiritual journal that is written for his own sake. The Jeremiah scroll is an account of his message (1:1–3), not a diary of his experiences or personal reflections that he formulates to help him understand what is going on. If he kept such a journal and includes excerpts from it in the scroll, he does so because they form part of Yahweh’s message to Judah and Jerusalem. His protests, too, are part of a scroll designed to convey a message for his people, not simply to record his personal agonizing. Nor is there any indication that Jeremiah might have received a divine rebuke for his protests (cf. Isa 45:9; Rom 9:20–21)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2213",
      "id": "footnote-2213-backlink"
    }
  }, [_c('sup', [_vm._v("91")])]), _vm._v(" Readers of the prayers and the protests in the scroll have to ask, how is this account of something from Jeremiah’s experience designed to function as Yahweh’s message? In 3:6–10, he reports a prose conversation in which Yahweh shares a reflection, which communicates with the audience in yet another way.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-15"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. THE SCROLL AND THE SCRIPTURES")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In due course, different Jewish communities came to recognize the importance of the collection of Jeremiah’s messages and the stories about him and to pay serious attention to it. The fall of Babylon in 539, the ascendancy of the Persians, the freedom of Judahites to go home to rebuild the temple, the arrival of the Greeks, and the troubles of the second century are beyond the scroll’s narrative horizon. But we know that people paid attention to the Jeremiah scroll during the Second Temple period."), _c('a', {
    attrs: {
      "href": "#/#footnote-2212",
      "id": "footnote-2212-backlink"
    }
  }, [_c('sup', [_vm._v("92")])]), _vm._v(" Second Chronicles ends with a quotation from Jeremiah, and Ezra begins with the same quotation, witnessing to creative interest in the scroll’s significance for events in the life of the Judahite community. Daniel 9 refers back to Jeremiah, engaging in greater hermeneutical creativity. While there are many cross allusions and virtual quotations within the Law, the Prophets, and the Writings—the Torah, Neviim, and Ketuvim; hence Tanak—the Jeremiah scroll is the only work within the Tanak that is explicitly quoted within the Tanak itself. In due course, anonymous Jews translated Jeremiah into Greek, revising it slightly or considerably, and created the letters of Baruch and Jeremiah preserved in the LXX. Qumran scribes copied it and created more “Jeremianic” writings."), _c('a', {
    attrs: {
      "href": "#/#footnote-2211",
      "id": "footnote-2211-backlink"
    }
  }, [_c('sup', [_vm._v("93")])]), _vm._v(" Jesus and his contemporaries read it (Mark 11:17; Matt 16:14), Paul quoted from it (1 Cor 1:31; 2 Cor 10:17; perhaps 1 Cor 2:9; 2 Cor 6:17), Matthew read it (Matt 2:17), Luke takes up the theme of the persecuted prophet, and Hebrews quotes it (8:8–12; 10:16–17)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2210",
      "id": "footnote-2210-backlink"
    }
  }, [_c('sup', [_vm._v("94")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One could say that recognizing the Jeremiah scroll in this way indicates that it has canonical status, though the word “canon” means different things in different contexts. The Greek word "), _c('em', [_vm._v("kanōn")]), _vm._v(" means a rule—something by which to measure things and thus to resolve disagreements. When the church came to apply this word to the Scriptures, it referred to a defined list of works, though not necessarily a closed or unalterable one. To ask whether the scroll is part of such a canon in the Second Temple period is anachronistic. We know virtually nothing about the process whereby a defined canon of Scriptures came into being or about anybody who decided which documents were in and which were out."), _c('a', {
    attrs: {
      "href": "#/#footnote-2209",
      "id": "footnote-2209-backlink"
    }
  }, [_c('sup', [_vm._v("95")])]), _vm._v(" Once there is a canon, Jeremiah is part of it, but we don’t know anything of how the scroll came to be recognized in this way. It was presumably among the Prophets to whom Jesus Ben Sira refers about 200 BC when he mentions “the Prophets” in the prologue to his teaching about “Wisdom.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In MT manuscripts, Jeremiah follows Isaiah, though "), _c('em', [_vm._v("B. Baba Batra")]), _vm._v(" 14b notes the logic of the order Jeremiah, Ezekiel, Isaiah:")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("The Scholars taught: The order of the Prophets is Joshua and Judges, Samuel and Kings, Jeremiah and Ezekiel, and Isaiah and the Twelve…. Now: Isaiah was before Jeremiah and Ezekiel; Isaiah should come first. But Kings ends with the destruction, and Jeremiah is all of it the destruction, and Ezekiel begins with the destruction but ends with the comfort, and Isaiah is all of it the comfort. We join the destruction to the destruction and the comfort to the comfort.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-16"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("C. THE JEREMIAH SCROLL IN THE CANONS OF JUDAISM AND OF THE CHURCH")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The communities of people who came to believe in Jesus accepted the Tanak as one aspect of their being in origin part of Judaism or an offshoot of Judaism, though that statement conceals both some looseness and some greater precision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One aspect of the looseness is that while the Scriptures to which the New Testament refers were at least roughly the same as the works that comprise the Tanak, we do not have evidence that the edges of those Scriptures were set in New Testament times. We do know that Jeremiah would have counted among them; it is quoted in Matt 2:17–18 in a way analogous to the quotations in Chronicles, Ezra, and Daniel. Another aspect of the looseness is that Christian congregations came to work with a broader collection of writings than the Tanak—one that included other works such as Wisdom and Tobit. More significantly for our present concern, its Jeremianic materials were both shorter and longer than the Jeremiah scroll in the Tanak. They were shorter in that this longer canon comprised works as they had been translated into Greek or had been written in Greek, and Greek Jeremiah is shorter than Hebrew Jeremiah (see “The Hebrew Text,” pp. 43–46). They were longer in that they included Baruch and the Letter of Jeremiah.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The greater precision relates to these differences. Many later Christian communities were careful to define the contents of the canon of Scripture. Thus the Anglican Thirty-Nine Articles lists the books that comprise the Tanak (but in the LXX’s order) then lists the “other books” such as Baruch (implicitly including the Letter of Jeremiah) as works read for edification but not to establish doctrine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Readings in synagogue worship include one from the Torah (they cover the whole over a year) and one from the Prophets, including Jeremiah (from which they include selections over a year). The Tanak is among a variety of canonical works in Judaism, along with the Mishnah, the Talmud, and the teaching of certain rabbis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Paradoxically, this precision coexisted with another form of looseness. As Jewish communities set the Tanak in the context of the Mishnah, the Talmud, and other works, Christian communities set “the Old Testament” (as they eventually came to call it) in the context of explicitly Christian writings, “the New Testament.” Christian communities read only tiny sections of a scroll such as Jeremiah in worship and hear few sermons on Jeremiah, and it has little influence on Christian theology, ethics, or spirituality. Occasionally, Christians implicitly deny Jeremiah’s canonical status—for instance, by questioning its portrayal of God or of prayer or of women or of attitudes to other nations. More often, they simply ignore Jeremiah and deny its canonical status in that way. This fact is especially regrettable in a context where the declining church in the United States is in a similar position to Judah in the late 600s and the declined church in Europe and elsewhere in the West is in a similar position to Judah after 587, while the growing church in Asia, Africa, and Latin America might be wise to see whether it can avoid going the way of these two. While Second Temple Judaism, the Qumran community, the New Testament, and the church fathers were not as interested in Jeremiah as they were in Isaiah or Daniel, the scroll’s finding a place in the Torah, the Prophets, and the Writings implies that it presents testimonies, messages, and stories that are God-breathed (2 Tim 3:16) in the sense that they are full of illumination for people living way after the time and the context in which they came into being. But we miss the fact that in various senses, Jeremiah is “a spokesman ‘out of time.’”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2208",
      "id": "footnote-2208-backlink"
    }
  }, [_c('sup', [_vm._v("96")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-6"
    }
  }, [_vm._v("VI. THE HEBREW TEXT")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The commentary in this volume follows the version of Jeremiah in the Leningrad (St. Petersburg) Codex of the MT, to which I refer as MT"), _c('sup', [_vm._v("L")]), _vm._v(". It is this text that appears in "), _c('em', [_vm._v("BHS")]), _vm._v(" and NJPS. It dates from about AD 1009. Its copyist was Samuel ben Jacob; he writes in one of its colophons, “With all my heart I did my work; my heart rejoices in my lot.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2207",
      "id": "footnote-2207-backlink"
    }
  }, [_c('sup', [_vm._v("97")])]), _vm._v(" Also from the ninth to eleventh centuries but less complete are the Aleppo Codex (which includes nearly all of Jeremiah and appears in HUBP), the Cairo Codex of the Prophets, the Petropolitan Codex of the Latter Prophets, and Sassoon Codex 1053."), _c('a', {
    attrs: {
      "href": "#/#footnote-2206",
      "id": "footnote-2206-backlink"
    }
  }, [_c('sup', [_vm._v("98")])]), _vm._v(" Our oldest copies of MT thus come from fifteen hundred years after Jeremiah’s day, and as is the case with any ancient document, our oldest copies of the Jeremiah scroll can hardly represent the original form of it. In order to get closer to that original form, one investigates other versions than MT.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-17"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("A. THE TWO VERSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Of the two major versions of the scroll, one in Hebrew preserved in MT and one translated into Greek and preserved in LXX, the Greek version is more than 10 percent shorter than the Hebrew version, though the continuation of the LXX Jeremianic material in Baruch and the Letter of Jeremiah (not to say Lamentations) makes up for that shortfall. There is a series of possible ways of understanding the relationship between the two versions, and all have their advocates: that MT is an expanded edition of the Hebrew underlying LXX (the most common view), that LXX represents an abbreviated edition of the Hebrew underlying MT,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2205",
      "id": "footnote-2205-backlink"
    }
  }, [_c('sup', [_vm._v("99")])]), _vm._v(" that LXX is sometimes older but sometimes represents abbreviation, or that both are independent recensions of an earlier text that we no longer have—which is my own working assumption."), _c('a', {
    attrs: {
      "href": "#/#footnote-2204",
      "id": "footnote-2204-backlink"
    }
  }, [_c('sup', [_vm._v("100")])]), _vm._v(" Apart from length, the most substantial difference between MT and LXX is that MT has the block of messages about foreign nations near the end of the scroll, immediately before the final chapter, whereas LXX locates it in the middle of the scroll, following ch. 25. Both locations make sense in different ways. The order of the messages within the block also varies between MT and LXX.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the translation notes, I draw attention to many of the detailed differences between MT and LXX, which usually consist in words that MT has but LXX lacks. MT keeps reminding us that we are reading something that is “Yahweh’s affirmation,” that Jeremiah is a “prophet” (in the context of Jeremiah’s own work in Judah, “prophet” was not necessarily a compliment), and that the God of whom the text speaks is “Yahweh of Armies.” MT sometimes repeats a message or part of a message, implying that it is significant in more than one context, whereas LXX lacks such repetitions."), _c('a', {
    attrs: {
      "href": "#/#footnote-2203",
      "id": "footnote-2203-backlink"
    }
  }, [_c('sup', [_vm._v("101")])]), _vm._v(" Sometimes the longer MT text may be seeking to clarify things and make explicit things that are implicit. It sometimes underlines the deserved nature of Yahweh’s action against Judah, and it introduces the designation of Nebuchadrezzar as “my servant” (see the commentary on 27:6). The significance of some other differences is harder to see, such as an inclination frequently to specify that the king of Babylon is Nebuchadrezzar, that Jeconiah is “ben Jehoiakim King of Judah,” or that Hananiah is also “a prophet.” MT often seems simply to like things to be filled out; LXX likes things more succinct. LXX may deliberately make things more concise, or it may be omitting things accidentally."), _c('a', {
    attrs: {
      "href": "#/#footnote-2202",
      "id": "footnote-2202-backlink"
    }
  }, [_c('sup', [_vm._v("102")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Whatever the right answer to the question of the two texts’ interrelationship, it is possible to study either in its own right."), _c('a', {
    attrs: {
      "href": "#/#footnote-2201",
      "id": "footnote-2201-backlink"
    }
  }, [_c('sup', [_vm._v("103")])]), _vm._v(" But comparing them helps to draw attention to special features of each. If LXX is based on an earlier version of the scroll than MT, a desire to get back to its earliest version generates special focus on LXX; an interest in a version that was further developed to articulate the scroll’s significance for people generates a focus on the Hebrew version that gained a place in the Tanak."), _c('a', {
    attrs: {
      "href": "#/#footnote-2200",
      "id": "footnote-2200-backlink"
    }
  }, [_c('sup', [_vm._v("104")])]), _vm._v(" It might be too much to say that “the duty of a commentator on the Hebrew text is to maintain the final form of the text in MT,”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2199",
      "id": "footnote-2199-backlink"
    }
  }, [_c('sup', [_vm._v("105")])]), _vm._v(" but it is a defensible stance. In this commentary I note ways in which LXX differs from MT but focus on MT.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-18"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. BEHIND THE MASORETIC TEXT")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Either the Greek or the Hebrew text may thus properly be studied in its own right, and greater appreciation of the integrity and distinctiveness of each version changes the focus of study. But for much of the twentieth century, a main focus in the study of LXX Jeremiah was the aim of getting behind MT to something nearer the original form of the scroll. Yet it is actually hard to define what we would mean by the original or most authentic form of a scriptural scroll, as can also be the case with modern works in the age of the word processor and the internet. You would hardly be interested in an earlier version of this commentary rather than the one you are reading. But difficulties in understanding MT and the existence of other versions of the text still encourage the study of the other versions with a view to getting behind it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("While there are many other copies of MT as well as the ones noted above, to which commentaries and the notes in "), _c('em', [_vm._v("BHS")]), _vm._v(" refer, they come from later in the medieval period, and it is unlikely that they preserve independent older versions of the text. I occasionally refer to them as “medieval manuscripts.” On the other hand, there are a number of earlier fragments of Jeremiah from the Cairo Geniza (they are to be distinguished from the Cairo Codex, which was named after Cairo because it was long kept there)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2198",
      "id": "footnote-2198-backlink"
    }
  }, [_c('sup', [_vm._v("106")])]), _vm._v(" And there are some fragments from Qumran, known as 2QJer and 4QJer, which as such are a millennium older than MT. Their text sometimes corresponds to MT and sometimes to a Hebrew text that one might see as lying behind LXX, which suggests that the Qumran community was acquainted with both versions of the scroll but also that MT does preserve a form of the text that is a millennium older than the actual MT manuscripts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("To gain access to older forms of the text than MT, we also have Greek translations later than LXX by Aquila, Symmachus, and Theodotion, as well as Jerome’s Latin translation known as the Vulgate, the Syriac translation known as the Peshitta, and the Aramaic translation known as Targum Jonathan (the words Vulgate and Peshitta both designate their translation as “the people’s”). On the assumption that we can work out from them what was the Hebrew text they were translating, those other textual traditions may put us on the track of a more intelligible text when MT Jeremiah is difficult to understand. And even when it is quite intelligible, they may put us on the track of an older text—though the various considerations I have noted about the relative independence of MT and LXX underline the care needed in connection with such extrapolation."), _c('a', {
    attrs: {
      "href": "#/#footnote-2197",
      "id": "footnote-2197-backlink"
    }
  }, [_c('sup', [_vm._v("107")])]), _vm._v(" As with LXX, these translations also enable us to see how they were interpreting the text, which can help us with our own interpretation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Four centuries ago, European scholars began making their own suggestions about ways in which the text might be restored to a more original form. Many of these suggestions appear in the notes to "), _c('em', [_vm._v("BHS")]), _vm._v(", and some of the possibilities raised by those other versions of the text and by modern scholars may indeed lead us to an earlier form of the text. On the other hand, some of the apparent difficulties likely reflect the fact that the scroll expresses itself elliptically or uses unusual words. It is impossible to have great conviction about where the text has become mistakenly changed and what suggestions one should accept for its restoration. If I were to base my reading of Jeremiah on my version of a restored form of the scroll, I would probably be right at some points but wrong at others, and there is no assurance that my version of the text overall would be better than MT"), _c('sup', [_vm._v("L")]), _vm._v(". More or less invariably in this commentary, then, I follow MT"), _c('sup', [_vm._v("L")]), _vm._v(" and try to make sense of it as it stands, though in the notes I draw attention to alternative versions of the text—especially readings that can be inferred from the old translations."), _c('a', {
    attrs: {
      "href": "#/#footnote-2196",
      "id": "footnote-2196-backlink"
    }
  }, [_c('sup', [_vm._v("108")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In following MT, I also generally work with MT’s punctuation and thus follow MT where it hyphenates words and they have only one stress. Although it is frequently tempting to rework the punctuation to produce a more consistent rhythm, I resist this temptation on the same assumption as I make regarding questions about the consonantal text and the vocalization: that it is unlikely that on the whole I will end up with a better text than the Masoretes have preserved. But in the notes, I sometimes draw attention to ways in which one could change the punctuation and thus make the rhythm more conventional. On the other hand, from time to time I feel free to rework MT’s divisions of verses and cola where a recognition that the verses are poetic lines suggests such changes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I use the term “units” to refer to the divisions within the text, as I identify them, whose size roughly corresponds to that of the medieval chapter divisions in printed Bibles. I use the term “sections” to refer to semi-complete sections within these units. Units and sections thus also roughly correspond to "), _c('em', [_vm._v("petuhot")]), _vm._v(" and "), _c('em', [_vm._v("setumot")]), _vm._v(" in the Qumran and MT Hebrew manuscripts. There, a "), _c('em', [_vm._v("petuhah")]), _vm._v(" is an “open” unit; at the end of a "), _c('em', [_vm._v("petuhah")]), _vm._v(", the line is left empty and the next "), _c('em', [_vm._v("petuhah")]), _vm._v(" begins on a new line. A "), _c('em', [_vm._v("setumah")]), _vm._v(" is a “closed” section; at the end of a "), _c('em', [_vm._v("setumah")]), _vm._v(" there is a space in the line, but the next "), _c('em', [_vm._v("setumah")]), _vm._v(" may then continue on the same line or put the space at the beginning of the next line. "), _c('em', [_vm._v("BHS")]), _vm._v(" and NJPS print a "), _c('em', [_vm._v("pe")]), _vm._v(" or a "), _c('em', [_vm._v("samek")]), _vm._v(" where in MT"), _c('sup', [_vm._v("L")]), _vm._v(" or MT"), _c('sup', [_vm._v("A")]), _vm._v(" there is a new line or a space."), _c('a', {
    attrs: {
      "href": "#/#footnote-2195",
      "id": "footnote-2195-backlink"
    }
  }, [_c('sup', [_vm._v("109")])]), _vm._v(" When I refer to a “unit marker” or “section marker,” I imply that MT"), _c('sup', [_vm._v("L")]), _vm._v(" and MT"), _c('sup', [_vm._v("A")]), _vm._v(" agree on its location; where they disagree about which kind of break occurs, I use the unqualified ambiguous expression “marker.” At Jer 8–9 and occasionally elsewhere, printed English Bibles and printed Hebrew Bibles vary in their chapter divisions: 8:1–23 in the Hebrew is 8:1–9:1 in the English. These differences are variant forms of the medieval chapter system; they do not denote differences between MT’s Hebrew text and the English translations (MT has no marker after 8:22 or after 9:1 [8:23]). Where necessary, I give the English reference followed by the Hebrew, as in the reference at the end of the previous sentence.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-7"
    }
  }, [_vm._v("VII. THEOLOGY")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The Jeremiah scroll has almost as broad and wide-ranging a set of theological assumptions and implications as the Torah, the Prophets, and the Writings as a whole. It offers its own take on the nature of God, on the theological significance of Israel, on God’s attitude to the nations, and on how to look at past, present, and future.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-19"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("A. THE GOD OF ISRAEL")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The God of the Jeremiah scroll is Yahweh, the God of Israel and the creator of the world, who claims sovereignty over both. Jeremiah offers no reason why he chose to be the God of a particular people or of this particular people. He might be quite happy with the nonanswer to this question in Deut 7, where Moses first affirms that it was not because Israel was so impressive that he chose it; he just did. He made a commitment to Israel’s ancestors and then he couldn’t get out of it if he wanted to. This “explanation” simply pushes the question back: why did he make such a commitment to Israel’s ancestors? Moses does not even go through the motions of answering that question. Jeremiah, too, goes behind Yahweh’s commitment to Israel to his commitment to its ancestors without purporting to explain it. Like Moses, Jeremiah focuses on the results of making it. It was because he made that commitment that he got the Israelites out of Egypt, looked after them in the wilderness, and gave them their land. Jeremiah does not consider the question whether he was being fair to the Canaanites any more than considering the basis for giving the land to the Israelites.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The God of the Jeremiah scroll is faithful, committed, caring, and compassionate. He is also angry, wrathful, and raging. He has those characteristics because—well, because he has those characteristics. In other words, when he acts in those ways, he is being himself, and he can hardly not be himself."), _c('a', {
    attrs: {
      "href": "#/#footnote-2194",
      "id": "footnote-2194-backlink"
    }
  }, [_c('sup', [_vm._v("110")])]), _vm._v(" His faithfulness ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("әdāqâ")]), _vm._v(") means he acts in the right way in relation to people who belong to him and to whom he belongs. He fulfills his promises. He protects. His commitment ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("esed")]), _vm._v(") goes beyond his faithfulness. It means that when his people have been unfaithful, he stays faithful. His caring ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ahăbâ")]), _vm._v(") means that he is love, not merely in the sense of an emotional response but in a self-giving sense. His compassion ("), _c('em', [_vm._v("ra")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ămîm")]), _vm._v(") means he has the feelings of a mother for the children of her womb ("), _c('em', [_vm._v("re")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("em")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("He is also characterized by anger, wrath, and rage. Jeremiah does not assume that there is anything inherently wrong with anger. The question is who exercises it and to what ends. Whereas the First Testament elsewhere suggests that anger is a subordinate or more marginal aspect of Yahweh’s character (e.g., Lam 3:33), Jeremiah offers no pointers in this direction. He rather emphasizes the monumental threat that Yahweh’s wrath constitutes for Judah. Yet he incidentally and unconsciously indicates that Yahweh’s bark is worse than his bite. Yahweh talks a lot about anger, but his actions fall far short of what the talk would make one expect.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The God of the Jeremiah scroll is insightful, sovereign, and powerful, while also interactive and resistible. He can make plans for events in the world and implement them, and when other people (such as Judah or Edom) think they can formulate policies and implement them, he can expose their pretentiousness. He can do as he likes in the world. Human “kings” exercise an authority and power that falls far short of the authority and power of the King. He is Yahweh of Armies, “a doxology in miniature that acclaims God as Divine Warrior leading the heavenly armies into battle.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2193",
      "id": "footnote-2193-backlink"
    }
  }, [_c('sup', [_vm._v("111")])]), _vm._v(" The greatest human king that people know he can treat as his servant, his agent in implementing his will in the world. Yet Jeremiah does not imply that everything that happens in the world issues from Yahweh’s will. Israel rather consistently ignores his wishes. His sovereignty is more theoretical than practical and more occasional than consistent. He works via human decision-making; Jeremiah speaks of no divine acts that do not work via human decision-making.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yahweh is the one who made the heavens and the earth by his insight and power. He is the only God. Like the rest of the First Testament, Jeremiah is not interested in monotheism in itself but in mono-Yahwism. He insists not that there is only one God but that Yahweh alone is God. Monotheism follows, but it is not the important issue. The important question is Yahweh’s own status, significance, and power over against other beings who are called gods. Jeremiah does not deny the existence of other gods; he rather declares that they are insignificant compared with Yahweh. They cannot do anything. Whereas other peoples believe it is possible to make images of their gods, Yahweh forbids the making of images of him. Jeremiah does not say it is impossible, nor does he give reasons for the ban, as Deuteronomy does, though he implies that the weakness of images is their being human-made.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s account of God raises for the church whether it takes seriously that he is a wrathful God and one active in world events, both of which convictions are accepted by the New Testament but not obvious in the church’s thinking and talk.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-20"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. THE ISRAEL OF GOD")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("In the expression “the God of Israel,” the word “of” is systematically ambiguous. Jeremiah does not describe Yahweh as the God of Assyria, Egypt, Babylon, Moab, or Elam, and he does not describe God as creating or providing for or revealing himself to these peoples. He does describe Yahweh as acting in their national lives, mostly by bringing calamity but also by restoring them to fullness of life. And they are ultimately destined to recognize Yahweh—more for his sake or for the sake of the truth than for their own sake. They are inclined to be reliant on their own resources and capacities and need to be disabused of such stupidity, though it is a stupidity no worse and no better than Israel’s. Not possessing the Torah or the words of prophets evidently does not leave them ignorant of what they ought to know in this connection.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But Israel is “my people.” The prominence of the word “people” ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("am")]), _vm._v(") in Jeremiah points to the fact that Yahweh’s primary relationship is with the people as a body as opposed to the individual. The name “Israel” then points to the fact that “people” suggests the community belonging together as a family—they have a shared genealogy as the descendants of Jacob/Israel. They are also a “nation” ("), _c('em', [_vm._v("gôy")]), _vm._v("), which is a less warm word, but suggests something more numerous than a family. It designates Israel as a political entity, an important aspect of Israel in Jeremiah’s day. They are Yahweh’s “domain” ("), _c('em', [_vm._v("na")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ălâ")]), _vm._v("), his particular and inalienable possession, like the domain of land that belongs to a family.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Such is the good news. The bad news is that occurrences of the phrase “my people” usually come in troublesome contexts—contexts that refer to their not behaving as “my people” and to Yahweh’s not treating them as “my people.” Although Yahweh is Israel’s God and Israel is Yahweh’s people (lit. “God for you” and “a people for me”), that formulation represents Yahweh’s original intention and his intention for the future (7:23; 11:4; 24:7; 30:22; 31:1, 33; 32:38) but not the present reality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The formulation does draw attention to the mutuality of relationship between Yahweh and Israel, though the two are not partners—or if they are, Israel is the junior partner. Rather, Israel is Yahweh’s servant (30:10; 46:27–28), though neatly, Jeremiah uses that word to suggest Israel’s security as Yahweh’s servant rather than its responsibility. With its worship, Israel is to serve him rather than serving other deities, which is its inclination (8:2; 16:11; 30:9).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Being Yahweh’s servant means both security and vulnerability. This master will not ultimately cast off his servant, but he will feel free to discipline him in quite severe ways. In Jeremiah, Israel is indeed threatened with drastic discipline, discipline that amounts to being wiped out. It is cut down and cut down and threatened with being cut down again. In the background is the cutting down that happened a century previously, when Israel was virtually reduced to the rump state of Judah. One might have thought that this decimation could never be reversed. But Jeremiah affirms that Yahweh will restore Ephraim as well as Judah. The master cannot get out of it, because of who he is. Yahweh thus lives with a tension over the word “remainder” or “remnant.” He threatens to cut Israel down even further, and does so, but he cannot actually eliminate it and promises to turn it into a numerous people again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("A family does not require kings or priests, perhaps not even prophets or experts. A nation does require them, and Israel has them. Their responsibility is to rule the nation in Yahweh’s way, to pass on his teaching, to bring his messages, to mediate his insight, and to facilitate its worship and service. Israel’s leaders comprehensively fail in these respects. Instead of enabling Israel to function as his servant, they hinder it. Yahweh’s response is not to abolish monarchy, priesthood, prophecy, and expertise. Part of the background is that here, too, he is bound by commitments he has made in the past, as is the case with his relationship to Israel. He made commitments to Levi and to David. As with Israel, then, he may take severe disciplinary action against the current holders of Levitical and Davidic office, but he does not cast off the line.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jesus and Paul give a similar account of Israel to Jeremiah’s, which raises for the church whether it takes seriously the status of the Jewish people for God. Jeremiah’s critique of Israel also raises the question whether he would address the church in the twenty-first century in a similar way."), _c('a', {
    attrs: {
      "href": "#/#footnote-2192",
      "id": "footnote-2192-backlink"
    }
  }, [_c('sup', [_vm._v("112")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-21"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("C. THE NATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Jeremiah’s commission is to be a prophet regarding the nations. The scroll uses several prepositions that can be translated “regarding” ("), _c('em', [_vm._v("lә")]), _vm._v(", "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(", "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("el")]), _vm._v("), which could denote “to,” “for,” “about,” or “against.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("There is no record of Jeremiah ever prophesying "), _c('em', [_vm._v("to")]), _vm._v(" foreign nations. In Jer 27, Yahweh commissions him to do so, but the story does not say that he does, which confirms that it is actually about his prophesying to Judah about the nations. The point is that the nations are important to Judah, and Yahweh’s dealings with them are important to Judah. Judah needs to understand what Yahweh is doing with the nations because of the significance of Yahweh’s actions for Judah’s relationship with Yahweh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Another apparent exception that proves the rule is that Jeremiah commissions Seraiah to read out his prophecies in Babylon (51:59–64). Again, there is no record of Seraiah’s doing so, and again the story appears in the scroll because of its importance to Judah. Further, Jeremiah does not say that the reading is to be done in Babylon’s hearing. It is to be done in Yahweh’s hearing. The story thus illustrates how Jeremiah prophesies "), _c('em', [_vm._v("against")]), _vm._v(" the nations. The purpose of reading out the prophecies is to get Yahweh to do as he has said in his pronouncements about Babylon. It will work because Yahweh answers such prayers and because Seraiah will perform a sign-act that will contribute to the implementing of the pronouncements. And Babylon does fall, though in nothing like the way Yahweh has said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah prophesies "), _c('em', [_vm._v("for")]), _vm._v(" as well as against the nations in the sense that he promises that Yahweh will restore them. He will no more eliminate them than he will eliminate Judah. Admittedly, he does not issue that promise about Babylon as he does about some other nations. But he does have mercy on Babylon in the sense that it does not get destroyed—even though it does lose its position as the center of an empire.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah prophesies "), _c('em', [_vm._v("about")]), _vm._v(" the nations in connection with the fact that they serve him, though they do not realize it. The point is explicit in connection with the great empire itself: Nebuchadrezzar is Yahweh’s servant. It is unfortunate for Judah, because he will serve Yahweh by bringing catastrophe to Judah for rebelling against Yahweh and rebelling against Babylon. In fulfillment of declarations by Jeremiah, 2 Chr 36 will describe a successor of his as in effect Yahweh’s servant in a way that is fortunate for Judah, because Cyrus will serve Yahweh by commissioning Judahites to go home to rebuild the temple.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The converse of Nebuchadrezzar’s being Yahweh’s servant is that Yahweh is Nebuchadrezzar’s master. He is Lord in relation to the nations. He has authority over them, and he has power over them. He is both for the nations as his servants and against them. He will demonstrate it by implementing the kind of proclamations that he issues in Jer 46–51, which contain promises as well as threats. A significant feature of those threats is the range of nations they concern:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Egypt, the old oppressor but also current threat or potential resource")]), _vm._v(" "), _c('li', [_vm._v("Philistia, Moab, Ammon, and Edom, the neighbors that might also be threats or temptations")]), _vm._v(" "), _c('li', [_vm._v("Kedar, Hazor, and Elam, far-off peoples that are irrelevant to Judah but are within Yahweh’s purview")]), _vm._v(" "), _c('li', [_vm._v("Babylon itself, the imperial power that rivals Yahweh and has brought such suffering to other peoples and such devastation to Zion")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah thus also prophesies about the nations because Yahweh wants Judah to look at them in the right way. Jeremiah implicitly agrees with Isaiah that Judah is neither to look to other nations as resources nor to be afraid of other nations as if they could bring Judah trouble—unless Yahweh wants them to do so, in which case Judah’s problem is Yahweh, not the nations.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The New Testament picks up Jeremiah’s theology of empire and thus raises questions for churches that are part of imperial nations while suggesting good news for churches within subaltern nations.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-22"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("D. THE PRESENT, THE PAST, AND THE FUTURE")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Although Jeremiah is not an exercise in narrative theology in the way that 2 Kings is, it is implicitly a narrative theology (the Gospels will take up the approach of 2 Kings, and Paul will take up the approach of Jeremiah). Its theology focuses on what Yahweh has done, is doing, and will do; it looks at the present in light of the past and the future and urges its readers to live their lives on that basis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the present, Judah looks to Yahweh to encourage the crops to grow and to help its women have children, but it does so in a way that pictures Yahweh rather like the "), _c('em', [_vm._v("bә")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ālîm")]), _vm._v("—the Masters. It may also consciously look to the Masters or other deities. And it looks to Egypt or other nations as resources in connection with its foreign policy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("In the present, it is thus ignoring the past. Its present is designed to be lived in light of the way Yahweh looked after it in the wilderness, the way it responded at that time, and the pledge that Yahweh made with it at that time. These events were designed to shape its theology, but “Jeremiah has to practice his ministry and his faith in a community alienated from and cut off from its founding, authorizing memory.” In addition, “the prophet is rooted in a powerful vision of an alternative future” that he needs to get it to heed."), _c('a', {
    attrs: {
      "href": "#/#footnote-2191",
      "id": "footnote-2191-backlink"
    }
  }, [_c('sup', [_vm._v("113")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s vision of the future is dominated by two great events: the day of Yahweh (though he uses that actual phrase only in 46:10) and the time when Yahweh will “bring about the restoration of Israel.” One might think of the second as a subset of the first; Israel was used to seeing Yahweh’s day as the time when his great positive purposes for Israel would be fulfilled in blessing and fruitfulness. Amos 5:18–20 presupposes that understanding, but Yahweh turns its implications upside-down. In line with Amos, Jeremiah thus speaks often of “that day” as a grave day, a day of dire trouble, a day of disaster, a day of distress (17:16–18; 18:17; 30:7). But “that day” can become the day of restoration (30:8). Indeed, on the one occasion when he uses the actual expression “the day of Yahweh,” it has regained the positive significance it had for Amos’s contemporaries and become the day when Yahweh takes action against Egypt. On the other hand, if Judah was trusting Egypt as its ally …")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“That day” and the day of restoration are not eschatological events in the sense of belonging in a far-off time or a different epoch or bringing history to an end. If they are, they nevertheless find embodiment in the meantime during current history, during this epoch, and during a time that is near. The fall of Jerusalem will be that day (Lam 1:12; 2:1, 21–22). Yahweh will make its grim reality become actual within Israel’s life; he will make the future become the present.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("But Yahweh will not let that negative action be his last one. People had not wholly misunderstood him when they looked forward to a great day of blessing. Now it will need to be the day when Yahweh brings about his people’s restoration. Yahweh announces it in 30:3, and the picture of the future that Jer 30–33 paints is implicitly a working out of the phrase’s implications. It will mean building and planting instead of demolishing and uprooting. It includes bringing Ephraim and Judah back to the country he gave to their ancestors and having them serve David (past and future come together). It includes liberation from the service of strangers, the healing of wounds, the rebuilding of Jerusalem, the planting of vineyards in Samaria and its people making pilgrimage to Zion, the realization of that vision that they should be a people for him and he should be God for them, and the making of a new pledge that includes the writing of the Torah into their minds. It includes forgiving and forgetting. Like the vision of Yahweh’s day, it is not eschatological in the sense of belonging in a far-off time or different epoch or in the sense of bringing history to an end. And as the threat of Yahweh’s day found an embodiment in the lives of the people to whom it was issued (or in the lives of their children and grandchildren), so the promise of restoration found an embodiment in the lives of the people to whom it was issued (or in the lives of their children and grandchildren).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The New Testament presupposes a “now but not yet” theology like Jeremiah’s that urges churches to live in light of both “now” and “not yet.”")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-8"
    }
  }, [_vm._v("VIII. MAIN THEMES AND THEIR IMPLICATIONS")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Broadly, the theology of the scroll as we have outlined it fits into that of the First Testament as a whole, and particularly the Latter Prophets."), _c('a', {
    attrs: {
      "href": "#/#footnote-2190",
      "id": "footnote-2190-backlink"
    }
  }, [_c('sup', [_vm._v("114")])]), _vm._v(" What of ways in which the scroll stands out? The scroll’s most distinctive theme is its focus on the prophet himself; the way people relate to him is an expression of their relationship to God. A second distinctive feature is the way he uses a range of images to describe God. That feature links with a third: that the scroll sees two sides to complex questions. One of its implications is thus that it equips readers to formulate a theology that is both inclusive and timely.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-23"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("A. THEOLOGY EMBODIED: JEREMIAH AS SUBJECT")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("In Jeremiah, the message—the word ("), _c('em', [_vm._v("haddābār")]), _vm._v(")—became flesh and dwelt among us, full of grace and truth. Some of the stories about Jeremiah that appear in the scroll are what have been called type scenes. Type scenes are stories about events that recur in human experience, so that the stories about them get told in similar ways. The kind of events are an annunciation, a birth, a betrothal, a wedding, a meal, a banquet, an appearing of God or another supernatural being, a dream, a death, a funeral, a coronation, an ordination, a cabinet meeting. A type scene gives an author the scaffolding for a story but also makes possible the construction of something with its own distinctive nature. The scroll begins with a notable example of a type scene: the commissioning of a prophet. Sometimes one can see a story in Jeremiah as a play with several acts and scenes and as raising questions that it then goes on to answer—or sometimes does not. Jeremiah 26 is an example; Jer 28 is a more spectacular one, with its plot relating how a prophet with an encouraging message drops dead—a story characterized by unpredictable and shocking drama, all within seventeen verses. These stories illustrate the key role played by dialogue in Hebrew narrative, and they are often vivid and full of circumstantial detail (such as people’s names). While their concreteness does not make it more likely that they are historical, any more than is the case with Jesus’s parables, it does reflect how the author is an engaging storyteller. A number of the stories about Jeremiah relate how he undertakes symbolic actions (Jer 13; 18; 19–20). Here, too, there is both scaffolding for the stories and variation. Each enables the communication and interpretation of the story.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The message of grace finds expression in Yahweh’s insistence on using Jeremiah to address Judah about its faithlessness, warn it about the catastrophe he intended to bring, and urge it to turn back to him in order that he need not do as he threatened. Its being a message of grace finds further expression in the way Jeremiah persists in doing so. Its being a message of truth finds expression in Jeremiah’s insistence on speaking with truthfulness and on living out the opposite of deceit or falseness. All these characteristics are embodied in Jeremiah’s person and life as well as in his words; he mediates the revelation of God through his person and his life. He also embodies what it means to respond to God. “The figure of Jeremiah assumes a paradigmatic value for his disciples.” He is not merely a hero to admire but a model of accepting the word of God in a time of crisis."), _c('a', {
    attrs: {
      "href": "#/#footnote-2189",
      "id": "footnote-2189-backlink"
    }
  }, [_c('sup', [_vm._v("115")])]), _vm._v(" Thus “the Book of Jeremiah does not so much teach religious truths as present a religious personality. Prophecy had already taught its truths, its last effort was to reveal itself in a life.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2188",
      "id": "footnote-2188-backlink"
    }
  }, [_c('sup', [_vm._v("116")])]), _vm._v(" Jeremiah’s life is crucial to his work and message.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Jeremiah may be the most embodied of the biblical prophets. His prophetic role clearly impacts his body. Once God’s words enter Jeremiah’s body, they burn within him (Jer 5:14), at times causing him delight (15:16), at times causing him physical distress (20:9). God commands Jeremiah not to marry and have children, thereby curtailing bodily pleasures and functions (16:2–3). Like other prophets, Jeremiah uses his body to communicate and engages in sign-acts. He wears and then buries linen underwear, smashes clay pots, and places a yoke around his neck (chs. 13, 18, 19, 27, 28). He also relies heavily on disturbing corporeal rhetoric such as the frequently evoked image of birds and beasts that consume Israel’s unburied dead (7:33, 16:4, 19:7, 22:19, 34:20). Another prominent feature of Jeremiah’s corporeal rhetoric is the image of the incurable sore."), _c('a', {
    attrs: {
      "href": "#/#footnote-2187",
      "id": "footnote-2187-backlink"
    }
  }, [_c('sup', [_vm._v("117")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s reports of his protests and his interactions with Yahweh are an aspect of the way his life is part of his message. “He is a metaphor for God’s word. Through him we see into God’s pathos and purpose and into the plight and destiny of the people.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2186",
      "id": "footnote-2186-backlink"
    }
  }, [_c('sup', [_vm._v("118")])]), _vm._v(" He is not the only figure in the scroll who is significant in this way: Baruch, Ebed-melech, and Uriah accompany him as people whose commitment risks their lives or costs their lives. The scroll thus reports the initiation of the way “the goodly fellowship of the prophets praise thee” and “the noble army of martyrs praise thee,” as the ancient Christian hymn "), _c('em', [_vm._v("Te Deum")]), _vm._v(" puts it.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-24"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. THEOLOGY IMAGED")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Prophets do much of their thinking in imagery. It is necessarily so. There are few things one can say literally about God and his relationship with us; we are bound to use metaphor in this connection. It is imagery that makes ideas possible. It enables us to think and see things and then to communicate them. Metaphor makes it possible to speak about things that we could not otherwise speak of; it also makes it possible to say more about things that we can speak of because we can speak of one thing we know in terms of another thing that we know. Jeremiah is comparable to Hosea in the extravagant profusion of his metaphorical thinking and language."), _c('a', {
    attrs: {
      "href": "#/#footnote-2185",
      "id": "footnote-2185-backlink"
    }
  }, [_c('sup', [_vm._v("119")])])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("God is king, and in different ways both the world and Israel are the people he governs. People must bow down before him. He has a cabinet. He sends messengers. He is commander-in-chief and sends his (heavenly and earthly) armies to bring trouble to rebels. He exercises authority. He makes pledges. He may listen to intercession.")]), _vm._v(" "), _c('li', [_vm._v("God is guide. He points out the path for people to walk. They must go after him rather than go after other guides (gods).")]), _vm._v(" "), _c('li', [_vm._v("God is master. People must serve him and not serve other masters.")]), _vm._v(" "), _c('li', [_vm._v("God is builder, but also destroyer.")]), _vm._v(" "), _c('li', [_vm._v("God is shepherd. He provides.")]), _vm._v(" "), _c('li', [_vm._v("God is father. He begets children. He adopts children. Israel belongs to his household. He passes on a domain.")]), _vm._v(" "), _c('li', [_vm._v("God is husband. He marries a wife. He commits himself to faithfulness and expects faithfulness. He is lord. He is jealous, and he objects to his wife whoring and committing adultery. He divorces.")]), _vm._v(" "), _c('li', [_vm._v("God is teacher. He expects attentiveness and obedience.")]), _vm._v(" "), _c('li', [_vm._v("God is farmer. He plants vines, olives, and figs. He expects fruit. He plants trees and fells them. He irrigates or withholds irrigation. He controls access to his garden and resents its invasion and attack. But he can devastate it if it fails to produce fruit. He has a farmhand.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s view of God is characterized by a “robustness” to which his use of imagery contributes."), _c('a', {
    attrs: {
      "href": "#/#footnote-2184",
      "id": "footnote-2184-backlink"
    }
  }, [_c('sup', [_vm._v("120")])]), _vm._v(" Yahweh is “an abandoned bridegroom, a water fountain, a betrayed father, a lion, a wolf, a leopard, a potter….”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2183",
      "id": "footnote-2183-backlink"
    }
  }, [_c('sup', [_vm._v("121")])]), _vm._v(" Jeremiah’s use of imagery thus contributes to another feature of the scroll: its resistance to speaking univocally. There are subjects on which it is unequivocal: Israel must serve Yahweh alone and must exercise authority with faithfulness. But on some other matters, it speaks with considerable diversity. Ironically, the moment of the postmodern turn at the end of the twentieth century was also a moment when some scholarly study of Jeremiah became puzzled by the complexity of the attitudes that the scroll takes to a number of questions. It was an irony because this complexity makes Jeremiah more of a postmodern book. It does not offer simple answers to simple questions or simple answers to complex questions. “The claim of theological incoherence in Jeremiah is often due to the theology of interpreters; something does not make sense from within their own theological framework.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2182",
      "id": "footnote-2182-backlink"
    }
  }, [_c('sup', [_vm._v("122")])]), _vm._v(" The scroll may speak in terms that are in tension with one another, and as readers we may prefer one to the other. Readers assess Jeremiah’s ideology in light of their own ideology."), _c('a', {
    attrs: {
      "href": "#/#footnote-2181",
      "id": "footnote-2181-backlink"
    }
  }, [_c('sup', [_vm._v("123")])]), _vm._v(" “Its combustible mix of politics and prophecy points to a Word of God that is dynamic, contextually responsive, and stubbornly resistant to commodification by any one group or ideology.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2180",
      "id": "footnote-2180-backlink"
    }
  }, [_c('sup', [_vm._v("124")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-25"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("C. THEOLOGY OF A BOTH-AND CHARACTER")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The robustness and diversity of Jeremiah’s portrait of God link with the both-and character of his proclamation as it emerges in connection with a series of questions raised by the scroll.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Is Yahweh chiefly characterized by anger or by love? I have suggested the answer to this question in considering “The God of Israel” (see p. 49). Love and faithfulness are key to Yahweh’s character, but he is capable of acting in wrath, and in Jeremiah’s day that capacity finds strong expression. While the idea that Yahweh punishes people can have a destructive effect on people who are traumatized by horrific experiences,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2179",
      "id": "footnote-2179-backlink"
    }
  }, [_c('sup', [_vm._v("125")])]), _vm._v(" the idea that Yahweh does not punish people might also have a destructive effect on them (so Heb 12). But maybe it is therefore significant that Jeremiah does not use the actual language of punishment or judgment (and hence I use words such as “catastrophe” and “calamity” rather than “judgment”). The scroll does not look at the relationship between God and humanity in the quasi-legal framework that has been common in Christian thinking since the medieval period. Its thinking is hierarchical but relational.")]), _vm._v(" "), _c('li', [_vm._v("Is catastrophe inevitable or can Judah avert it by turning to Yahweh?"), _c('a', {
    attrs: {
      "href": "#/#footnote-2178",
      "id": "footnote-2178-backlink"
    }
  }, [_c('sup', [_vm._v("126")])]), _vm._v(" Jeremiah gives both impressions in different contexts. Catastrophe is inevitable (if Judah carries on as it is). Judah must turn (catastrophe can then be avoided). There is no indication that either Jeremiah or Yahweh changes his mind about these possibilities at some point (e.g., when it becomes clear that Judah is not going to turn). It’s never over until it’s over. Jeremiah 36:3 makes explicit Yahweh’s aim in issuing his threats, and 18:1–11 provides a clue to interrelating the two possibilities.")]), _vm._v(" "), _c('li', [_vm._v("Will the catastrophe mean the destruction of Israel or simply its decimation? Whereas the scroll explicitly provides a way to look at the alternatives of inevitability or turning, it simply proclaims the possibility both of total annihilation and of decimation that leaves something. “I am going to make an end of them” ("), _c('em', [_vm._v("kālâ piel")]), _vm._v(", 14:12); “I will not make an end of you” (the noun "), _c('em', [_vm._v("kālâ")]), _vm._v(", 5:18). It seems unlikely that Jeremiah simply juxtaposed the two kinds of statements within the main years of his proclamation (see, e.g., 4:27) because the second undermines the force of the first. Perhaps the juxtaposition is an example of the development of the messages when the catastrophe had happened and people needed to be and could be reassured that Yahweh did not intend to bring about complete destruction—and did not do so. Perhaps Yahweh changed his mind about obliterating Israel. Perhaps he never intended to do so, and the first kind of statement involved a hyperbole. These possibilities interweave with questions raised by Jesus’s statements (e.g., Matt 21:43) and discussed in Rom 9–11.")]), _vm._v(" "), _c('li', [_vm._v("Does Yahweh intend simply to put down the Davidic monarchy, or will it be restored? Again the scroll simply juxtaposes these possibilities, but they can be part of a bigger picture: in the long term, Yahweh must be faithful to his promise to David, but that fact does not give any individual king a basis for assuming he can do as he likes and get away with it.")]), _vm._v(" "), _c('li', [_vm._v("Does Yahweh simply despise Israel’s worship, or can it be redeemed? Likewise, the scroll implies that the temple and its worship are part of the ongoing life of Israel, but Yahweh can be dismissive of the worship offered by a particular generation.")]), _vm._v(" "), _c('li', [_vm._v("Are other nations simply doomed, or is there hope for them? As I have already noted, in a number of cases the scroll makes clear that their prospects are the same as Israel’s.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("One implication of the scroll, then, is that it pushes readers to develop a theology that is both inclusive and timely. It recognizes that truth is complex and that theology needs to incorporate both-ands; it also pushes readers to perceive which of the both-ands needs bringing out now. A prophet is someone who “knows what time it is,”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2177",
      "id": "footnote-2177-backlink"
    }
  }, [_c('sup', [_vm._v("127")])]), _vm._v(" someone who can “distinguish whether a historical hour stands under the wrath or the love of God.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2176",
      "id": "footnote-2176-backlink"
    }
  }, [_c('sup', [_vm._v("128")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-9"
    }
  }, [_vm._v("IX. ANALYSIS OF CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("When Western readers start to read through books such as Isaiah or Jeremiah, they can be bemused. Without obvious logic, these prophetic scrolls switch between subjects, between prose and poetry, between God speaking and a prophet speaking, between addressing Israel and addressing God, between narrative and direct address, between threatening and promising, between foretelling and forthtelling, between what is imminent and what is far off. As a consequence, the prophetic scrolls can seem “virtually incomprehensible as "), _c('em', [_vm._v("books")]), _vm._v(".”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2175",
      "id": "footnote-2175-backlink"
    }
  }, [_c('sup', [_vm._v("129")])]), _vm._v(" The Jeremiah scroll is the longest of the prophetic scrolls, and it is all the more difficult to find one’s way around because its organization is less clear than that of the other prophetic scrolls. Indeed, one might infer that “"), _c('em', [_vm._v("the Book of")]), _vm._v(" "), _c('em', [_vm._v("Jeremiah is not a work made from whole cloth")]), _vm._v(". The book is not only without any discernible organization, on the contrary, there rules it a "), _c('em', [_vm._v("conspicuous")]), _vm._v(" "), _c('em', [_vm._v("lack of plan")]), _vm._v(".”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2174",
      "id": "footnote-2174-backlink"
    }
  }, [_c('sup', [_vm._v("130")])]), _vm._v(" Now premodern readers such as Jerome, Rashi, and Calvin apparently did not find Jeremiah unreadable, though it is not surprising that modern readers should find it difficult. It is more surprising if postmodern readers have this difficulty (as with the equivocal nature of its contents), because so much contemporary writing abjures logic and structure.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“The book of Jeremiah is an elaborate tapestry of meaning-making that honors complexity, delights in ambiguity, and relishes "), _c('em', [_vm._v("heteroglossia")]), _vm._v(" (Bakhtin’s term).” But “while this meaning-making map is wild and unwieldy, it is not formless.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2173",
      "id": "footnote-2173-backlink"
    }
  }, [_c('sup', [_vm._v("131")])]), _vm._v(" The scroll is bookended by a chapter relating how Jeremiah came to be a prophet and summarizing the nature of his message and a chapter telling of the fate of the Jerusalem to which he addressed that message. It then divides into two halves, with the first half dominated by messages and the second by stories. Jeremiah 25 both concludes the first half and opens the second."), _c('a', {
    attrs: {
      "href": "#/#footnote-2172",
      "id": "footnote-2172-backlink"
    }
  }, [_c('sup', [_vm._v("132")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-26"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("A. JEREMIAH 1–25")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("One difficulty that readers may feel when they work through the Jeremiah scroll is that “in the entire book the same argument keeps repeating.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2171",
      "id": "footnote-2171-backlink"
    }
  }, [_c('sup', [_vm._v("133")])]), _vm._v(" In response to the repetitiveness, commentators “tend perhaps to consider themselves not so much servants of the word as its sedulous critics, even its improvers.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2170",
      "id": "footnote-2170-backlink"
    }
  }, [_c('sup', [_vm._v("134")])]), _vm._v(" Over and over, Jeremiah declares that Judah is unfaithful to Yahweh and Yahweh intends to bring calamity upon it. One recalls the preacher who was asked why he kept repeating the same sermon: “When they listen to that one, I’ll preach another.” Jeremiah’s messages are variants on one theme. But the written collection of these messages does divide into a series of major sections, signaled by the opening phrase “The word that came to Jeremiah from Yahweh” or a variant on it:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Prologue")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("1:1–19")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  })])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 1")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("2:1–6:36")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Confrontation, Exhortation, Warning")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2a")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("7:1–10:25")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Exhortations and Exchanges")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2b")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("11:1–13:22")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Jeremiah’s Arguments")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2c")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("14:1–17:27")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Drought, Hunger, Sword")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2d")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("18:1–20:18")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Concerning Plans and Counsels")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2e")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("21:1–24:10")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("On Kings and Prophets")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("25:1–38")])]), _vm._v(" "), _c('td', {
    staticClass: "col45"
  }, [_c('p', {
    staticClass: "outline"
  })])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("At a formal level, this framework provides Jer 1–25 with some structuring. One way or another, each of the major sections opens with a prose account of a message for Jeremiah to deliver to Judah; each section then comprises mostly messages in poetry. The themes of the prose and the poetry are similar, and the same message indeed recurs through the different sections as Jeremiah tries different ways of getting his message home. The logic of Jer 1–25 corresponds to the perspective on Ephraim expounded in 2 Kgs 17:7–23:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Ephraim has served other gods.")]), _vm._v(" "), _c('li', [_vm._v("In doing so, it has ignored the prophets.")]), _vm._v(" "), _c('li', [_vm._v("Judah has acted in the same way.")]), _vm._v(" "), _c('li', [_vm._v("Its kings are especially to blame for Ephraim’s downfall."), _c('a', {
    attrs: {
      "href": "#/#footnote-2169",
      "id": "footnote-2169-backlink"
    }
  }, [_c('sup', [_vm._v("135")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The sections combine their repetitiveness with a subverting of the Judahites’ possible or actual assumptions, whereby they avoid the thrust of Jeremiah’s repeated message:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 1")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("begins by undermining assumptions about the exodus.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2a")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("begins by undermining assumptions about the temple.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2b")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("begins by undermining assumptions about Sinai.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2c")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("begins by undermining assumptions about prayer.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2d")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("begins by undermining assumptions about divine sovereignty.")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Part 2e")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("begins by undermining assumptions about David.")])])])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-27"
    }
  }, [_c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("B. JEREMIAH 25–52")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Whereas the first half of the scroll incorporates few dates, the second half is dominated by stories with dates that make clear that the stories cluster around 604, 597, and 587. The difficulty modern readers may then feel is that the chapters do not come in chronological order."), _c('a', {
    attrs: {
      "href": "#/#footnote-2168",
      "id": "footnote-2168-backlink"
    }
  }, [_c('sup', [_vm._v("136")])]), _vm._v(" “Dischrononologization represents a significant tactic of time management from chs. 21 to 51.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2167",
      "id": "footnote-2167-backlink"
    }
  }, [_c('sup', [_vm._v("137")])]), _vm._v(" It is again surprising if postmodern readers have difficulty with the chapters’ order, because we watch movies and television series that work in dramatic sequence rather than chronological sequence (“three weeks earlier,” “two years later”). The Jeremiah text points both to a reading as history and to a reading as drama."), _c('a', {
    attrs: {
      "href": "#/#footnote-2166",
      "id": "footnote-2166-backlink"
    }
  }, [_c('sup', [_vm._v("138")])]), _vm._v(" A dramatic order rather than a chronological order can both entertain and make the audience think, and it can make connections that would not otherwise be apparent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Like the first half of the scroll, the second half divides into major sections. On a broad canvas, the sequences are clear, though there is room for disagreement about some of the details:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col15",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Introduction "), _c('span', {
    staticClass: "tab"
  }, [_vm._v("25:1–38")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("Part 3")])]), _vm._v(" "), _c('td', {
    staticClass: "col25",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("The Die Cast and the Possibility of Restoration")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("a")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("26:1–29:32")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Stories about Prophets")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("b")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("30:1–33:26")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("At Last, a Focus on Hope")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("c")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("34:1–36:32")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Stories Implying a Reversion to Reality")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("Part 4")])]), _vm._v(" "), _c('td', {
    staticClass: "col70",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("The Calamity and the Aftermath")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("a")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("37:1–39:18")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Last Chances, Calamity, and a Footnote for Ebed-melech")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("b")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("40:1–45:5")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Aftermath, Missed Chances, and a Footnote for Baruch")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("Part 5")])]), _vm._v(" "), _c('td', {
    staticClass: "col70",
    attrs: {
      "colspan": "2"
    }
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Messages about Other Nations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("a")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("46:1–28")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Egypt")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("b")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("47:1–49:39")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Neighbors and Distant Peoples")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("c")])]), _vm._v(" "), _c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("50:1–51:64")])]), _vm._v(" "), _c('td', {
    staticClass: "col55"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Babylon")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15",
    attrs: {
      "colspan": "3"
    }
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Epilogue "), _c('span', {
    staticClass: "tab"
  }, [_vm._v("52:1–34")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("One feature of the scroll’s second half is a series of false endings: Jer 33 might seem like an end, so might Jer 36, so might Jer 39, so might Jer 45, and so might Jer 51."), _c('a', {
    attrs: {
      "href": "#/#footnote-2165",
      "id": "footnote-2165-backlink"
    }
  }, [_c('sup', [_vm._v("139")])]), _vm._v(" The placing of Jer 30–33 shows that one cannot suggest that “the book of Jeremiah moves along a plot trajectory from judgment to restoration.” Indeed, actually “it would be difficult to argue convincingly for a large-scale plot unfolding from judgment to salvation in the book. The prophetic diction of chaos, terror, divine fury, and grievous loss controls the tenor of the book from beginning to end.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2164",
      "id": "footnote-2164-backlink"
    }
  }, [_c('sup', [_vm._v("140")])]), _vm._v(" At the same time, Jer 30–33 does qualify the gloom, and the second half of the scroll does manifest a suggestive sequence of doom on Judah (chs. 26–45), on other nations (chs. 46–49), and on Babylon (chs. 50–51)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2163",
      "id": "footnote-2163-backlink"
    }
  }, [_c('sup', [_vm._v("141")])]), _vm._v(" And the closing chapter has notes of hope that do not quite count as a Hollywood ending but do mitigate the gloom that would obtain if the scroll ended with the fall of Jerusalem or the killing of Gedaliah and its aftermath.")]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2303-backlink",
      "id": "footnote-2303"
    }
  }, [_vm._v("1")]), _vm._v(". Formulating dates for Israelite kings raises difficulties. Many kings appointed their successors to reign jointly with them, presumably in part to ensure the succession; thus, the dates of reigns can overlap. Manasseh had apparently reigned as co-king with Hezekiah since about 697. Date formulations in modern books may also vary by a year because the Jewish year starts at a different point from the Western year (and sometimes in the spring, sometimes in the fall; see the commentary on 36:9) and because formulations vary over whether a king’s accession year counts as his first actual year.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2302-backlink",
      "id": "footnote-2302"
    }
  }, [_vm._v("2")]), _vm._v(". For these events and the ones in the next paragraph, see, e.g., O. Lipschits, "), _c('em', [_vm._v("The Fall and Rise of Jerusalem: Judah under Babylonian Rule")]), _vm._v(" (Winona Lake, IN: Eisenbrauns, 2005), 11–35.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2301-backlink",
      "id": "footnote-2301"
    }
  }, [_vm._v("3")]), _vm._v(". I will use this English form of the name, reflecting the Hebrew form that usually appears in Jeremiah, except in connection with Jer 27–29, where the form Nebuchadnezzar appears; see the translation note on 21:2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2300-backlink",
      "id": "footnote-2300"
    }
  }, [_vm._v("4")]), _vm._v(". A. G. Shead takes up this opening phrase of the scroll in his study of “The Word of God in the Words of Jeremiah,” the subtitle of "), _c('em', [_vm._v("A Mouth Full of Fire")]), _vm._v(", New Studies in Biblical Theology 9 (Nottingham: Apollos, 2012).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2299-backlink",
      "id": "footnote-2299"
    }
  }, [_vm._v("5")]), _vm._v(". E. K. Holt, “Word of Jeremiah—Word of God,” in "), _c('em', [_vm._v("Uprooting and Planting: Essays on Jeremiah for Leslie")]), _vm._v(" "), _c('em', [_vm._v("Allen")]), _vm._v(", ed. J. Goldingay, LHBOTS 459 (London: T&T Clark 2007), 172–89.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2298-backlink",
      "id": "footnote-2298"
    }
  }, [_vm._v("6")]), _vm._v(". In Jeremiah, “the means for marking DD [direct divine discourse] are the most varied, unpredictable, and … chaotic of any book in the Hebrew Bible” (S. A. Meier, "), _c('em', [_vm._v("Speaking of Speaking: Marking Direct Discourse in the Hebrew Bible")]), _vm._v(", VTSup 46 [Leiden: Brill, 1992], 258).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2297-backlink",
      "id": "footnote-2297"
    }
  }, [_vm._v("7")]), _vm._v(". R. Davidson, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", The Daily Study Bible (Edinburgh: Saint Andrew, 1985), 1:1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2296-backlink",
      "id": "footnote-2296"
    }
  }, [_vm._v("8")]), _vm._v(". With apologies to A. C. Thiselton, "), _c('em', [_vm._v("The Two Horizons")]), _vm._v(" (Grand Rapids: Eerdmans, 1980), though he adapted the image from H.-G. Gadamer, "), _c('em', [_vm._v("Truth and Method")]), _vm._v(" (New York: Crossroad, 1975).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2295-backlink",
      "id": "footnote-2295"
    }
  }, [_vm._v("9")]), _vm._v(". D. R. Jones, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", The New Century Bible Commentary (Grand Rapids: Eerdmans, 1992), 96.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2294-backlink",
      "id": "footnote-2294"
    }
  }, [_vm._v("10")]), _vm._v(". E.g., R. P. Carroll, “Radical Clashes of Will and Style,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 45 (1989): 99–100; “Arguing about Jeremiah,” in "), _c('em', [_vm._v("Congress Volume: Leuven 1989")]), _vm._v(", ed. J. A. Emerton, VTSup 43 (Leiden: Brill, 1991), 229–33.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2293-backlink",
      "id": "footnote-2293"
    }
  }, [_vm._v("11")]), _vm._v(". Cf. F. Lippke, “Ancient Editing and the Coherence of Traditions within the Book of Jeremiah and throughout the "), _c('em', [_vm._v("nby’im")]), _vm._v(",” in "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(", ed. H. Najman and K. Schmid, JSJSup 173 (Leiden: Brill, 2016), 49–52.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2292-backlink",
      "id": "footnote-2292"
    }
  }, [_vm._v("12")]), _vm._v(". I thus do not work with the assumption that distinguishing between poetry and prose, and then between prose messages and narratives, is key to studying the scroll—an assumption that has been basic to Jeremiah scholarship since Duhm’s commentary ("), _c('em', [_vm._v("Das Buch Jeremia")]), _vm._v(", Kurzer Hand-Commentar zum Alten Testament 11 [Tübingen: Mohr Siebeck, 1901]) and S. Mowinckel’s "), _c('em', [_vm._v("Zur Komposition des Buches Jeremia")]), _vm._v(" (Kristiania: Dybward, 1914). Indeed, L. Stulman has noted that, in effect, though the world of scholarship has concluded that the twentieth-century framework for the study of Jeremiah was fundamentally flawed, it has carried on using it all the same (“Reflections on the Prose Sermons in the Book of Jeremiah,” in "), _c('em', [_vm._v("Bible Through the Lens of Trauma")]), _vm._v(", ed. E. Boase and C. G. Frechete, Semeia Studies 38 [Atlanta: SCM, 2016], 127–30). See further J. M. Henderson, "), _c('em', [_vm._v("Jeremiah under the Shadow of Duhm: A Critique of the Use of Poetic Form as a Criterion of Authenticity")]), _vm._v(", T&T Clark Biblical Studies (London: T&T Clark, 2019); D. Rom-Shiloni, “From Prophetic Words to Prophetic Literature: Challenging Paradigms That Control Our Academic Thought on Jeremiah and Ezekiel,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 138 (2019), 565–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2291-backlink",
      "id": "footnote-2291"
    }
  }, [_vm._v("13")]), _vm._v(". See the survey in B. E. Kelle, “The Phenomenon of Israelite Prophecy in Contemporary Scholarship,” "), _c('em', [_vm._v("CurBR")]), _vm._v(" 12 (2013): 296–300.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2290-backlink",
      "id": "footnote-2290"
    }
  }, [_vm._v("14")]), _vm._v(". E. W. Nicholson, "), _c('em', [_vm._v("Preaching to the Exiles: A Study of the Prose Tradition in the Book of Jeremiah")]), _vm._v(" (Oxford: Blackwell, 1970).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2289-backlink",
      "id": "footnote-2289"
    }
  }, [_vm._v("15")]), _vm._v(". J. Calvin, "), _c('em', [_vm._v("Commentary on Jeremiah and Lamentations")]), _vm._v(", trans. John Owen, 5 vols. (repr., Grand Rapids: Christian Classics Ethereal Library), 4:3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2288-backlink",
      "id": "footnote-2288"
    }
  }, [_vm._v("16")]), _vm._v(". See, e.g., a number of the papers in Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v("; C. J. Sharp, "), _c('em', [_vm._v("Prophecy and Ideology in Jeremiah: Struggles for Authority in the Deutero-Jeremianic Prose")]), _vm._v(", Old Testament Studies (London: T&T Clark, 2003), esp. 1–39; W. L. Holladay, “Elusive Deuteronomists, Jeremiah, and Proto-Deuteronomy,” "), _c('em', [_vm._v("CBQ")]), _vm._v(" 66 (2004): 55–77; M. J. Williams, “An Investigation of the Legitimacy of Source Distinctions for the Prose Material in Jeremiah,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 112 (1993): 193–210.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2287-backlink",
      "id": "footnote-2287"
    }
  }, [_vm._v("17")]), _vm._v(". Cf. C. L. Crouch, "), _c('em', [_vm._v("An Introduction to the Study of Jeremiah")]), _vm._v(" (London: T&T Clark, 2017), 48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2286-backlink",
      "id": "footnote-2286"
    }
  }, [_vm._v("18")]), _vm._v(". See, e.g., N. Mastnjak"), _c('em', [_vm._v(", Deuteronomy and the Emergence of Textual Authority in Jeremiah")]), _vm._v(", FAT 2/87 (Tübingen: Mohr Siebeck, 2016).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2285-backlink",
      "id": "footnote-2285"
    }
  }, [_vm._v("19")]), _vm._v(". E.g., J. A. Thompson, "), _c('em', [_vm._v("The Book of Jeremiah")]), _vm._v(", NICOT (Grand Rapids: Eerdmans, 1980), 37, 38; S.-M. Kang, “The Authentic Sermon on Jeremiah in Jeremiah 7:1–20,” in "), _c('em', [_vm._v("Texts, Temples, and Traditions: Tribute to Menahem")]), _vm._v(" "), _c('em', [_vm._v("Haran")]), _vm._v(", ed. M. V. Fox et al. (Winona Lake, IN: Eisenbrauns, 1996), 147–62; Sharp, "), _c('em', [_vm._v("Prophecy and Ideology in Jeremiah")]), _vm._v(", 8, 45, 106.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2284-backlink",
      "id": "footnote-2284"
    }
  }, [_vm._v("20")]), _vm._v(". E.g., W. L. Holladay, "), _c('em', [_vm._v("A Commentary on the Book of the Prophet Jeremiah")]), _vm._v(", 2 vols., Hermeneia (Philadelphia: Fortress, 1986; Minneapolis: Fortress, 1989), 2:165.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2283-backlink",
      "id": "footnote-2283"
    }
  }, [_vm._v("21")]), _vm._v(". See, e.g., J. M. Bos, “The ‘Literarization’ of the Biblical Prophecy of Doom,” in "), _c('em', [_vm._v("Contextualizing Israel’s Sacred Writing: Ancient Literacy, Orality, and Literary Production")]), _vm._v(", ed. B. B. Schmidt, AIIL 22 (Atlanta: Society of Biblical Literature, 2015), 263–65; M. Nissinen, “How Prophecy Became Literature,” "), _c('em', [_vm._v("SJOT")]), _vm._v(" 19 (2005): 153–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2282-backlink",
      "id": "footnote-2282"
    }
  }, [_vm._v("22")]), _vm._v(". R. E. Clements, “Jeremiah 1–25 and the Deuteronomistic History,” in "), _c('em', [_vm._v("Understanding Poets and Prophets: Essays in Honour of George Wishart Anderson")]), _vm._v(", ed. A. G. Auld, JSOTSup 152 (Sheffield: JSOT, 1993), 93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2281-backlink",
      "id": "footnote-2281"
    }
  }, [_vm._v("23")]), _vm._v(". See, e.g., K. van der Toorn, "), _c('em', [_vm._v("Scribal Culture and the Making of the Hebrew Bible")]), _vm._v(" (Cambridge, MA: Harvard University Press, 2007).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2280-backlink",
      "id": "footnote-2280"
    }
  }, [_vm._v("24")]), _vm._v(". Carroll, “Arguing about Jeremiah,” 234.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2279-backlink",
      "id": "footnote-2279"
    }
  }, [_vm._v("25")]), _vm._v(". See Lipschits, "), _c('em', [_vm._v("Fall and Rise of Jerusalem")]), _vm._v("; E. Meyers, “Exile and Restoration in Light of Recent Archaeology and Demographic Studies,” in "), _c('em', [_vm._v("Exile and Restoration Revisited: Essays on the Babylonian and Persian Periods in Memory of Peter R. Ackroyd")]), _vm._v(", ed. G. N. Knoppers, L. L. Grabbe, and D. Fulton, The Library of Second Temple Studies 73 (London: T&T Clark, 2009), 166–73.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2278-backlink",
      "id": "footnote-2278"
    }
  }, [_vm._v("26")]), _vm._v(". The word “theodicy” is often used in this connection: the word comes about eighteen times in A. R. P. Diamond’s commentary on Jer 1–10 (“Jeremiah,” in "), _c('em', [_vm._v("Eerdmans Commentary on the Bible")]), _vm._v(", ed. J. D. G. Dunn and J. W. Rogerson [Grand Rapids: Eerdmans, 2003], 548–65); see also A. R. P. Diamond, "), _c('em', [_vm._v("The Confessions of Jeremiah in Context: Scenes of Prophetic Drama")]), _vm._v(", JSOTSup 45 (Sheffield: Sheffield Academic, 1987), e.g., 189–91 on Jer 11–20. See my introductory comment on 11:1–13:22 below.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2277-backlink",
      "id": "footnote-2277"
    }
  }, [_vm._v("27")]), _vm._v(". Cf. T. Römer, “The Formation of the Book of Jeremiah as a Supplement to the So-Called Deuteronomistic History,” in "), _c('em', [_vm._v("The Production of Prophecy: Constructing Prophecy and Prophets in Yehud")]), _vm._v(", ed. D. V. Edelman and E. Ben Zvi (London: Equinox, 2009), 168–83, though he dates both in the Persian period.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2276-backlink",
      "id": "footnote-2276"
    }
  }, [_vm._v("28")]), _vm._v(". K. M. O’Connor, “Surviving Disaster in the Book of Jeremiah,” "), _c('em', [_vm._v("WW")]), _vm._v(" 22 (2002): 369–70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2275-backlink",
      "id": "footnote-2275"
    }
  }, [_vm._v("29")]), _vm._v(". K. M. O’Connor, “How Trauma Studies Can Contribute to Old Testament Studies,” in "), _c('em', [_vm._v("Trauma and Traumatization in Individual and Collective Dimensions: Insights from Biblical Studies and Beyond")]), _vm._v(", ed. E.-M. Becker, J. Dochhorn, and E. K. Holt, Studia Aarhusiana Neotestamentica 2 (Göttingen: Vandenhoeck & Ruprecht, 2014), 210; "), _c('em', [_vm._v("Jeremiah: Pain and Promise")]), _vm._v(" (Minneapolis: Fortress, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2274-backlink",
      "id": "footnote-2274"
    }
  }, [_vm._v("30")]), _vm._v(". A. R. P. Diamond and L. Stulman, “Analytical Introduction,” in "), _c('em', [_vm._v("Jeremiah (Dis)placed")]), _vm._v(", ed. A. R. P. Diamond and L. Stulman, LHBOTS 529 (London: T&T Clark, 2011), 3. The authors of this quotation do rather object, and H.-J. Stipp responds to them in “‘But into the Water You Must Not Dip It,’” in "), _c('em', [_vm._v("Thinking of Water in the Early Second Temple Period")]), _vm._v(", ed. E. Ben Zvi and C. Levin, BZAW 461 (Berlin: de Gruyter, 2014), 167–95; he says in effect that even if we are never going to agree on the nature of the redactional process in Jeremiah, he is going to do it anyway (170). For that decision, see also, e.g., R. P. Carroll, “Synchronic Deconstructions of Jeremiah,” in "), _c('em', [_vm._v("Synchronic or Diachronic: A Debate on Method in Old Testament Exegesis")]), _vm._v(", ed. J. C. de Moor, OTS 34 (Leiden: Brill, 1995), 39–51.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2273-backlink",
      "id": "footnote-2273"
    }
  }, [_vm._v("31")]), _vm._v(". D. K. Jobling notes analogies between Jeremiah research and Jesus research in “The Quest of the Historical Jeremiah,” "), _c('em', [_vm._v("Union Seminary Quarterly Review")]), _vm._v(" 34 (1978): 3–12; cf. R. P. Carroll, "), _c('em', [_vm._v("Jeremiah: A Commentary")]), _vm._v(", OTL (London: SCM, 1986), 63. Oddly, Carroll refers specifically to the synoptic Gospels even though John provides a closer model for his understanding of Jeremiah.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2272-backlink",
      "id": "footnote-2272"
    }
  }, [_vm._v("32")]), _vm._v(". R. P. Carroll, “Arguing about Jeremiah,” 229.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2271-backlink",
      "id": "footnote-2271"
    }
  }, [_vm._v("33")]), _vm._v(". See H. W. Frei’s exploration of the development of thinking about biblical narrative during the eighteenth and nineteenth centuries in "), _c('em', [_vm._v("The Eclipse of Biblical Narrative")]), _vm._v(" (New Haven: Yale University Press, 1974).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2270-backlink",
      "id": "footnote-2270"
    }
  }, [_vm._v("34")]), _vm._v(". But cf., e.g., J. R. Lundbom, "), _c('em', [_vm._v("Jeremiah 1–20: A New Translation with Introduction and Commentary")]), _vm._v(", AB 21A (New York: Doubleday, 1999), 100–101; M. Leuchter, "), _c('em', [_vm._v("The Polemics of Exile in Jeremiah 26–45")]), _vm._v(" (Cambridge: Cambridge University Press, 2008), 1–17; for the opposite view, see, e.g., essays in Edelman and Ben Zvi, "), _c('em', [_vm._v("Production of Prophecy")]), _vm._v("; J. Hill, “The Book of Jeremiah (MT) and Its Early Second Temple Background,” in Goldingay, "), _c('em', [_vm._v("Uprooting and Planting")]), _vm._v(", 153–71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2269-backlink",
      "id": "footnote-2269"
    }
  }, [_vm._v("35")]), _vm._v(". See, e.g., S. V. Davidson, "), _c('em', [_vm._v("Empire and Exile: Postcolonial Readings of the Book of Jeremiah,")]), _vm._v(" LHBOTS 542 (London: T&T Clark, 2011).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2268-backlink",
      "id": "footnote-2268"
    }
  }, [_vm._v("36")]), _vm._v(". See, e.g., R. P. Carroll, “Jeremiah, Intertextuality and Ideologiekritik,” "), _c('em', [_vm._v("JNSL")]), _vm._v(" 22 (1996): 15–34.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2267-backlink",
      "id": "footnote-2267"
    }
  }, [_vm._v("37")]), _vm._v(". This question may be posed in connection with the question of gender, on which the Jeremiah scroll works with the gender assumptions of its culture while also deconstructing, harnessing, or subverting them (see, e.g., 3:7 and the comment), and one may interweave the two questions: see C. M. Maier and C. J. Sharp, eds., "), _c('em', [_vm._v("Prophecy and Power: Jeremiah in Feminist and Postcolonial Perspective")]), _vm._v(", LHBOTS 577 (London: T&T Clark, 2013); M. E. Mills, "), _c('em', [_vm._v("Jeremiah: An Introduction and Study Guide; Prophecy in a Time of Crisis")]), _vm._v(" (London: T&T Clark, 2015), 70–82.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2266-backlink",
      "id": "footnote-2266"
    }
  }, [_vm._v("38")]), _vm._v(". R. P. Carroll, "), _c('em', [_vm._v("Jeremiah,")]), _vm._v(" Old Testament Guides (Sheffield: JSOT, 1989), 98.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2265-backlink",
      "id": "footnote-2265"
    }
  }, [_vm._v("39")]), _vm._v(". See, e.g., R. P. Carroll: "), _c('em', [_vm._v("Jeremiah: A Commentary")]), _vm._v(", 65–82.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2264-backlink",
      "id": "footnote-2264"
    }
  }, [_vm._v("40")]), _vm._v(". D. Rom-Shiloni, “Group Identities in Jeremiah,” in "), _c('em', [_vm._v("A Palimpsest: Rhetoric, Ideology, Stylistics and Language Relating to Persian Israel")]), _vm._v(", ed. E. Ben Zvi, D. Edelman, and F. Polak (Piscataway, NJ: Gorgias, 2009), 11–46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2263-backlink",
      "id": "footnote-2263"
    }
  }, [_vm._v("41")]), _vm._v(". D. Rom-Shiloni, “"), _c('em', [_vm._v("Exclusive Inclusivity")]), _vm._v(", the Transparent and the Invisible,” "), _c('em', [_vm._v("JHS")]), _vm._v(" 18/1 (2018): 76–77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2262-backlink",
      "id": "footnote-2262"
    }
  }, [_vm._v("42")]), _vm._v(". See, e.g., A. Hornkohl, "), _c('em', [_vm._v("Ancient Hebrew Periodization and the Language of the Book of Jeremiah: The Case for a Sixth-Century Date of Composition")]), _vm._v(", Studies in Semitic Languages and Linguistics 74 (Leiden: Brill, 2014); R. Hendel and J. Joosten, "), _c('em', [_vm._v("How Old Is the Hebrew Bible?")]), _vm._v(" (New Haven: Yale University, 2018); M. Tafferner, “The Linguistic Date of the Masoretic Extensions in the Book of Jeremiah” (paper presented at the Annual Meeting of the Evangelical Theological Society, San Antonio, TX, 15 November 2016); for the contrary view, see R. Rezetko, “The (Dis)Connection between Textual and Linguistic Developments in the Book of Jeremiah,” in "), _c('em', [_vm._v("Empirical Models Challenging Biblical Criticism")]), _vm._v(", ed. R. F. Person and R. Rezetko, AIIL 25 (Atlanta: Society of Biblical Literature, 2016), 239–69.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2261-backlink",
      "id": "footnote-2261"
    }
  }, [_vm._v("43")]), _vm._v(". Cf. L.-S. Tiemeyer, “Will the Prophetic Texts from the Hellenistic Period Stand Up, Please?” in "), _c('em', [_vm._v("Judah Between East and West: The Transition from Persian to Greek Rule (ca. 400–200 BCE)")]), _vm._v(", ed. O. Lipschits and L. L. Grabbe, The Library of Second Temple Studies 75 (London: T&T Clark, 2012), 255–79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2260-backlink",
      "id": "footnote-2260"
    }
  }, [_vm._v("44")]), _vm._v(". J. G. McConville, “Jeremiah: Prophet and Book,” "), _c('em', [_vm._v("TynB")]), _vm._v(" 42 (1991): 85.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2259-backlink",
      "id": "footnote-2259"
    }
  }, [_vm._v("45")]), _vm._v(". O. Keel, "), _c('em', [_vm._v("Jerusalem and the One God: A Religious History")]), _vm._v(" (Minneapolis: Fortress, 2017), 135–36.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2258-backlink",
      "id": "footnote-2258"
    }
  }, [_vm._v("46")]), _vm._v(". Diamond, “Jeremiah,” 572.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2257-backlink",
      "id": "footnote-2257"
    }
  }, [_vm._v("47")]), _vm._v(". E. Ben Zvi, “The Concept of Prophetic Books and Its Historical Setting,” in Edelman and Ben Zvi, "), _c('em', [_vm._v("Production of Prophecy")]), _vm._v(", 75.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2256-backlink",
      "id": "footnote-2256"
    }
  }, [_vm._v("48")]), _vm._v(". R. E. Clements, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", Interpretation: A Bible Commentary for Teaching and Preaching (Atlanta: John Knox, 1988), 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2255-backlink",
      "id": "footnote-2255"
    }
  }, [_vm._v("49")]), _vm._v(". M. Brummitt, “Troubling Utopias: Possible Worlds and Possible Voices in the Book of Jeremiah,” in Diamond and Stulman, "), _c('em', [_vm._v("Jeremiah (Dis)placed")]), _vm._v(", 186.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2254-backlink",
      "id": "footnote-2254"
    }
  }, [_vm._v("50")]), _vm._v(". P. R. Raabe, “What Is Israel’s God Up To among the Nations?” in "), _c('em', [_vm._v("The Book of Jeremiah: Composition, Reception, and Interpretation")]), _vm._v(", ed. J. Lundbom, C. A. Evans, and B. A. Anderson, VTSup 178 (Leiden: Brill, 2018), 234.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2253-backlink",
      "id": "footnote-2253"
    }
  }, [_vm._v("51")]), _vm._v(". See R. Bauckham, ed., "), _c('em', [_vm._v("The Gospels for All Christians")]), _vm._v(" (Grand Rapids: Eerdmans, 1997).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2252-backlink",
      "id": "footnote-2252"
    }
  }, [_vm._v("52")]), _vm._v(". See, e.g., C. E. Carroll, “Another Dodecade: A Dialectic Model of the Decentred Universe of Jeremiah Studies 1996–2008,” "), _c('em', [_vm._v("CurBR")]), _vm._v(" 8 (2010): 162–82.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2251-backlink",
      "id": "footnote-2251"
    }
  }, [_vm._v("53")]), _vm._v(". See Holladay, "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(", 2:35–70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2250-backlink",
      "id": "footnote-2250"
    }
  }, [_vm._v("54")]), _vm._v(". See D. Rom-Shiloni, “The Forest and the Trees: The Place of Pentateuchal Materials in Prophecy of the Late Seventh/Early Sixth Centuries BCE,” in "), _c('em', [_vm._v("Congress Volume Stellenbosch 2016")]), _vm._v(", ed. L. C. Jonker, G. Kotzé, and C. M. Maier, VTSup 177 (Leiden: Brill, 2017), 56–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2249-backlink",
      "id": "footnote-2249"
    }
  }, [_vm._v("55")]), _vm._v(". See H. Lalleman-de Winkel, "), _c('em', [_vm._v("Jeremiah in Prophetic Tradition")]), _vm._v(", Contributions to Biblical Exegesis and Theology 26 (Leeuven: Peeters, 2000), 85–144.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2248-backlink",
      "id": "footnote-2248"
    }
  }, [_vm._v("56")]), _vm._v(". See, e.g., B. D. Sommer, "), _c('em', [_vm._v("A Prophet Reads Scripture: Allusion in Isaiah 40–66")]), _vm._v(", Contraversions: Jews and Other Differences (Stanford: Stanford University Press, 1998); H. Leene, “Blowing the Same Shofar: An Intertextual Comparison of Representations of the Prophetic Role in Jeremiah and Ezekiel,” in "), _c('em', [_vm._v("The Elusive Prophet: The Prophet as a Historical Person, Literary Character and Anonymous Artist")]), _vm._v(", ed. J. C. de Moor, OTS 45 (Leiden: Brill, 2001), 175–98; L. Boadt, “Do Jeremiah and Ezekiel Share a Common View of the Exile?” in Goldingay, "), _c('em', [_vm._v("Uprooting and Planting")]), _vm._v(", 14–31.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2247-backlink",
      "id": "footnote-2247"
    }
  }, [_vm._v("57")]), _vm._v(". See R. G. Kratz, “Why Jeremiah? The Invention of a Prophetic Figure,” in Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(", 197–212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2246-backlink",
      "id": "footnote-2246"
    }
  }, [_vm._v("58")]), _vm._v(". T. Collins, "), _c('em', [_vm._v("The Mantle of Elijah: The Redaction Criticism of the Prophetical Books")]), _vm._v(", The Biblical Seminar 20 (Sheffield: JSOT, 1993), 120; cf. R. P. Carroll, "), _c('em', [_vm._v("From Chaos to Covenant: Uses of Prophecy in the Book of Jeremiah")]), _vm._v(" (London: SCM, 1981), 5–30.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2245-backlink",
      "id": "footnote-2245"
    }
  }, [_vm._v("59")]), _vm._v(". E. Ben Zvi, “The Voice and Role of a Counterfactual Memory in the Construction of Exile and Return,” in "), _c('em', [_vm._v("The Concept of Exile in Ancient Israel and Its Historical Contexts")]), _vm._v(", ed. E. Ben Zvi and C. Levin, BZAW 404 (Berlin: de Gruyter, 2010), 169.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2244-backlink",
      "id": "footnote-2244"
    }
  }, [_vm._v("60")]), _vm._v(". B. M. Levinson, “Was Jeremiah Invented? The Relation of an Author to a Literary Tradition; A Response to Reinhard G. Kratz,” in Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(", 217.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2243-backlink",
      "id": "footnote-2243"
    }
  }, [_vm._v("61")]), _vm._v(". W. McKane, "), _c('em', [_vm._v("A Critical and Exegetical Commentary on Jeremiah")]), _vm._v(", 2 vols., ICC (repr., London: T & T Clark, 2014), 1:l. McKane adds, “Small pieces of pre-existing text trigger exegesis or commentary” (lxxxiii).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2242-backlink",
      "id": "footnote-2242"
    }
  }, [_vm._v("62")]), _vm._v(". T. W. Overholt, “‘It Is Difficult to Read,’” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 48 (1990): 52.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2241-backlink",
      "id": "footnote-2241"
    }
  }, [_vm._v("63")]), _vm._v(". A. Berlejung, “Sources,” in "), _c('em', [_vm._v("T&T Clark Handbook of the Old Testament")]), _vm._v(", ed. J. C. Gertz et al. (London: T&T Clark, 2012), 3; cf. Z. T. Mohammad, “Jeremiah: The Prophet and the Concept; A Response to Reinhard G. Kratz,” in Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(", 226.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2240-backlink",
      "id": "footnote-2240"
    }
  }, [_vm._v("64")]), _vm._v(". R. R. Wilson, “Historicizing the Prophets: History and Literature in the Book of Jeremiah,” in "), _c('em', [_vm._v("On the Way to Nineveh: Studies in Honor of George M. Landes")]), _vm._v(", ed. S. L. Cook and S. C. Winter, American Schools of Oriental Research Books 4 (Atlanta: Scholars, 1999), 136–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2239-backlink",
      "id": "footnote-2239"
    }
  }, [_vm._v("65")]), _vm._v(". L. L. Grabbe, “‘The Lying Pen of the Scribes’?” in "), _c('em', [_vm._v("Essays on Ancient Israel in Its Near Eastern Context: A Tribute to Nadav Na’aman")]), _vm._v(", ed. Y. Amit et al. (Winona Lake, IN: Eisenbrauns, 2006), 189–204; D. A. Glatt-Gilad, “The Personal Names in Jeremiah as a Source for the History of the Period,” "), _c('em', [_vm._v("Hebrew Studies")]), _vm._v(" 41 (2000): 31–45; J. A. Dearman, “My Servants the Scribes,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 109 (1990): 403–21; Keel, "), _c('em', [_vm._v("Jerusalem and the One God")]), _vm._v(", 119.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2238-backlink",
      "id": "footnote-2238"
    }
  }, [_vm._v("66")]), _vm._v(". R. P. Carroll, "), _c('em', [_vm._v("From Chaos to Covenant")]), _vm._v(", 60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2237-backlink",
      "id": "footnote-2237"
    }
  }, [_vm._v("67")]), _vm._v(". J. Pixley, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", Chalice Commentaries for Today (St. Louis, MO: Chalice, 2004), 49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2236-backlink",
      "id": "footnote-2236"
    }
  }, [_vm._v("68")]), _vm._v(". A. J. Rosenberg, “Jeremiah and Ezekiel,” in "), _c('em', [_vm._v("The Literary")]), _vm._v(" "), _c('em', [_vm._v("Guide to the Bible")]), _vm._v(", ed. R. Alter and F. Kermode (London: Collins, 1987), 185.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2235-backlink",
      "id": "footnote-2235"
    }
  }, [_vm._v("69")]), _vm._v(". Cf. R. R. Wilson, “Poetry and Prose in the Book of Jeremiah,” in "), _c('em', [_vm._v("Ki Baruch Hu: Ancient Near Eastern, Biblical, and Judaic Studies in Honor of Baruch A. Levine")]), _vm._v(", ed. R. Chazan, William W. Hallo, and L. H. Schiffman (Winona Lake, IN: Eisenbrauns, 1999), 413–27.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2234-backlink",
      "id": "footnote-2234"
    }
  }, [_vm._v("70")]), _vm._v(". M. Leuchter, "), _c('em', [_vm._v("Josiah’s Reform and Jeremiah’s Scroll: Historical Calamity and Prophetic Response")]), _vm._v(", Hebrew Bible Monographs 6 (Sheffield: Sheffield Phoenix, 2006), 168; see further M. Leuchter, “The Medium and the Message,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 126 (2014): 208–27. H. Weippert ("), _c('em', [_vm._v("Die Prosareden des Jeremiabuches")]), _vm._v(", BZAW 132 [Berlin: de Gruyter, 1973]) argues that the “Deuteronomistic” prose could be Jeremianic. C. M. Maier ("), _c('em', [_vm._v("Jeremia als Lehrer der Tora: Soziale Gebote des Deuteronomiums in Fortschreibungen des Jeremiabuches")]), _vm._v(", FRLANT 196 [Göttingen: Vandenhoeck & Ruprecht, 2002]) argues that in passages such as Jer 7; 11; 26, we have a portrait of Jeremiah that derives from the exilic or Persian period.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2233-backlink",
      "id": "footnote-2233"
    }
  }, [_vm._v("71")]), _vm._v(". P. A. Viviano, “Characterizing Jeremiah,” "), _c('em', [_vm._v("WW")]), _vm._v(" 22 (2002): 365.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2232-backlink",
      "id": "footnote-2232"
    }
  }, [_vm._v("72")]), _vm._v(". Calvin, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 1:454.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2231-backlink",
      "id": "footnote-2231"
    }
  }, [_vm._v("73")]), _vm._v(". Contrast M. Reasoner, “The Redemptive Inversions of Jeremiah in Romans 9–11,” "), _c('em', [_vm._v("Bib")]), _vm._v(" 95 (2014): 388–404.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2230-backlink",
      "id": "footnote-2230"
    }
  }, [_vm._v("74")]), _vm._v(". J. L. Berquist, “Prophetic Legitimation in Jeremiah,” "), _c('em', [_vm._v("VT")]), _vm._v(" 39 (1989): 129.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2229-backlink",
      "id": "footnote-2229"
    }
  }, [_vm._v("75")]), _vm._v(". A. Kalmanofsky, “The Dangerous Sisters of Jeremiah and Ezekiel,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 130 (2011): 300.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2228-backlink",
      "id": "footnote-2228"
    }
  }, [_vm._v("76")]), _vm._v(". A. Kalmanofsky, "), _c('em', [_vm._v("Terror All Around: The Rhetoric of Horror in the Book of Jeremiah")]), _vm._v(", LHBOTS 390 (London: T&T Clark, 2008), 1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2227-backlink",
      "id": "footnote-2227"
    }
  }, [_vm._v("77")]), _vm._v(". Viviano, “Characterizing Jeremiah,” 366.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2226-backlink",
      "id": "footnote-2226"
    }
  }, [_vm._v("78")]), _vm._v(". So S. J. Choi, “A New Heart to Know the Lord: Rhetorical Analysis of Jeremiah 21–24” (PhD diss., University of Gloucestershire, 2001).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2225-backlink",
      "id": "footnote-2225"
    }
  }, [_vm._v("79")]), _vm._v(". Calvin, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 2:253.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2224-backlink",
      "id": "footnote-2224"
    }
  }, [_vm._v("80")]), _vm._v(". In his study of Jer 2, H. L. Ellison also compares Isa 1 (“The Prophecy of Jeremiah,” "), _c('em', [_vm._v("EvQ")]), _vm._v(" 32 [1960]: 4).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2223-backlink",
      "id": "footnote-2223"
    }
  }, [_vm._v("81")]), _vm._v(". R. P. Carroll, “Century’s End: Jeremiah Studies at the Beginning of the Third Millennium,” "), _c('em', [_vm._v("Currents in Research: Biblical Studies")]), _vm._v(" 8 (2000): 22, his emphasis.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2222-backlink",
      "id": "footnote-2222"
    }
  }, [_vm._v("82")]), _vm._v(". On the mythical nature of the empty land, see, e.g., D. Rom-Shiloni, “What Is ‘Persian’ in Late Sixth Century B. C. E. Prophetic Literature? Case Studies and Criteria,” in "), _c('em', [_vm._v("Discerning Criteria for Dating Persian Period Texts")]), _vm._v(", ed. R. J. Bautch and M. Lackowski, FAT 2/101 (Tübingen: Mohr Siebeck, 2019), 32–41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2221-backlink",
      "id": "footnote-2221"
    }
  }, [_vm._v("83")]), _vm._v(". M. Leuchter, “Jeremiah,” in "), _c('em', [_vm._v("The Oxford Handbook of the Prophets")]), _vm._v(", ed. C. J. Sharp (Oxford: Oxford University Press, 2016), 179.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2220-backlink",
      "id": "footnote-2220"
    }
  }, [_vm._v("84")]), _vm._v(". T. E. Fretheim, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", Smith and Helwys Bible Commentary (Macon, GA: Smith and Helwys, 2002), 540.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2219-backlink",
      "id": "footnote-2219"
    }
  }, [_vm._v("85")]), _vm._v(". So G. L. Keown, P. J. Scalise, and T. G. Smothers, "), _c('em', [_vm._v("Jeremiah 26–52")]), _vm._v(", WBC 27 (Dallas: Word, 1995), 263.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2218-backlink",
      "id": "footnote-2218"
    }
  }, [_vm._v("86")]), _vm._v(". See, e.g., L. Stulman, “Insiders and Outsiders in the Book of Jeremiah,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 66 (1995): 71–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2217-backlink",
      "id": "footnote-2217"
    }
  }, [_vm._v("87")]), _vm._v(". M. Leuchter, “Remembering Jeremiah in the Persian Period,” in "), _c('em', [_vm._v("Remembering Biblical Figures in the Late Persian and Early Hellenistic Periods: Social Memory and Imagination")]), _vm._v(", ed. D. V. Edelman and E. Ben Zvi (Oxford: Oxford University Press, 2013), 394.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2216-backlink",
      "id": "footnote-2216"
    }
  }, [_vm._v("88")]), _vm._v(". McKane, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 2:1091–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2215-backlink",
      "id": "footnote-2215"
    }
  }, [_vm._v("89")]), _vm._v(". For the argument that an important level of tradition in the scroll is a redaction in Babylon, see, e.g., K.-F. Pohlmann, "), _c('em', [_vm._v("Studien zum Jeremiabuch: Ein Beitrag zur Frage nach der Entstehung des Jeremiabuches")]), _vm._v(", FRLANT 118 (Göttingen: Vandenhoeck & Ruprecht, 1978); C. R. Seitz, "), _c('em', [_vm._v("Theology in Conflict: Reactions to the Exile in the Book of Jeremiah")]), _vm._v(", BZAW 176 (Berlin: de Gruyter, 1989).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2214-backlink",
      "id": "footnote-2214"
    }
  }, [_vm._v("90")]), _vm._v(". On various possibilities, see, e.g., H.-J. Stipp, "), _c('em', [_vm._v("Studien zum Jeremiabuch: Text und Redaktion")]), _vm._v(", FAT 96 (Tübingen: Mohr Siebeck, 2015), 325–47. Stipp suggests that the first half was composed in Judah, the second half in Babylon.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2213-backlink",
      "id": "footnote-2213"
    }
  }, [_vm._v("91")]), _vm._v(". J. A. Thompson, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 222.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2212-backlink",
      "id": "footnote-2212"
    }
  }, [_vm._v("92")]), _vm._v(". See, e.g., C. Wolff, "), _c('em', [_vm._v("Jeremia in Frühjudentum und Urchristentum")]), _vm._v(", Texte und Untersuchungen zur Geschichte der altchristlichen Literatur 118 (Berlin: Akademie, 1976); A. H. W. Curtis and T. Römer, eds., "), _c('em', [_vm._v("The Book of Jeremiah and Its Reception")]), _vm._v(", BETL 128 (Leuven: Peeters, 1997); J. Barton, “Jeremiah in the Apocrypha and Pseudepigrapha,” in "), _c('em', [_vm._v("Troubling Jeremiah")]), _vm._v(", ed. A. R. P. Diamond, K. M. O’Connor, and L. Stulman, JSOTSup 260 (Sheffield: Sheffield Academic, 1999), 306–17; Leuchter, “Remembering Jeremiah”; L. G. Perdue, “Baruch among the Sages,” in Goldingay, "), _c('em', [_vm._v("Uprooting and Planting")]), _vm._v(", 260–90; S. A. Adams, “Jeremiah in the Old Testament Apocrypha and Pseudepigrapha,” in Lundbom, Evans, and B. A. Anderson, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 359–78; J. H. Newman, "), _c('em', [_vm._v("Before the Bible: The Liturgical Body and the Formation of Scriptures in Early Judaism")]), _vm._v(" (Oxford: Oxford University Press, 2018), 53–74; Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2211-backlink",
      "id": "footnote-2211"
    }
  }, [_vm._v("93")]), _vm._v(". See, e.g., E. Tov, “The Jeremiah Scrolls from Qumran,” "), _c('em', [_vm._v("Revue de Qumran")]), _vm._v(" 14 (1989): 189–206; G. J. Brooke, “The Book of Jeremiah and Its Reception in the Qumran Scrolls,” in Curtis and Römer, "), _c('em', [_vm._v("Jeremiah and Its Reception")]), _vm._v(", 183–206; M. S. Moore, “The Laments in Jeremiah and 1QH,” in Goldingay, "), _c('em', [_vm._v("Uprooting and Planting")]), _vm._v(", 228–52; R. Goldstein, “Jeremiah between Destruction and Exile,” "), _c('em', [_vm._v("Dead Sea Discoveries")]), _vm._v(" 20 (2013): 433–51; K. Davis, "), _c('em', [_vm._v("The Cave 4 Apocryphon of Jeremiah and the Qumran Jeremianic Traditions")]), _vm._v(", STDJ 111 (Leiden: Brill, 2014); A. Lange, “Texts of Jeremiah in the Qumran Library,” in Lundbom, Evans, and B. A. Anderson, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 280–302.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2210-backlink",
      "id": "footnote-2210"
    }
  }, [_vm._v("94")]), _vm._v(". See, e.g., C. A. Evans, “Jeremiah in Jesus and the New Testament,” in Lundbom, Evans, and B. A. Anderson, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 303–19 (this volume also includes studies of the Tg, the Latin translations, and the Peshitta); J. Frey, “The Reception of Jeremiah and the Impact of Jeremianic Traditions in the New Testament,” in Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(", 499–522; J. D. Hays, “The Persecuted Prophet and Judgment on Jerusalem: The Use of LXX Jeremiah in the Gospel of Luke,” "), _c('em', [_vm._v("BBR")]), _vm._v(" 25 (2015): 453–73; M. Knowles, "), _c('em', [_vm._v("Jeremiah in Matthew’s Gospel: The Rejected Prophet Motif in Matthean Redaction")]), _vm._v(", JSNTSup 68 (Sheffield JSOT Press, 1993); J. W. Mazurel, “Citations from the Book of Jeremiah in the New Testament,” in Kessler, "), _c('em', [_vm._v("Reading Jeremiah")]), _vm._v(", 181–89; A. Rakotoharintsifa, “Jérémieh en action à Corinthe,” in Curtis and Römer, "), _c('em', [_vm._v("Jeremiah and Its Reception")]), _vm._v(", 207–16; M. F. Whitters, “Jesus in the Footsteps of Jeremiah,” "), _c('em', [_vm._v("CBQ")]), _vm._v(" 68 (2006): 229–47.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2209-backlink",
      "id": "footnote-2209"
    }
  }, [_vm._v("95")]), _vm._v(". For a review of the evidence, see, e.g., T. H. Lim, "), _c('em', [_vm._v("The Formation of the Jewish Canon")]), _vm._v(" (New Haven: Yale University Press, 2013).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2208-backlink",
      "id": "footnote-2208"
    }
  }, [_vm._v("96")]), _vm._v(". W. L. Holladay, "), _c('em', [_vm._v("Jeremiah: Spokesman out of Time")]), _vm._v(" (Philadelphia: United Church Press, 1974), 140.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2207-backlink",
      "id": "footnote-2207"
    }
  }, [_vm._v("97")]), _vm._v(". See the Leningrad Codex at the Internet Archive, "), _c('a', {
    attrs: {
      "href": "https://archive.org/details/Leningrad_Codex",
      "target": "_blank"
    }
  }, [_vm._v("https://archive.org/details/Leningrad_Codex")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2206-backlink",
      "id": "footnote-2206"
    }
  }, [_vm._v("98")]), _vm._v(". See E. Würthwein, "), _c('em', [_vm._v("The Text of the Old Testament")]), _vm._v(", 3rd ed. (Grand Rapids: Eerdmans, 2014), 39–43. I have not had access to the Sassoon Codex 1053. The Cairo Codex of the Prophets is reproduced in D. S. Lowinger, "), _c('em', [_vm._v("Cairo Codex of the Bible")]), _vm._v(" (Jerusalem: Makor, 1971).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2205-backlink",
      "id": "footnote-2205"
    }
  }, [_vm._v("99")]), _vm._v(". Jerome has a nice comment on what he sees as a well-intentioned LXX omission: “But what about the Hebrew truth?” (Jerome, "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(", trans. Michael Graves, Ancient Christian Texts [Downers Grove, IL: InterVarsity, 2011], 173). He has another comment on 17:1–4: “I do not know why the LXX translators omitted this passage, unless perhaps they were sparing their people…. And there are many other passages of this kind, but to discuss all of them would require not just a book but books” ("), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 104; I write with admiration and gratitude for the work of Jerome—Hebraist, translator, and commentator—who died in Bethlehem while writing his commentary). Augustine has a neat answer to Jerome’s implicit question, at a different level: “If anything is in the Hebrew text but not in that of the seventy translators, it is something that the Spirit of God did not choose to say through the latter”—and the converse ("), _c('em', [_vm._v("City of God")]), _vm._v(" 18.43).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2204-backlink",
      "id": "footnote-2204"
    }
  }, [_vm._v("100")]), _vm._v(". The classic studies are J. G. Janzen, "), _c('em', [_vm._v("Studies in the Text of Jeremiah")]), _vm._v(", HSM 6 (Cambridge, MA: Harvard University Press, 1973) and such works of E. Tov as “Some Aspects of the Textual and Literary History of the Book of Jeremiah,” in "), _c('em', [_vm._v("Le livre de Jérémie: Le prophète et son milieu. Les oracles et leur transmission")]), _vm._v(", ed. P.-M. Bogaert, 2nd ed., BETL 54 (Leuven: Peeters, 1997), 145–67, 430; “The Literary History of the Book of Jeremiah in the Light of Its Textual History,” in "), _c('em', [_vm._v("Empirical Models for Biblical Criticism")]), _vm._v(", ed. J. H. Tigay (Philadelphia: University of Pennsylvania Press, 1985), 211–37. More recent studies and surveys of the question include R. P. Carroll, “Surplus Meaning and the Conflict of Interpretations: A Dodecade of Jeremiah Studies (1984–1995),” "), _c('em', [_vm._v("Currents in Research: Biblical Studies")]), _vm._v(" 4 (1996): 124–25; R. P. Carroll, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", OTL, 50–55; G. Fischer, “Mysteries of the Book of Jeremiah,” in Najman and Schmid, "), _c('em', [_vm._v("Jeremiah’s Scriptures")]), _vm._v(", 166–78; Y. Goldman, "), _c('em', [_vm._v("Prophétie et royauté au retour de l’exil: Les origines litteraires de la forme massoretique du livre de Jérémie")]), _vm._v(", OBO 118 (Göttingen: Vandenhoeck & Ruprecht, 1992); J. R. Lundbom, “Haplography in the Hebrew "), _c('em', [_vm._v("Vorlage")]), _vm._v(" of LXX Jeremiah,” "), _c('em', [_vm._v("Hebrew Studies")]), _vm._v(" 46 (2005): 301–20; Lundbom, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(" 1–20, 57–62; McKane, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 1:xv–xxxi; R. F. Person, “A Rolling Corpus and Oral Tradition: A Not-So-Literate Solution to a Highly Literate Problem,” in Diamond, K. M O’Connor, and Stulman, "), _c('em', [_vm._v("Troubling Jeremiah")]), _vm._v(", 263–71; C. J. Sharp, “‘Take Another Scroll and Write’: A Study of the LXX and the MT of Jeremiah’s Oracles against Egypt and Babylon,’” "), _c('em', [_vm._v("VT")]), _vm._v(" 47 (1997): 487–516; A. G. Shead, “The Text of Jeremiah,” in Lundbom, Evans, and B. A. Anderson, "), _c('em', [_vm._v("Book of Jeremiah")]), _vm._v(", 255–79; H.-J. Stipp, "), _c('em', [_vm._v("Das masoretische und alexandrinische Sondergut des Jeremiabuches")]), _vm._v(", OBO 136 (Göttingen: Vandenhoeck & Ruprecht, 1994); L. Stulman, “Some Theological and Lexical Differences between the Old Greek and the MT of the Jeremiah Prose Discourses,” "), _c('em', [_vm._v("Hebrew Studies")]), _vm._v(" 25 (1984): 18–23; M. A. Sweeney, "), _c('em', [_vm._v("Form and Intertextuality in Prophetic and Apocalyptic Literature")]), _vm._v(", FAT 45 (Tübingen: Mohr Siebeck, 2005), 65–77; R. D. Weis, “Textual History of Jeremiah,” in "), _c('em', [_vm._v("Textual History of the Bible")]), _vm._v(", ed. A. Lange and E. Tov, vol. 1B (Leiden: Brill, 2016), §7.1.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2203-backlink",
      "id": "footnote-2203"
    }
  }, [_vm._v("101")]), _vm._v(". G. H. Parke-Taylor ("), _c('em', [_vm._v("The Formation of the Book of Jeremiah")]), _vm._v(" [Atlanta: Society of Biblical Literature, 2000]) systematically studies the doublets in the scroll and the verses that recur in and from other parts of the First Testament in order to see how they suggest insight into the formation of the scroll.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2202-backlink",
      "id": "footnote-2202"
    }
  }, [_vm._v("102")]), _vm._v(". See J. R. Lundbom, "), _c('em', [_vm._v("Jeremiah 37–52: A New Translation with Introduction and Commentary")]), _vm._v(", AB 21C (New York: Doubleday, 2004), 549–63.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2201-backlink",
      "id": "footnote-2201"
    }
  }, [_vm._v("103")]), _vm._v(". For LXX in its own right, see esp. G. A. Walser, "), _c('em', [_vm._v("Jeremiah: A Commentary Based on Ieremias in Codex Vaticanus")]), _vm._v(", Septuagint Commentary Series (Leiden: Brill, 2012). K. Finsterbusch and N. Jacoby lay out the two texts synoptically in German in "), _c('em', [_vm._v("MT-Jeremia und LXX-Jeremia 1–24")]), _vm._v(" (Neukirchen: Neukirchener, 2016) and "), _c('em', [_vm._v("MT-Jeremia und LXX-Jeremia 25–52")]), _vm._v(" (Neukirchen: Neukirchener, 2017).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2200-backlink",
      "id": "footnote-2200"
    }
  }, [_vm._v("104")]), _vm._v(". B. S. Childs, "), _c('em', [_vm._v("Introduction to the Old Testament as Scripture")]), _vm._v(" (Philadelphia: Fortress, 1979), 352–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2199-backlink",
      "id": "footnote-2199"
    }
  }, [_vm._v("105")]), _vm._v(". McKane, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 1:623. See further D. L. Christensen, “In Quest of the Autograph of the Book of Jeremiah,” "), _c('em', [_vm._v("JETS")]), _vm._v(" 33 (1990): 145–53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2198-backlink",
      "id": "footnote-2198"
    }
  }, [_vm._v("106")]), _vm._v(". "), _c('em', [_vm._v("BHS")]), _vm._v(" refers to the codex by means of an ordinary capital C and to the geniza fragments by an ornate Gothic C.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2197-backlink",
      "id": "footnote-2197"
    }
  }, [_vm._v("107")]), _vm._v(". See, e.g., Crouch, "), _c('em', [_vm._v("Introduction")]), _vm._v(", 31–37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2196-backlink",
      "id": "footnote-2196"
    }
  }, [_vm._v("108")]), _vm._v(". W. L. Holladay argues the opposite way in “Text Criticism and Beyond: The Case for Jeremiah,” "), _c('em', [_vm._v("Textus")]), _vm._v(" 23 (2007): 173–210, and illustrates his conviction in his commentary—as do most commentators.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2195-backlink",
      "id": "footnote-2195"
    }
  }, [_vm._v("109")]), _vm._v(". For divisions in the LXX, see C. Amphoux and A. Serandour, “La composition de Jérémie LXX d’après les divisions du Codex Vaticanus (B),” in "), _c('em', [_vm._v("XIII Congress of the International Organization for the Septuagint and Cognate Studies")]), _vm._v(", ed. M. K. H. Peters, SCS 55 (Atlanta: Society of Biblical Literature, 2008), 3–21.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2194-backlink",
      "id": "footnote-2194"
    }
  }, [_vm._v("110")]), _vm._v(". T. E. Fretheim, "), _c('em', [_vm._v("What Kind of God? Collected Essays of Terence E. Fretheim")]), _vm._v(", Siphrut 14 (Winona Lake, IN: Eisenbrauns, 2015), 300.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2193-backlink",
      "id": "footnote-2193"
    }
  }, [_vm._v("111")]), _vm._v(". C. J. Sharp, “Jeremiah,” in "), _c('em', [_vm._v("Theological Bible Commentary")]), _vm._v(", ed. D. L. Petersen and G. R. O’Day (Louisville: Westminster John Knox, 2009), 231.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2192-backlink",
      "id": "footnote-2192"
    }
  }, [_vm._v("112")]), _vm._v(". See J. Goldingay, “As a Commentator, One Might Ask, ‘What Would Jeremiah or John Say?’” in "), _c('em', [_vm._v("The Genre of Biblical Commentary: Essays in Honor of John E. Hartley on the Occasion of His 75th Birthday")]), _vm._v(", ed. T. D. Finlay and W. Yarchin (Eugene, OR: Pickwick, 2015), 234–40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2191-backlink",
      "id": "footnote-2191"
    }
  }, [_vm._v("113")]), _vm._v(". W. Brueggemann, "), _c('em', [_vm._v("Like Fire in the Bones: Listening for the Prophetic Word in Jeremiah")]), _vm._v(" (Minneapolis: Fortress, 2006), 144, 151.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2190-backlink",
      "id": "footnote-2190"
    }
  }, [_vm._v("114")]), _vm._v(". W. Brueggemann considers Jeremiah’s relationship with other First Testament books in "), _c('em', [_vm._v("The Theology of the Book of Jeremiah")]), _vm._v(", Old Testament Theology (Cambridge: Cambridge University Press, 2007), 134–86.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2189-backlink",
      "id": "footnote-2189"
    }
  }, [_vm._v("115")]), _vm._v(". G. Barbiero, "), _c('em', [_vm._v("“Tu mi hai sedotto, Signore”: Le confessioni di Geremia alla luce della sua vocazione profetica")]), _vm._v(", Analecta Biblica Studia (Rome: Gregorian, 2013), 12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2188-backlink",
      "id": "footnote-2188"
    }
  }, [_vm._v("116")]), _vm._v(". A. B. Davidson, “Jeremiah the Prophet,” in "), _c('em', [_vm._v("A Dictionary of the Bible")]), _vm._v(", ed. J. Hastings, vol. 2 (Edinburgh: T&T Clark, 1899), 576.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2187-backlink",
      "id": "footnote-2187"
    }
  }, [_vm._v("117")]), _vm._v(". A. Kalmanofsky, “Israel’s Open Sore in the Book of Jeremiah,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 135 (2016): 248.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2186-backlink",
      "id": "footnote-2186"
    }
  }, [_vm._v("118")]), _vm._v(". T. Polk, "), _c('em', [_vm._v("The Prophetic Persona: Jeremiah and the Language of the Self")]), _vm._v(", JSOTSup 32 (Sheffield: JSOT, 1984), 170–71.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2185-backlink",
      "id": "footnote-2185"
    }
  }, [_vm._v("119")]), _vm._v(". See D. Bourguet, "), _c('em', [_vm._v("Des Métaphores de Jérémie")]), _vm._v(", Études Bibliques 9 (Paris: Gabalda, 1987); J. Y. Jindo, "), _c('em', [_vm._v("Biblical Metaphor Reconsidered: A Cognitive Approach to Poetic Prophecy in Jeremiah 1–24")]), _vm._v(", HSM 64 (Winona Lake, IN: Eisenbrauns, 2010).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2184-backlink",
      "id": "footnote-2184"
    }
  }, [_vm._v("120")]), _vm._v(". W. Brueggemann, "), _c('em', [_vm._v("Hopeful Imagination: Prophetic Voices in Exile")]), _vm._v(" (Philadelphia: Fortress, 1986), 14.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2183-backlink",
      "id": "footnote-2183"
    }
  }, [_vm._v("121")]), _vm._v(". Brueggemann, "), _c('em', [_vm._v("Hopeful Imagination")]), _vm._v(", 14–15.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2182-backlink",
      "id": "footnote-2182"
    }
  }, [_vm._v("122")]), _vm._v(". Fretheim, "), _c('em', [_vm._v("What Kind of God?")]), _vm._v(", 296.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2181-backlink",
      "id": "footnote-2181"
    }
  }, [_vm._v("123")]), _vm._v(". See, e.g., J. H. le Roux, “In Search of Carroll’s Jeremiah,” "), _c('em', [_vm._v("OTE")]), _vm._v(" 7 (1994): 7–20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2180-backlink",
      "id": "footnote-2180"
    }
  }, [_vm._v("124")]), _vm._v(". Sharp, “Jeremiah,” 234.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2179-backlink",
      "id": "footnote-2179"
    }
  }, [_vm._v("125")]), _vm._v(". C. G. Frechette, “The Old Testament as Controlled Substance: How Insights from Trauma Studies Reveal Healing Capacities in Potentially Harmful Texts,” "), _c('em', [_vm._v("Int")]), _vm._v(" 69 (2014): 20–34.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2178-backlink",
      "id": "footnote-2178"
    }
  }, [_vm._v("126")]), _vm._v(". See J. Skinner, "), _c('em', [_vm._v("Prophecy and Religion: Studies in the Life of Jeremiah")]), _vm._v(" (Cambridge: Cambridge University Press, 1922), 77–79.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2177-backlink",
      "id": "footnote-2177"
    }
  }, [_vm._v("127")]), _vm._v(". A. J. Heschel, "), _c('em', [_vm._v("The Prophets")]), _vm._v(" (New York: Harper, 1962), 106; cf. E. A. Martens, “Jeremiah,” "), _c('em', [_vm._v("Direction")]), _vm._v(" 15 (1986): 3.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2176-backlink",
      "id": "footnote-2176"
    }
  }, [_vm._v("128")]), _vm._v(". E. Osswald, "), _c('em', [_vm._v("Falsche Prophetie im Alten Testament")]), _vm._v(" (Tübingen: Mohr Siebeck, 1962), 22; cf. J. A. Sanders, "), _c('em', [_vm._v("From Sacred Story to Sacred Text")]), _vm._v(" (Philadelphia: Fortress, 1987), 84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2175-backlink",
      "id": "footnote-2175"
    }
  }, [_vm._v("129")]), _vm._v(". R. P. Carroll, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", OTL, 38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2174-backlink",
      "id": "footnote-2174"
    }
  }, [_vm._v("130")]), _vm._v(". Mowinckel, "), _c('em', [_vm._v("Komposition")]), _vm._v(", 5, his italics.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2173-backlink",
      "id": "footnote-2173"
    }
  }, [_vm._v("131")]), _vm._v(". L. Stulman, “Jeremiah as a Messenger of Hope in Crisis,” "), _c('em', [_vm._v("Int")]), _vm._v(" 62 (2008): 13, 7.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2172-backlink",
      "id": "footnote-2172"
    }
  }, [_vm._v("132")]), _vm._v(". For similar analyses to the one that follows, see A. Rofé, “The Arrangement of the Book of Jeremiah,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 101 (1989): 390–98; S. J. Murphy, “The Quest for the Structure of the Book of Jeremiah,” "), _c('em', [_vm._v("BSac")]), _vm._v(" 166 (2009): 306–18; R. D. Patterson, “Of Bookends, Hinges, and Hooks: Literary Clues to the Arrangement of Jeremiah’s Prophecies,” "), _c('em', [_vm._v("WTJ")]), _vm._v(" 51 (1989): 109–131; L. Stulman, "), _c('em', [_vm._v("Order amid Chaos: Jeremiah as Symbolic Tapestry")]), _vm._v(", The Biblical Seminar 57 (Sheffield: Sheffield Academic, 1998), 23–55.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2171-backlink",
      "id": "footnote-2171"
    }
  }, [_vm._v("133")]), _vm._v(". J. Oecolampadius, "), _c('em', [_vm._v("In Hieremiam prophetam")]), _vm._v(" (Strasbourg: Apiarius, 1533), 39.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2170-backlink",
      "id": "footnote-2170"
    }
  }, [_vm._v("134")]), _vm._v(". D. Berrigan, "), _c('em', [_vm._v("Jeremiah: The World, the Wound of God")]), _vm._v(" (Minneapolis: Fortress, 1999), 141.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2169-backlink",
      "id": "footnote-2169"
    }
  }, [_vm._v("135")]), _vm._v(". R. E. Clements, “Jeremiah 1–25 and the Deuteronomistic History.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2168-backlink",
      "id": "footnote-2168"
    }
  }, [_vm._v("136")]), _vm._v(". Commentators such as B. Blayney ("), _c('em', [_vm._v("Jeremiah and Lamentations")]), _vm._v(", 2nd ed. [Edinburgh: Oliphant, 1810]) and J. Bright ("), _c('em', [_vm._v("Jeremiah: Introduction, Translation, and Notes")]), _vm._v(", AB 21 [Garden City, NY: Doubleday, 1965]) thus rearrange them in order to comment on them.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2167-backlink",
      "id": "footnote-2167"
    }
  }, [_vm._v("137")]), _vm._v(". Diamond, “Jeremiah,” 546.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2166-backlink",
      "id": "footnote-2166"
    }
  }, [_vm._v("138")]), _vm._v(". Cf. M. C. Calloway’s study of Jer 37–38, “Black Fire on White Fire: Historical Context and Literary Subtext in Jeremiah 37–38,” in Diamond, K. M O’Connor, and Stulman, "), _c('em', [_vm._v("Troubling Jeremiah")]), _vm._v(", 173–74.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2165-backlink",
      "id": "footnote-2165"
    }
  }, [_vm._v("139")]), _vm._v(". Indeed, Newman ("), _c('em', [_vm._v("Before the Bible")]), _vm._v(", 53–74) notes that some people did not think it should end after Jer 52: they added Baruch and other “Jeremianic” works.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2164-backlink",
      "id": "footnote-2164"
    }
  }, [_vm._v("140")]), _vm._v(". Sharp, “Jeremiah,” 231.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2163-backlink",
      "id": "footnote-2163"
    }
  }, [_vm._v("141")]), _vm._v(". H.-J. Stipp, “Legenden der Jeremia-Exegese (I),” "), _c('em', [_vm._v("VT")]), _vm._v(" 64 (2014): 500–501.")])])])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "part-tit"
  }, [_c('strong', [_vm._v("The Book of "), _c('br'), _vm._v("JEREMIAH")])])])])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter-title",
    attrs: {
      "id": "ch-2"
    }
  }, [_vm._v("Text and Commentary")]), _vm._v(" "), _c('h1', {
    staticClass: "sec1",
    attrs: {
      "id": "sec-10"
    }
  }, [_vm._v("PROLOGUE: AN INTRODUCTION TO THE SCROLL (1:1–19)")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Like Isaiah, Ezekiel, and Hosea, the Jeremiah scroll begins with a long introduction (a chapter in Jeremiah’s case; more than a chapter in the other cases). Like those other examples, it opens with a brief factual and chronological preface and then goes on to something more substantial and more distinctive in form as well as in content. As is the case in Hosea, this more substantial introduction takes the form of a narrative account of Yahweh’s commission that anticipates the scroll’s contents as a whole in terms of threat and promise. As is the case in Ezekiel, however, the narrative introducing Jeremiah takes first-person form, talks about the prophet’s own reaction to Yahweh’s commission, and homes in on the provision of words to speak. And as is the case in Isaiah, the introduction incorporates material from much later than the time of the commission in order to give a balanced account of where the commission led.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The chapter comprises a four-part introduction to the scroll:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("vv. 1–3")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A preface introducing Jeremiah and his times")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("vv. 4–10")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Jeremiah’s self-introduction describing his commission, with its challenge to speak boldly and its promise of protection")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("vv. 11–12")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Jeremiah’s report of a message from Yahweh about the coming implementation of his message")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("vv. 13–19")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Jeremiah’s report of a second (double) message from Yahweh:")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline1"
  }, [_vm._v("vv. 13–16")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline1"
  }, [_vm._v("Yahweh’s intention to bring disaster on Judah by mean of enemy invasion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("vv. 17–19")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Yahweh’s renewed commission to Jeremiah with its challenge to speak boldly and its promise of protection")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("This analysis broadly corresponds to the divisions in MT, which has section markers after vv. 3, 6, 10, 12, and 19. Jeremiah 1 thus forms a coherent section to introduce the scroll. It does so by bringing together some originally separate elements. Verses 1–3 is a third-person preface that corresponds to the prefaces in many prophetic scrolls. In substance, though not in form or structure, the first-person account in vv. 4–19 then follows an a-b-b′-a′ order. Verses 4–10 tell of a commission. Verses 11–16 relate two occasions when Yahweh enabled the prophet to “see” something by looking at something ordinary—they might be two separate experiences, though they have become the subject of a linked testimony. Verses 17–19 continue this second report, but their content reverts to the theme and focus of vv. 4–10.")]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-28"
    }
  }, [_vm._v("A. "), _c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("PREFACE")]), _vm._v(" ("), _c('span', {
    staticClass: "rh_char2"
  }, [_vm._v("1:1–3")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vq_prose"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("1")]), _vm._v("The words of "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("a")]), _vm._v(" Jeremiah "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("b")]), _vm._v(" ben Hilkiah, one of the priests who were in Anathoth in the territory of Benjamin, "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("2")]), _vm._v("to whom Yahweh’s message came "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("c")]), _vm._v(" in the time of Josiah ben Amon King of Judah, in the thirteenth year of his reign, "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("3")]), _vm._v("and came "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("d")]), _vm._v(" in the time of Jehoiakim ben Josiah King of Judah, until the ending of "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("e")]), _vm._v(" the eleventh year of Zedekiah ben Josiah King of Judah, until the exile of Jerusalem "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("f")]), _vm._v(" in the fifth month. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("g")])]), _vm._v(" "), _c('p', {
    staticClass: "verse_note1"
  }, [_vm._v("a. LXX has “the word of God that came to,” a formulation more like the one in Hosea, Joel, Micah, Jonah, and Zephaniah (“God” rather than “the Lord” is unique, though it corresponds to v. 2 here), whereas MT’s formulation compares with that in Amos. In 1–2 Kings, "), _c('em', [_vm._v("dibrê")]), _vm._v(" denotes the deeds (of a king), and in Amos and Jeremiah it might imply both words and deeds (cf. Neh 1:1). At the beginning of a prophetic scroll, however, it likely suggests words (cf. Vg).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("b. On the name, see J. J. Stamm, “Der Name Jeremia,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 100 (1988): 100–106. He concludes it means “Yahweh gives life.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("c. The formulation recurs in the introduction to messages in 14:1; 46:1; 47:1; 49:34, with the meaning “what came/happened” ("), _c('em', [_vm._v("hāyâ")]), _vm._v("). Here the "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ăšer")]), _vm._v(" has an antecedent, as in 1 Kgs 18:31, and the clause is a regular relative clause with a resumptive pronominal suffix on "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ēlāyw")]), _vm._v(" (W. Rudolph, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 3rd ed., Handbuch zum Alten Testament 12 [Tübingen: Mohr Siebeck, 1968], 2). Cf. also 25:2 with a different antecedent.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("d. Lit. “happened,” as in v. 2 (cf. vv. 11, 13). Verses 1–2 could have led directly into v. 4, and v. 3 might have been added to adapt the preface as part of the introduction to the entire scroll.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("e. LXX lacks "), _c('em', [_vm._v("the ending of")]), _vm._v(", perhaps omitting it because of the tension with the subsequent reference to the fifth month; or perhaps it is an MT expansion of the shorter text represented by LXX.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("f. The expression involves a metonymy: it is the people of Jerusalem who are taken into exile.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("g. MT has a marker here.")]), _vm._v(" "), _c('p', {
    staticClass: "para_grid"
  }, [_vm._v("This conventional preface answers three questions that its author evidently thought were important to anyone reading the scroll.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Who was Jeremiah?")]), _vm._v(" "), _c('li', [_vm._v("Where did his message come from?")]), _vm._v(" "), _c('li', [_vm._v("What was it about?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("People need to know about the person, know his times, and recognize who gave him the message. The answers in vv. 1–3 are preliminary ones that raise as many questions as they resolve; vv. 4–19 will elaborate on them, and the scroll as a whole will fill them out. The preface simply offers preliminary pointers to guide the scroll’s readers. It functions to “impose order on chaos”—on “the messy and terrible events of history” as these unfolded in the period it covers—and it hints at the replacement of defunct priestly and kingly lines by a prophetic line."), _c('a', {
    attrs: {
      "href": "#/#footnote-2162",
      "id": "footnote-2162-backlink"
    }
  }, [_c('sup', [_vm._v("1")])]), _vm._v(" It also suggests a framework of order for the messy scroll that it introduces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The prefaces to Jeremiah and Ezekiel are the longest prophetic prefaces. Jeremiah’s also compares particularly with Hosea’s and Amos’s in giving the prophet’s name and family background, the time of his commissioning, and the names of the kings during his time. The preface is presumably the work of the theologian-curators who compiled the Jeremiah scroll, who wanted to offer guidance to people reading it (the conventional scholarly term for them is the Deuteronomists; see “Jeremiah and His Curators,” pp. 34–36). The third-person form underscores the objective, factual nature of the preface’s contents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("On the kings and their dates, see “Background” (pp. 2–3).")]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("1")]), _vm._v(" In answer to the first question, the preface gives Jeremiah’s name and family background. Anathoth can presumably be linked with the modern village of Anata, three miles north of Jerusalem."), _c('a', {
    attrs: {
      "href": "#/#footnote-2161",
      "id": "footnote-2161-backlink"
    }
  }, [_c('sup', [_vm._v("2")])]), _vm._v(" It is thus across the boundary between Judah and Benjamin so that technically Jeremiah is a Benjaminite and a northern Israelite in Jerusalem."), _c('a', {
    attrs: {
      "href": "#/#footnote-2160",
      "id": "footnote-2160-backlink"
    }
  }, [_c('sup', [_vm._v("3")])]), _vm._v(" The reference to Anathoth makes clear that Jeremiah’s father was not the Jerusalem Hilkiah, senior priest in his time (2 Kgs 22–23), who would hardly be described simply as one of the priests who were in Anathoth; the name is common."), _c('a', {
    attrs: {
      "href": "#/#footnote-2159",
      "id": "footnote-2159-backlink"
    }
  }, [_c('sup', [_vm._v("4")])]), _vm._v(" The expression “Jeremiah of Anathoth” (29:27) would similarly serve to distinguish the prophet from other Jeremiahs. It is tempting to infer that a priestly family in Anathoth comprised descendants of Abiathar, the senior priest in David’s day who was banished to Anathoth after backing Adonijah rather than Solomon as David’s successor, Anathoth being one of the towns where priestly families lived (Josh 21:13–19; 1 Kgs 2:26–27)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2158",
      "id": "footnote-2158-backlink"
    }
  }, [_c('sup', [_vm._v("5")])]), _vm._v(" Ironically, then, from the place to which Solomon banished Abiathar comes a man who will speak the word against Solomon’s edifice."), _c('a', {
    attrs: {
      "href": "#/#footnote-2157",
      "id": "footnote-2157-backlink"
    }
  }, [_c('sup', [_vm._v("6")])]), _vm._v(" It would not be surprising if Abiathar’s family had continued to act as priests at a shrine at Anathoth; if their shrine was one that was closed down by Josiah (2 Kgs 23), there might well have been animosity in Anathoth toward the Jerusalem authorities as well as animosity in Jerusalem toward someone who could be called “Jeremiah of Anathoth.” Perhaps Jeremiah got caught in the crossfire between the two priesthoods by not being obviously loyal to either (see Jer 11–12). On the other hand, neither would it be surprising if the Anathoth priesthood kept alive an awareness of Israelite faith going back to Eli and behind Abiathar to Moses, the faith that then shaped Jeremiah and made him the man he was. There’s no hint that Jeremiah functioned as a priest in Anathoth, though his priestly connections might lie behind the liberty with which he relates to the temple (e.g., 19:1; 35:1–4; see the commentary on v. 5).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("2")]), _vm._v(" The answer to the second question is: Yahweh spoke to him, in Josiah’s time and subsequently. "), _c('em', [_vm._v("The words of Jeremiah")]), _vm._v(" (v. 1) were thus also "), _c('em', [_vm._v("Yahweh’s message")]), _vm._v(" (word). Verses 7 and 9 will expand on the interrelationship of the expressions. "), _c('em', [_vm._v("Came")]), _vm._v(" or “happened” ("), _c('em', [_vm._v("hāyâ")]), _vm._v("; cf. vv. 3, 4, etc.) suggests the objective factuality of this message. It did not issue from Jeremiah’s wise reflection but from elsewhere. “The incongruence between the word of a human being and the word of Yahweh is abolished.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2156",
      "id": "footnote-2156-backlink"
    }
  }, [_c('sup', [_vm._v("7")])]), _vm._v(" The expression "), _c('em', [_vm._v("Yahweh’s message came")]), _vm._v(" suggests a “word event”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2155",
      "id": "footnote-2155-backlink"
    }
  }, [_c('sup', [_vm._v("8")])]), _vm._v(" that represents “the incursion of potent, sovereign word into the life of prophet and nation.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2154",
      "id": "footnote-2154-backlink"
    }
  }, [_c('sup', [_vm._v("9")])]), _vm._v(" This coming of Yahweh’s word initially happened on the occasion of Jeremiah’s commission in the thirteenth year of Josiah’s reign, 626 BC (see v. 7). On the reckoning in 1 Kgs 22–23, it was five years before Josiah’s reformation, though according to 2 Chr 34, the reformation had already been initiated, and Jeremiah’s commission would come between two stages in the reformation. Given that Jer 1 and Jer 25 constitute the beginning and midpoint of the scroll, the date will turn out to make a link with 25:3."), _c('a', {
    attrs: {
      "href": "#/#footnote-2153",
      "id": "footnote-2153-backlink"
    }
  }, [_c('sup', [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("3")]), _vm._v(" Whereas the initial reference to a message coming suggested a one-time event (the event on which vv. 4–19 will say more), v. 3 refers to a recurring series of events over subsequent decades: compare the plural "), _c('em', [_vm._v("words")]), _vm._v(" in v. 9. The preface thus provides information on the chronological/political background of the time. The other two kings listed reigned for nearly the entire period between their father Josiah and the fall of Jerusalem. The preface omits reference to Jehoahaz, who was also a son of Josiah and immediately succeeded him but reigned for only three months, to Jehoiakim’s son Jehoiachin, who also reigned for only three months between Jehoiakim and Zedekiah, and to events after the fall of Jerusalem that Jer 40–44 relate. Zedekiah did not see his year eleven to its end; the "), _c('em', [_vm._v("ending")]), _vm._v(" of his eleventh year likely denotes the termination of his reign, which came during his eleventh year (for which, see 39:2; 52:5–6). The fifth month of a year reckoned to begin at Passover will refer to July/August (see 52:1–16). The preface’s omitting mention of Zedekiah’s ousting and death is not remarkable in light of its leaving out equivalent information about the other two kings, though it might still be a telling omission. The scroll will name Zedekiah more often than the rest of the Judahite kings put together and will portray Jeremiah involved in ongoing conflict with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The list as a whole and the place where v. 3 ends indicate that they are tough times. Josiah lost his life in battle. Jehoahaz was deposed by the Egyptians. Jehoiakim experienced invasion and attack from the Babylonians and other local peoples. His son Jehoiachin was deposed and taken off to Babylon (though in 52:31–34 he is implicitly a symbol of hope). Zedekiah was maimed in the aftermath of the fall of Jerusalem. In addition, with varying degrees of specificity, 2 Kings sees all these kings as going back on Josiah’s reformation, as thus bringing trouble on their people, and as thereby earning the trouble that came to them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Nevertheless, the event that counts in 587 is not the humiliating and horrifying end of Zedekiah’s reign, nor his exile, imprisonment, and death (52:1–11). It is the city’s exile. Verse 3 thus concerns not merely the chronology of Jeremiah’s time but the content of his message. While other prophetic prefaces often mention kings, they do not mention historical events, as Jeremiah’s does. Further, this event is key to buttressing the idea that he was a true prophet. This closing reference to the exile in 1:1–3 pairs with the account of the city’s fall and the exile that concludes the scroll as a whole in 52:1–34. The two—especially in combination—imply a point about the fulfillment of Jeremiah’s message. The scroll as a whole will refer to events that followed on the fall of Jerusalem (see Jer 40–44), as it will refer to Jehoiachin. But v. 3, by stopping where it does, draws attention to the event that constituted the fulfillment of the warnings on which Jeremiah had been long focusing. Its stopping point is hardly a basis for hypothesizing that the preface originally introduced an earlier version of the scroll that did not include the account of events after the city’s fall. Ending where it does, the preface makes a theological point. The fact of the exile hangs over the scroll; “the book of Jeremiah holds the record for the variety of "), _c('em', [_vm._v("verbal phrases")]), _vm._v(" used to denote exile.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2152",
      "id": "footnote-2152-backlink"
    }
  }, [_c('sup', [_vm._v("11")])]), _vm._v(" Whether the city will fall is an open question through most of the scroll, but the preface knows that it will. And the scroll is written for people who know that the exile has happened, who need to understand it, and who need to know how to look to the future.")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("The patient God was offering a respite even, so to speak, down to the day before the Captivity, urging hearers to repent so that he may prevent the misfortune of the captivity. Hence it is written, Jeremiah prophesied until the captivity of Jerusalem, until the fifth month. The Captivity begins, and still he prophesied, saying something like this: “Become captives, provided in such circumstances you can repent! For when you repent, the misfortunes of the captivity will not transpire, but God’s mercy will be realized for you.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2151",
      "id": "footnote-2151-backlink"
    }
  }, [_c('sup', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Over against the fact that Jehoiakim and Zedekiah are the prominent kings in the scroll, events in the reign of Josiah, with its great reformation, are less prominent than one might have expected. Admittedly, any prophetic scroll is selective. There is no reason to think that the “Minor Prophets” (i.e., the Shorter Prophets) said less than the “Major Prophets” in the course of their ministries, but for one reason or another, fewer of their prophecies were preserved. Perhaps a related dynamic gave the Jeremiah scroll the length and the balance it manifests. The disastrous early death of Josiah and the religious and moral reversion that followed meant that his reformation failed to generate the escape from calamity that one might have hoped for and that Jeremiah might have envisaged. As the Jeremiah scroll sought to bring its challenging and encouraging message to the next generation or three, the failure of Josiah’s reformation was hardly a dynamic to draw attention to."), _c('a', {
    attrs: {
      "href": "#/#footnote-2150",
      "id": "footnote-2150-backlink"
    }
  }, [_c('sup', [_vm._v("13")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-29"
    }
  }, [_vm._v("B. "), _c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("JEREMIAH GIVES AN ACCOUNT OF HIS COMMISSION")]), _vm._v(" ("), _c('span', {
    staticClass: "rh_char2"
  }, [_vm._v("1:4–10")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vq"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("4")]), _vm._v("Yahweh’s message came to me: "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("a")])]), _vm._v(" "), _c('p', {
    staticClass: "vq_10"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("5")]), _vm._v("Before I formed you "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("b")]), _vm._v(" in [someone’s] insides, I acknowledged "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("c")]), _vm._v(" you;")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("before you went out from a womb, I sanctified you;")]), _vm._v(" "), _c('p', {
    staticClass: "vq_31"
  }, [_vm._v("the nations’ prophet "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("d")]), _vm._v(" I am making you. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("e")])]), _vm._v(" "), _c('p', {
    staticClass: "vq_prose"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("6")]), _vm._v("I said, “Oh no, Lord Yahweh! There, I don’t know how to speak, because I’m a kid.” "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("f")]), _vm._v(" "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("7")]), _vm._v("But Yahweh said to me,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_10"
  }, [_vm._v("Don’t say “I’m a kid,”")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("because to everyone "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("g")]), _vm._v(" that I send you to, you are to go,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("and everything that I order you, you are to speak.")]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("8")]), _vm._v("Don’t be afraid before them,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_31"
  }, [_vm._v("because I am with you to snatch you away (Yahweh’s affirmation). "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("h")])]), _vm._v(" "), _c('p', {
    staticClass: "vq_prose"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("9")]), _vm._v("Yahweh extended his hand and made it touch"), _c('span', {
    staticClass: "vq_ss-2"
  }, [_vm._v("i")]), _vm._v(" my mouth. And Yahweh said to me,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_10"
  }, [_vm._v("There, I’m putting my words in your mouth;")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("10")]), _vm._v("see, I’m appointing you this day")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("over the nations, yes, "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("j")]), _vm._v(" over the kingdoms,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_vm._v("To pull up "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("k")]), _vm._v(" and to pull down")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("and to wipe out and to smash;")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("to build "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("l")]), _vm._v(" and to plant. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("m")])]), _vm._v(" "), _c('p', {
    staticClass: "verse_note1"
  }, [_vm._v("a. Here and commonly elsewhere, the text includes the word "), _c('em', [_vm._v("lē")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("mōr")]), _vm._v(" (lit. “[by] saying”), which functions like a colon in English introducing a quotation. Some LXX MSS have “to him,” not “to me.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("b. The "), _c('em', [_vm._v("qere")]), _vm._v(" has "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("e")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("orkā")]), _vm._v(" from "), _c('em', [_vm._v("yā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("ar")]), _vm._v("; the "), _c('em', [_vm._v("ketiv")]), _vm._v(" implies "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("e")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("ûrkā")]), _vm._v(" from the byform "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("ûr")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("c. The common verb "), _c('em', [_vm._v("yāda")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(", meaning “know,” is frequently used with the connotation of “acknowledge” (e.g., 2:8; 5:4–5) and then with the more precise sense of “choose” (cf. Gen 8:19; Exod 33:12; Amos 3:2): “a knowledge not intuitive only, but also approbative” (J. A. Trapp, "), _c('em', [_vm._v("Commentary or Exposition upon These Following Books of Holy Scripture: Proverbs of Solomon, Ecclesiastes, the Song of Songs, Isaiah, Jeremiah, Lamentations, Ezekiel & Daniel")]), _vm._v(" [Kidderminster: Simmons, 1660], 221).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("d. While Vg translates, “I gave you to the nations as a prophet,” Tg takes "), _c('em', [_vm._v("laggôyim")]), _vm._v(" to imply “against the nations” and has Jeremiah commissioned to make them drink the chalice to which 25:15 will refer; it then takes the negative verbs in v. 10 to refer to the nations. Syr and some LXX MSS have “to the nation” (cf. 18:7, 9; HUBP).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("e. This third "), _c('em', [_vm._v("qatal")]), _vm._v(" verb is declarative/performative, denoting what Yahweh is doing at this moment, not what he did before Jeremiah was born; cf. the verbs in vv. 9, 10, and 18 (see the commentary there).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("f. MT has an intriguing marker here.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("g. Vg has “to all things”; Tg has “to every place” (implying that he will go to the nations).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("h. This extrametrical phrase recurs through the scroll, more often in MT than in LXX; McKane ("), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 1:6) nicely paraphrases “you have my word.” The entirety of v. 8 reappears in 42:11 as the promise that Jeremiah passes on to the rebels after the fall of Jerusalem.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("i. The verb "), _c('em', [_vm._v("wayyagga")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(" is "), _c('em', [_vm._v("hiphil")]), _vm._v(", from "), _c('em', [_vm._v("nāga")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(", as in Isa 6:7; LXX, Vg “touched” implies "), _c('em', [_vm._v("qal")]), _vm._v(" "), _c('em', [_vm._v("wayyigga")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("j. The "), _c('em', [_vm._v("wә")]), _vm._v(" is explicative.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("k. Vg translates all six verbs “so that you may …”")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("l. LXX, Vg, Syr prefix the verb with “and”; MT’s omission of “and” marks the switch from the negative infinitives to the positive ones.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("m. MT has a unit marker here. “Plant” is "), _c('em', [_vm._v("nā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("a")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(", which makes for further assonance with the first pair of verbs, though the similarity has a paradoxical significance: it belies the contrast in the words’ meaning.")]), _vm._v(" "), _c('p', {
    staticClass: "ind_grid"
  }, [_vm._v("Verses 4–10 and 11–19 form further elements in a prologue to the Jeremiah scroll as a whole. They provide more detailed answers to the three questions noted in connection with vv. 1–3, opening up themes and introducing key motifs:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The person of Jeremiah himself is important to the scroll.")]), _vm._v(" "), _c('li', [_vm._v("Jeremiah is to be a prophet who has to speak about the nations.")]), _vm._v(" "), _c('li', [_vm._v("Yahweh is committed to implementing his threats and promises when it doesn’t look as if he is.")]), _vm._v(" "), _c('li', [_vm._v("Disaster from the north is a central focus of Jeremiah’s message.")]), _vm._v(" "), _c('li', [_vm._v("The background to the disaster is Israel’s unfaithfulness to Yahweh.")]), _vm._v(" "), _c('li', [_vm._v("The restoration of Israel is also a motif in Jeremiah’s message.")]), _vm._v(" "), _c('li', [_vm._v("People will oppose him.")]), _vm._v(" "), _c('li', [_vm._v("He must live in ongoing obedience to Yahweh’s commission.")]), _vm._v(" "), _c('li', [_vm._v("Yahweh will protect him as he meets with opposition.")]), _vm._v(" "), _c('li', [_vm._v("He will need to be resolute in the fulfillment of his commission.")]), _vm._v(" "), _c('li', [_vm._v("Yahweh will be committed to enabling him to be resolute and unstoppable.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Verses 1–3 and 4–19 thus comprise parallel introductions to the entire scroll—vv. 1–3 in the third person with more stress on concrete chronology, vv. 4–19 in the first person with more stress on Jeremiah’s commission and on the scroll’s themes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Verses 4–10 and their continuation in vv. 11–19 parallel other accounts of a prophet’s commission and the accounts of the commissions of Moses and Gideon."), _c('a', {
    attrs: {
      "href": "#/#footnote-2149",
      "id": "footnote-2149-backlink"
    }
  }, [_c('sup', [_vm._v("14")])]), _vm._v(" As is the case with the giving of testimonies in some churches or the formulation of prayers, the existence of a familiar way of giving such an account facilitates an individual’s articulating their experience and also enables the listeners to recognize that the experience is real and that the prophet is the real thing; it constitutes his “credentials.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2148",
      "id": "footnote-2148-backlink"
    }
  }, [_c('sup', [_vm._v("15")])]), _vm._v(" A comparison with other commissions helps highlight the significance of typical features while also drawing attention to this account’s distinctive significance.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Jeremiah’s account comes near the beginning of the scroll, like Ezekiel’s and Hosea’s but unlike Isaiah’s and Amos’s. It forms part of the scroll’s framework.")]), _vm._v(" "), _c('li', [_vm._v("Like the preface, it summarizes the agenda of the scroll as a whole—like the preface to Hosea but unlike that to Ezekiel (which refers only to the equivalent of pulling up and pulling down). It thus seems likely to have been composed to introduce a collection of Jeremiah’s messages as a whole.")]), _vm._v(" "), _c('li', [_vm._v("It specifies that this message relates to “the nations.”")]), _vm._v(" "), _c('li', [_vm._v("It takes first-person form, like Ezekiel’s and Isaiah’s but unlike Amos’s and Hosea’s. It thereby draws attention to the extent to which Jeremiah personally participates in his commission; he is not simply an uninvolved messenger.")]), _vm._v(" "), _c('li', [_vm._v("It emphasizes Yahweh’s initiative in issuing the commission, as is the case with Amos. It is an initiative that antedates Jeremiah’s birth; it does not suggest that Jeremiah was seeking to discover what his vocation might be, had a sense of vocation, or thought in any way along these lines (and I avoid the word “call,” which carries considerable baggage). Jeremiah is not a volunteer like Isaiah, and there is no suggestion that Yahweh chooses him because he has the right gifts. If vocation is “the place where your deep gladness and the world’s deep hunger meet,” Jeremiah has no vocation, or his vocation is “a call to dissent.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2147",
      "id": "footnote-2147-backlink"
    }
  }, [_c('sup', [_vm._v("16")])])]), _vm._v(" "), _c('li', [_vm._v("It comprises a report by Jeremiah of dialogue between Yahweh and Jeremiah, but it is not a Bakhtinian dialogue; Jeremiah contributes only an objection that Yahweh overrules and a pair of observations that Yahweh then interprets. The vast bulk of the “dialogue” is Yahweh’s words.")]), _vm._v(" "), _c('li', [_vm._v("Like the preface, it underlines the factual or objective nature of what happens, as is the case with Ezekiel: “I am putting my words in your mouth.” Another significance of its dialogic form is to point to the reality of the event, as is the case with the commissions of Isaiah and Ezekiel."), _c('a', {
    attrs: {
      "href": "#/#footnote-2146",
      "id": "footnote-2146-backlink"
    }
  }, [_c('sup', [_vm._v("17")])])]), _vm._v(" "), _c('li', [_vm._v("It relates how Jeremiah resists his commission, like Jonah (and Moses and Gideon) but unlike Isaiah, Ezekiel, and Hosea. It thereby underscores the implication that Jeremiah really is fulfilling Yahweh’s commission. He is not doing what he wants to do.")]), _vm._v(" "), _c('li', [_vm._v("It incorporates a reassurance of Yahweh’s presence and a sign, like Moses’s and Gideon’s.")]), _vm._v(" "), _c('li', [_vm._v("It emphasizes the opposition Jeremiah will receive.")]), _vm._v(" "), _c('li', [_vm._v("Like the other accounts, it makes no direct reference to Jeremiah’s final response to Yahweh’s commission. The focus lies on Yahweh’s commission; implicitly, the rest of the scroll relates Jeremiah’s response."), _c('a', {
    attrs: {
      "href": "#/#footnote-2145",
      "id": "footnote-2145-backlink"
    }
  }, [_c('sup', [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Unlike Isaiah and Ezekiel, Jeremiah does not speak in terms of a vision,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2144",
      "id": "footnote-2144-backlink"
    }
  }, [_c('sup', [_vm._v("19")])]), _vm._v(" nor does he speak of hearing the sound of Yahweh’s voice like Samuel. I have myself had the experience of seeing God’s hand pointing at something, of sensing God’s embrace, and of having a conversation with God in which sometimes I might take an initiative and sometimes God might—though either way, God’s words were not an articulation of something that I was thinking anyway. And I am able to distinguish these experiences from the sense that an idea has come to me and from a conviction that God has been present with me that is based on things that have happened. Whereas it is proper to be concerned about literalism in interpreting accounts of a prophet’s experience, reductionism is a greater danger in the context of modernity, of the familiarity of Buddhism, and of new age thinking, and Jeremiah’s account invites readers to infer that “‘God’ is not a device for objectifying inner convictions.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2143",
      "id": "footnote-2143-backlink"
    }
  }, [_c('sup', [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("How did vv. 4–19 come into being? There are subsets to this question.")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("What were the roles of Jeremiah and his disciples? An obvious assumption is that a disciple wrote vv. 1–3 and Jeremiah dictated vv. 4–19. But a creative writer can write about someone else in the first person, and someone can write about him or herself in the third person.")]), _vm._v(" "), _c('li', [_vm._v("Are vv. 4–19 a transcript of what happened when Yahweh commissioned Jeremiah, are they a dramatization of the event as Gen 1 is a dramatization of creation, or are they something in between—an adaptation based on fact?")]), _vm._v(" "), _c('li', [_vm._v("Were they composed at the time of the event that they describe, in about 626 BC, were they composed from scratch as a dedicated introduction to the scroll sometime after the last events it relates, or do they represent a reworking of an account with a prehistory going back to that time?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("These questions open up many possibilities, which themselves embrace further alternatives (e.g., did the final work on the scroll and therefore on this introduction happen in the Babylonian period or in the Persian period?). The attempt to answer these questions and to interpret Jer 1 as a whole may profit from comparing and contrasting the chapter with Hos 1:1–2:1 (1:1–2:3).")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("The Hosea scroll, too, begins with a third-person preface.")]), _vm._v(" "), _c('li', [_vm._v("That preface leads into a narrative account of the beginning of Hosea’s activity as a prophet.")]), _vm._v(" "), _c('li', [_vm._v("That account derives from a period later than his original commission (Hosea has had time to marry and have several children).")]), _vm._v(" "), _c('li', [_vm._v("It incorporates a number of statements by Yahweh presented as his actual words.")]), _vm._v(" "), _c('li', [_vm._v("It offers a perspective on the message of the scroll as a whole.")]), _vm._v(" "), _c('li', [_vm._v("It emphasizes threats but incorporates promises.")]), _vm._v(" "), _c('li', [_vm._v("It presupposes the downfall of the nation, which fulfills the threats.")]), _vm._v(" "), _c('li', [_vm._v("It presupposes a time when the promises have not yet been fulfilled.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The major difference is that Hos 1:1–2:1 (1:1–2:3) takes third-person form while Jer 1:4–19 takes first-person form. As is the case in connection with Jer 1:1–3, one cannot simply infer that Hoseanic theologians composed the third-person Hosea narrative while Jeremiah himself composed the first-person Jeremiah narrative, but my best guess is that this assumption is actually correct. The most plausible scenario is that a theologian wrote Jer 1:1–3, that Jeremiah dictated vv. 4–19, that in doing so he adapted the facts and his memory of his commission so that the account could function as an introduction to the deposit of his work, and that he did so in the 580s or 570s. Verses 4–19 are then “a mature reflection on a youthful experience.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2142",
      "id": "footnote-2142-backlink"
    }
  }, [_c('sup', [_vm._v("21")])]), _vm._v(" That view is just one possible one."), _c('a', {
    attrs: {
      "href": "#/#footnote-2141",
      "id": "footnote-2141-backlink"
    }
  }, [_c('sup', [_vm._v("22")])]), _vm._v(" I have more confidence in the conviction that whoever were the authors of vv. 4–19, they were inspired by the Holy Spirit to portray Jeremiah having the experience it describes in light of the actual process whereby he came to be a prophet and of his activity as a prophet so that the scroll’s readers might take it as an introduction to the scroll that would help them understand it and respond to it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Verses 4–10 are mostly Yahweh’s words. Most of them manifest rhythm and parallelism that suggests they are poetic lines, which enhances their importance and eminence. Even the lines that lack parallelism are sufficiently rhythmic to make it feasible to lay out the entirety of Yahweh’s words as poetry, albeit prosaic poetry. They comprise four tricola with one bicolon at the center (4-4-3, 3-4-4, 2-3, 4-4-2, 2-2-2). In the first tricolon, the opening two cola are closely parallel; in the second tricolon, the closing two cola are closely parallel; in the third tricolon, the opening two cola are broadly parallel; in the final tricolon, all three cola are parallel, and they incorporate metaphor and paronomasia. In substance, vv. 4–10 follow an a-b-b′-a′ order:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("vv. 4–5")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Yahweh speaks, recalling his past preparation of Jeremiah as a prophet to the nations")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("v. 6")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline1"
  }, [_vm._v("Jeremiah objects")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("vv. 7–8")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline1"
  }, [_vm._v("Yahweh responds")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline-r"
  }, [_vm._v("vv. 9–10")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Yahweh acts, implementing his preparation of Jeremiah as a prophet to the nations")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The formal parallels with other accounts of commissioning, such as those of Moses, Gideon, Samuel, Isaiah, and Ezekiel, are clear:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 4")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A revelation from Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 5")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A commission from Yahweh")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 6")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("An objection")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 7")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A reply and a restated commission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 8")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A reassurance")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 9")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A sign")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 10")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("A restated commission")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Comparison with these other accounts indicates that here the revelation is brief (esp. compared with those to Samuel and Ezekiel) and the objection is brief (esp. compared with that of Moses). The objection mainly becomes the opportunity for a twice-restated elaboration on the commission, which is put briefly in v. 5, slightly more fully in v. 7, and most elaborately in v. 10. In the focus on the content of the commission, Jeremiah compares with Samuel and Isaiah.")]), _vm._v(" "), _c('p', {
    staticClass: "para_section"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("4")]), _vm._v(" Jeremiah’s opening formulation picks up the words of v. 2a: this is the message that came to him in the thirteenth year of Josiah’s reign.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("5a")]), _vm._v(" Forming or shaping like a potter (see Jer 18) is an image for God’s original creation of the human and animal world (Gen 2:7–8; Ps 95:5; Isa 45:18) but also for his bringing each person into being (Pss 33:15; 94:9; 45:7; see Jer 10:16). In particular, it is an image for bringing into being someone with a specific role to play in his service (Isa 49:5) and an image for bringing Israel into being (Isa 44:2)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2140",
      "id": "footnote-2140-backlink"
    }
  }, [_c('sup', [_vm._v("23")])]), _vm._v(" More than one of these ideas might apply here. Yahweh shaped Jeremiah as he shapes everyone. But here (paradoxically), he first "), _c('em', [_vm._v("acknowledged")]), _vm._v("—or chose or destined—Jeremiah for a particular role and then shaped him accordingly. Yahweh could have used the verb “chose,” which the First Testament applies to Abraham (Neh 9:7), Levi (Deut 18:5), Aaron (Ps 105:26), Saul (1 Sam 10:24), and David and Solomon (1 Chr 28:4–5). But “choice” simply implies taking responsibility, whereas “acknowledgment” implies making a commitment, as Jeremiah’s frequent use of the verb will reflect (e.g., 2:8; 4:22; 5:4–5). Yahweh made a commitment to Jeremiah before Jeremiah existed. To judge from the scroll, he shaped him as someone with a commitment to Yahweh, with imagination, and with sensitivity. Yahweh’s designation did not take place "), _c('em', [_vm._v("in")]), _vm._v(" the womb but before Jeremiah was even conceived. It is a unique designation in the First Testament, though paralleled by the designation of Jesus in Luke 1:26–38. Paul generalizes its point in Rom 8:29,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2139",
      "id": "footnote-2139-backlink"
    }
  }, [_c('sup', [_vm._v("24")])]), _vm._v(" and Jeremiah may help one understand Paul’s point: God foreknew people in the sense of acknowledging them ahead of time as people he intended to make part of his people because of something he wanted to achieve through them. In themselves, Yahweh’s words do not indicate whether he formed Jeremiah in a way that he did not form other people. The First Testament elsewhere assumes that Yahweh forms everyone in the womb. But it can also speak in general terms about “opening the womb” while elsewhere applying that expression to particularly significant births. Yahweh may have in mind a forming that applies to Jeremiah in a distinctive way because of the role he intends for him. But it’s the aim rather than the process that’s different.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The second colon forms a perfect complement to the first:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/80.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("The temporal expression repeats; the verb adds Jeremiah’s action (he had to come out) to Yahweh’s action; the second prepositional expression makes the first more precise; and the final verb rephrases the parallel one. The most significant new note in the second colon is that Yahweh has "), _c('em', [_vm._v("sanctified")]), _vm._v(" Jeremiah—that is, made him holy or sacred, dedicated him, or set him apart for his service ("), _c('em', [_vm._v("qādaš hiphil")]), _vm._v("). “Sanctifying” implies choosing someone in order to do what you wish with them, which is the regular connotation of the notion of choosing in the Scriptures. Sacredness is not a common theme in the Prophets except in Ezekiel, who is especially the priestly prophet; this difference illustrates how Jeremiah’s priestly background does not mean he thinks like a priest. Yahweh’s sanctifying Jeremiah is not equivalent to his cleansing Isaiah (Isa 6:5–7) or to his choosing kings and having them anointed (e.g., 1 Sam 9; 16), where the language of sacredness does not occur, or to his separating Israel from the worship commitments of the Canaanites (Deut 7:6). The focus on Jeremiah’s birth makes it closer to the sanctifying of firstborn (e.g., Num 3:13; 8:17), which is also the only context in the First Testament for the use of this ("), _c('em', [_vm._v("hiphil")]), _vm._v(") verb with a human object. Jeremiah is especially claimed by God, like the firstborn of human beings and animals. Within the Jeremiah scroll, its nearest parallel is the sanctifying of warriors (the "), _c('em', [_vm._v("piel")]), _vm._v(" verb; e.g., 22:7; 51:27–28, where sanctifying is associated with appointing). As sanctifying suggests dedicating Jeremiah for a special task that relates to Yahweh’s purpose, the aggressive nature of the vocation that Yahweh is giving Jeremiah (v. 10; also vv. 17–19) fits with this parallel."), _c('a', {
    attrs: {
      "href": "#/#footnote-2138",
      "id": "footnote-2138-backlink"
    }
  }, [_c('sup', [_vm._v("25")])]), _vm._v(" But the people who are most often the object of the "), _c('em', [_vm._v("piel")]), _vm._v(" verb in the First Testament are priests (e.g., Exod 28–29), so the verb does deserve reading in light of v. 1. Jeremiah is like Ezekiel after all. Both prophets had priestly lineage; neither prophet could function as a priest in the temple; both are appointed as prophets by an act of consecration—explicitly so appointed in Jeremiah’s case. In Israel and its royal court, there was such a thing as a prophetic office; people such as Nathan occupied it (e.g., 2 Sam 7; 1 Kgs 1). Jeremiah does not occupy this position, and in this sense it is misleading to speak of his being appointed to it."), _c('a', {
    attrs: {
      "href": "#/#footnote-2137",
      "id": "footnote-2137-backlink"
    }
  }, [_c('sup', [_vm._v("26")])]), _vm._v(" On the other hand, there is a prophetic office in Yahweh’s court that one could see Jeremiah as occupying (see Jer 23:21–22), and one could say that he is here reporting his appointment to that office (see v. 10).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("5b")]), _vm._v(" Given that the 4–4 bicolon was neatly complete, a third colon is a surprise at one level—though at another level it is not. One of the ways in which parallelism functions is by the first colon leaving open a question that the second resolves, and v. 5 as a whole functions this way. But in substance, the opening two cola are incomplete in the sense that they raise a question they do not answer. What did Yahweh shape Jeremiah for? What did he come out to do? The third colon answers the question. To put it another way, the middle colon functioned only to raise suspense, which the third colon resolves in the manner of the second colon in a bicolon. "), _c('em', [_vm._v("The nations’ prophet I am making you")]), _vm._v(". This is a speech act, equivalent to “I hereby make you.” The word order, with the description of Jeremiah as a prophet coming before the verb, underscores the significance of the designation. Admittedly, "), _c('em', [_vm._v("prophet")]), _vm._v(" ("), _c('em', [_vm._v("nābî")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _vm._v(") could have various resonances, like “minister” in English. In Israel, there were many prophets linked with sanctuaries or functioning on the king’s staff, offering advice to ordinary people and to the administration. Some would be committed to the faith in Yahweh that the First Testament affirms; some would be more open-minded. Some would be identified with the administration; some would find it easier to be more independent. To call Jeremiah a prophet is not an unequivocal compliment nor an unequivocal encouragement."), _c('a', {
    attrs: {
      "href": "#/#footnote-2136",
      "id": "footnote-2136-backlink"
    }
  }, [_c('sup', [_vm._v("27")])]), _vm._v(" Yet here, the designation is free of polemical undertones,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2135",
      "id": "footnote-2135-backlink"
    }
  }, [_c('sup', [_vm._v("28")])]), _vm._v(" despite the narratives that will follow in Jer 27–29 and in contrast to Amos 7:10–17, where Amos questions it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("What does it mean to be "), _c('em', [_vm._v("the nations’ prophet")]), _vm._v(" ("), _c('em', [_vm._v("nābî")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _vm._v(" "), _c('em', [_vm._v("laggôyim")]), _vm._v("; more literally “a prophet for the nations”)? “This is a very strange designation of a prophet.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2134",
      "id": "footnote-2134-backlink"
    }
  }, [_c('sup', [_vm._v("29")])]), _vm._v(" While v. 5b clarifies, it thus also tantalizes. Who are these nations? Ephraim and Judah (so that the nations are not set over against Israel—Israel is one of the nations)?"), _c('a', {
    attrs: {
      "href": "#/#footnote-2133",
      "id": "footnote-2133-backlink"
    }
  }, [_c('sup', [_vm._v("30")])]), _vm._v(" The regional and imperial powers Egypt, Assyria, and Babylon? Neighbors such as Philistia, Moab, and Ammon? While most prophets have to say things that relate to other nations, for Jeremiah this role will be more central—a fact that will emerge as the scroll unrolls. In v. 10, Yahweh will speak of Jeremiah being appointed about or against ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(") the nations; in 25:9, that formulation recurs, and "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("al")]), _vm._v(" unequivocally means “against.” Jeremiah 25–28 expands on this theme. The description recurs again in 46:1, in the introduction to the messages about different nations in Jer 46–51. In the shorter term within the scroll, Jeremiah will speak of the nations coming to acknowledge Yahweh (3:17; 16:19), of their seeking blessing like Israel’s (4:2), of Yahweh attending to them (9:25–26[24–25]), of Yahweh’s pouring out his wrath on them (10:25), and of them witnessing to what Yahweh does and to who Israel is (4:16; 6:18; 18:13). As far as we know, none of this speaking will be actually addressed to the nations themselves (unless in Jer 27). It will be addressed to Judah’s kings and their cabinets, to its priests and people (see v. 18), pointing out implications for foreign policy and religious policy and thus for what they need to decide to do. The Jeremiah scroll as a whole will suggest developing the idea of "), _c('em', [_vm._v("the nations’ prophet")]), _vm._v(" in at least two directions: It means Yahweh’s judgment is coming against the entire world of nations. It also means that they may turn to Yahweh and thus be built and planted."), _c('a', {
    attrs: {
      "href": "#/#footnote-2132",
      "id": "footnote-2132-backlink"
    }
  }, [_c('sup', [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah’s account prompts reflection on divine sovereignty, election, determination, and freewill,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2131",
      "id": "footnote-2131-backlink"
    }
  }, [_c('sup', [_vm._v("32")])]), _vm._v(" invites (as often happens) a rethinking of modern categories if we are to understand, and offers an alternative way of thinking about the issues in question. Did Jeremiah have a choice about being who he was and about being a prophet? It’s a logically odd question. Can I choose to be someone other than the person I am? Can I choose not to be myself? Sure! Will God let me make that choice? Maybe, maybe not. A vineyard owner (who stands for God) told his son to go and work in the vineyard, but he didn’t go (Matt 21:28–32). On the other hand, there are stories about people who try to decline God’s commission but fail (Moses, Saul, Jonah) and none about people who succeed in declining. Was Saul of Tarsus free to decline God’s “choice” (Acts 9:15) after Jesus knocked him off his horse? Was Jonah free to decline Yahweh’s commission after emerging from the fish? Sure! The dynamics of election are the dynamics of a personal interaction, and personal interactions don’t follow systematic rules. Jeremiah is about to join the company of people who try to resist God’s commission (people who decline to be themselves), and he is about to discover how Yahweh deals with his attempt as part of his relationship with him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("6")]), _vm._v(" “What different answers God’s chosen ones give to his voice!” (consider Amos, Isaiah, Moses)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2130",
      "id": "footnote-2130-backlink"
    }
  }, [_c('sup', [_vm._v("33")])]), _vm._v(" Whereas Yahweh’s words were poetically and vividly symmetrical and rhythmic, Jeremiah’s response is unpoetic and unrhythmic, suggesting his confusion and sense of panic. This feature forms part of the passage’s rhetoric; it helps establish that it was not because of his own inclination that Jeremiah delivered his message about Yahweh acting in wrath."), _c('a', {
    attrs: {
      "href": "#/#footnote-2129",
      "id": "footnote-2129-backlink"
    }
  }, [_c('sup', [_vm._v("34")])]), _vm._v(" "), _c('em', [_vm._v("Oh no")]), _vm._v(" is "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ăhâ")]), _vm._v("; the traditional translation “alas” is not far off. Jeremiah addresses the "), _c('em', [_vm._v("Lord Yahweh")]), _vm._v(", but there is something illogical about his response given that he is not responding to Yahweh as if Yahweh is a Lord. With further irony, he picks up one of Yahweh’s verbs: "), _c('em', [_vm._v("yāda")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(". Yahweh knew/acknowledged Jeremiah; Jeremiah doesn’t know/acknowledge speaking. How can he address nations or take part in cabinet debates? He’s a just a "), _c('em', [_vm._v("kid")]), _vm._v(" ("), _c('em', [_vm._v("na")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ar")]), _vm._v("). As a term denoting youth, the word might cover anything from a child to a young adult; David describes Absalom as a kid (2 Sam 18:5, 12), and King Solomon describes himself in the same terms—indeed, as a little kid (1 Kgs 3:7). While not much more than half of the First Testament occurrences of “kid” refer to someone of youthful years,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2128",
      "id": "footnote-2128-backlink"
    }
  }, [_c('sup', [_vm._v("35")])]), _vm._v(" nearly half refer to someone who is (for instance) a servant (the first “kids” in the Scriptures are men capable of marching many miles to take part in a battle: Gen 14:24) or an apprentice, which is the nuance suggested by Jeremiah’s reference to knowing "), _c('em', [_vm._v("how to speak")]), _vm._v(". While he may not be very old, and “understanding is gray hair for men” (Wisdom 4:9),"), _c('a', {
    attrs: {
      "href": "#/#footnote-2127",
      "id": "footnote-2127-backlink"
    }
  }, [_c('sup', [_vm._v("36")])]), _vm._v(" his point concerns not his youthfulness but his lack of expertise, training, or gifting. His objection is not so different from that of Moses in Exod 4:10–17. After v. 5, his response is and is not a surprise. He speaks like someone praying in the manner of a psalm of protest or lament;"), _c('a', {
    attrs: {
      "href": "#/#footnote-2126",
      "id": "footnote-2126-backlink"
    }
  }, [_c('sup', [_vm._v("37")])]), _vm._v(" it is significant that his first words should be of this kind."), _c('a', {
    attrs: {
      "href": "#/#footnote-2125",
      "id": "footnote-2125-backlink"
    }
  }, [_c('sup', [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("7")]), _vm._v(" “God’s only answer was to make His instructions clearer.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2124",
      "id": "footnote-2124-backlink"
    }
  }, [_c('sup', [_vm._v("39")])]), _vm._v(" Like Moses, Jeremiah subsequently shows a magnificent capacity to speak. It seems unlikely that God simply grafted on that capacity. It must be that Jeremiah didn’t know he had it, he had never tried to exercise it, or he means he doesn’t know what he would say. It is the last possibility that leads best into Yahweh’s answer here. Yahweh does not simply ignore Jeremiah’s objection but answers it, though the point is not immediately explicit. Again, Yahweh speaks in a tricolon, though here it is the second and third cola that are neatly complementary, once more comprising 4–4 cola through MT’s judicious use of hyphens:")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/84.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Jeremiah must go wherever he is told. Who is the "), _c('em', [_vm._v("everyone")]), _vm._v(" or where is the implicit everywhere? The nations are the antecedent of the statement, and 25:15 will have Jeremiah rhetorically sent to them."), _c('a', {
    attrs: {
      "href": "#/#footnote-2123",
      "id": "footnote-2123-backlink"
    }
  }, [_c('sup', [_vm._v("40")])]), _vm._v(" So this command does nothing to solve the problem Jeremiah raised, though the parallel colon will provide an answer as it covers the action that will follow on fulfilling the command in the first. But the first colon ignores the problem. First there is sending, and therefore there is a place (everywhere!), which makes things worse, and then there is to be the obedient going. Sending raises the question “To do what?” People are sent to do things, to discover things, to say things. But the designating of Jeremiah as a prophet makes the specification unsurprising: Jeremiah is sent "), _c('em', [_vm._v("to speak")]), _vm._v(", sent as a kind of messenger. In connection with the fulfillment of the first instruction, there is the ordering, therefore the content of the order (everything!), and therefore the obedient speaking, which solves the problem of Jeremiah’s correct apprehension that there is no way he can fulfill Yahweh’s commission on his own. This complementary colon corresponds to Yahweh’s promise concerning a prophet like Moses: “He will speak … everything that I order him” (Deut 18:18). We do not know whether Deut 18 antedates or postdates Jer 1, though in isolation from the broader considerations, it makes better sense to see Jer 1 portraying Jeremiah as a prophet like Moses than to see Deut 18 as promising someone like Jeremiah."), _c('a', {
    attrs: {
      "href": "#/#footnote-2122",
      "id": "footnote-2122-backlink"
    }
  }, [_c('sup', [_vm._v("41")])]), _vm._v(" Jeremiah fulfills Moses’s criteria for identification as a true prophet, though he needs not to be limited to reiterating what Moses said."), _c('a', {
    attrs: {
      "href": "#/#footnote-2121",
      "id": "footnote-2121-backlink"
    }
  }, [_c('sup', [_vm._v("42")])]), _vm._v(" The audience is implicitly challenged to respond to Jeremiah in a way that recognizes his identity in this connection."), _c('a', {
    attrs: {
      "href": "#/#footnote-2120",
      "id": "footnote-2120-backlink"
    }
  }, [_c('sup', [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("8")]), _vm._v(" Yahweh does now offer reassurance in a way appropriate to a lament-like protest such as Jeremiah has uttered,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2119",
      "id": "footnote-2119-backlink"
    }
  }, [_c('sup', [_vm._v("44")])]), _vm._v(" but it relates to a different problem, which Jeremiah hasn’t raised and apparently hasn’t thought of. Yahweh’s words are parallel with his response to that earlier problem:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 7")])]), _vm._v(" "), _c('td', {
    staticClass: "col40"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Don’t say …")])]), _vm._v(" "), _c('td', {
    staticClass: "col40"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("because …")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col15"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 8")])]), _vm._v(" "), _c('td', {
    staticClass: "col40"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Don’t be afraid …")])]), _vm._v(" "), _c('td', {
    staticClass: "col40"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("because …")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Literally, Yahweh bids Jeremiah not to be afraid of people’s faces—an unusual expression. It wouldn’t be surprising if he were afraid of the presence of the king and his cabinet or of other prophets (cf. vv. 17–19). But on the other occasions where Jeremiah uses the expression, it relates to the Babylonians (41:18; 42:11), and here the antecedent of "), _c('em', [_vm._v("them")]), _vm._v(" is the nations (v. 5). Within v. 8, the first colon thereby raises a question (How can Jeremiah not be afraid?), which the second colon answers. "), _c('em', [_vm._v("I am with you")]), _vm._v(" is then a key promise (cf. Exod 3:12; Judg 6:16; Isa 41:10; 43:5),"), _c('a', {
    attrs: {
      "href": "#/#footnote-2118",
      "id": "footnote-2118-backlink"
    }
  }, [_c('sup', [_vm._v("45")])]), _vm._v(" as is the undertaking "), _c('em', [_vm._v("to snatch you away")]), _vm._v("—more prosaically “to rescue you”—with the backing "), _c('em', [_vm._v("Yahweh’s affirmation")]), _vm._v(" that Jeremiah himself will attach to words from Yahweh to the people on countless occasions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("9")]), _vm._v(" Yahweh adds action to his words. So far, the commission has involved only a conversation. Jeremiah has simply had an awareness of Yahweh saying something, of responding, and of Yahweh replying. Although Jeremiah has indicated the objective nature of Yahweh’s speaking in the form of his words in v. 4, there need have been no divine words that anyone else heard and no words that Jeremiah outwardly articulated. But Yahweh now adds an action with an even more explicitly objective nature. Although, again, maybe no one else would have been able to sense it, simply to call it a vision might be misleading. Touching ("), _c('em', [_vm._v("nāga")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _vm._v(" "), _c('em', [_vm._v("hiphil")]), _vm._v(") recalls Isa 6:7 (also 1 Kgs 19:5, 7, and passages in Daniel, though there the verb is "), _c('em', [_vm._v("qal")]), _vm._v("). For both Isaiah and Jeremiah, there is a touching that deals with a problem they raise in connection with their commission, though the problems are different, and so is the significance of the touching. In Isa 6, a seraph applies a coal from the altar as a sacramental rite of cleansing. Here Yahweh’s touch overlaps in significance with Ezekiel’s eating a scroll that Yahweh gives him (Ezek 3): they are two ways by which Yahweh ensures that the prophet will speak Yahweh’s words. The action in Ezekiel suggests that Yahweh causes Ezekiel to internalize his perspective. The action in Jeremiah suggests that Yahweh causes Jeremiah to externalize his perspective. It is a performative action. Putting words in someone’s mouth means giving them a message that they will restate (Exod 4:15; 2 Sam 14:19; Ezra 8:17). Yahweh is here doing so in a once-for-all way for Jeremiah, opening his eyes (to use a different image) so that he sees how Yahweh views his people and grasps the message that has to be brought home to it. Yahweh thus continues the verbal performative action to which he referred in v. 5b, as he implements the plan formulated before Jeremiah’s birth: "), _c('em', [_vm._v("I’m putting")]), _vm._v(" is the same verb ("), _c('em', [_vm._v("nātan")]), _vm._v(") as "), _c('em', [_vm._v("I am making")]), _vm._v(" in v. 5, and Yahweh’s "), _c('em', [_vm._v("there")]), _vm._v(" ("), _c('em', [_vm._v("hinnēh")]), _vm._v(") corresponds to and confronts Jeremiah’s "), _c('em', [_vm._v("there")]), _vm._v(" in v. 6. At the same time, Yahweh’s words correspond further to his words concerning a prophet like Moses (Deut 18:18, except that there the verb is "), _c('em', [_vm._v("śîm")]), _vm._v("). The correspondence again marks Jeremiah as a fulfillment of that promise. These words “will tear down much that his audience believes.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2117",
      "id": "footnote-2117-backlink"
    }
  }, [_c('sup', [_vm._v("46")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("10")]), _vm._v(" The performative action and the implementing again continue. "), _c('em', [_vm._v("The nations’ prophet I am making you")]), _vm._v(" (v. 5) becomes "), _c('em', [_vm._v("I’m appointing you")]), _vm._v(" … "), _c('em', [_vm._v("/ over the nations, yes, over the kingdoms")]), _vm._v(". If there was a touch of ambiguity in v. 5, which one could translate as “I am giving you to the nations,” it is removed; Jeremiah is not a nice gift that Yahweh is “giving” the nations. He is appointing Jeremiah over them, as (ironically) Nebuchadrezzar will “appoint” Gedaliah “over” Judah (40:11). Yahweh adds reference to these nations being kingdoms, making more explicit that it will be kings such as Nebuchadrezzar, Pharaoh Neco, and the Median kings (e.g., 46:2; 51:11) over whom Jeremiah will be exercising authority—though in the immediate context the reference to kingdoms will be taken up in v. 15. Jeremiah is to be in charge of them. The implications are not yet made clear. Are the nations to be the victims of calamity from Yahweh? Are they to be Yahweh’s agents? Verses 14–15 will suggest that the answer to both questions is “yes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Yahweh has said nothing yet about Jeremiah being a prophet in relation to Israel, and one would initially assume that the six infinitives that now follow refer to action against these nations and their kings. Jeremiah will indeed involve himself with the potential fall of Babylon, and with the uprooting and wiping out of Judah’s neighbors—and their reestablishing (12:14–17). But he focuses more on the fall and recovery of Israel itself, and it is in this connection that these verbs recur in 18:1–12; 24:6; 31:27–28, 40; 42:10; 45:4. The six infinitives thus raise a question that will be clarified only as the scroll unrolls. Nor does Yahweh indicate the verbs’ subject. Is it Jeremiah? Is it the nations and kingdoms? Is it Yahweh himself? It will be Yahweh in the other passages that use these terms.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("The balance between the six verbs is simultaneously solemn and encouraging. On one hand, four have negative implications; on the other, at least Yahweh does not stop there. The balance between negative and positive is more favorable than it is in the eighth-century prophets, though less so than it is in Ezekiel (their respective chronological locations make a difference). John Cassian reports that Abba Nestoros says, with a reference to this verse, that it is twice as hard to drive out vice as to acquire virtue."), _c('a', {
    attrs: {
      "href": "#/#footnote-2116",
      "id": "footnote-2116-backlink"
    }
  }, [_c('sup', [_vm._v("47")])]), _vm._v(" But Jeremiah is talking about material as well as inward building and planting, not just salvation in an abstract sense."), _c('a', {
    attrs: {
      "href": "#/#footnote-2115",
      "id": "footnote-2115-backlink"
    }
  }, [_c('sup', [_vm._v("48")])]), _vm._v(" The balance is also more favorable than the one in Jeremiah’s actual messages. The difference would be encouraging for people reading the scroll in a context after the pulling up, pulling down, wiping out, and smashing have happened and hope is needed. At its very outset, the Jeremiah scroll, “which is so preoccupied with ‘exile’ … can anticipate the destruction of Babylon and the restoration of Jerusalem in the word pair ‘plant and build.’” The scroll is “designed to walk Jews into, through, and beyond the reality of destruction and exile.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2114",
      "id": "footnote-2114-backlink"
    }
  }, [_c('sup', [_vm._v("49")])]), _vm._v(" Perhaps the wording reflects the formulation of vv. 4–10 in that later context.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('em', [_vm._v("Pull up")]), _vm._v(" presupposes the image of a people as a plant such as a vine or an olive, apparently securely planted in its land but actually destined to be dug up. The image can apply to other peoples (12:14–17; 18:7) but it commonly applies to Israel in particular as a people planted in Canaan but in danger of being thrown out from that country (1 Kgs 14:15; 2 Chr 7:20; Pss 44:2[3]; 80:8[9]). It can also be a general metaphor to describe a people thriving like a plant or being uprooted from its land (Jer 31:40; 45:4; 2 Sam 7:10; 1 Chr 17:9; Ps 80:15[16]; Dan 11:4). While uprooting and planting is thus a familiar metaphor, "), _c('em', [_vm._v("pull down")]), _vm._v(" otherwise generally refers to the literal demolition of a structure (e.g., Jer 33:4; 39:8). The verbs for "), _c('em', [_vm._v("pull up")]), _vm._v(" and "), _c('em', [_vm._v("pull down")]), _vm._v(" are similar ("), _c('em', [_vm._v("nātaš")]), _vm._v(", "), _c('em', [_vm._v("nāta")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _vm._v("), which adds to the force of the double expression. "), _c('em', [_vm._v("Wipe out")]), _vm._v(" is a slightly less concrete term for terminating the life of something; "), _c('em', [_vm._v("smash")]), _vm._v(" has similar concrete implications to "), _c('em', [_vm._v("pull down")]), _vm._v(". The language is the language of war—of siege and deportation."), _c('a', {
    attrs: {
      "href": "#/#footnote-2113",
      "id": "footnote-2113-backlink"
    }
  }, [_c('sup', [_vm._v("50")])]), _vm._v(" But the four negative verbs do lead into two positive ones taking up the same imagery in a-b-b′-a′ order: "), _c('em', [_vm._v("pull down")]), _vm._v(" will give way to "), _c('em', [_vm._v("build")]), _vm._v(", and "), _c('em', [_vm._v("pull up")]), _vm._v(" to "), _c('em', [_vm._v("plant")]), _vm._v(". The building metaphor is, again, more innovative, whereas the planting metaphor is familiar as a term for placing a people (back) on its land or causing it to flourish there (cf. 2:21; 11:17; 32:41; 42:10; Amos 9:15).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Typically, Yahweh’s words leave open whether demolition/uprooting and building/planting are alternatives between which Judah must choose (which is the situation up until 587), experiences that will follow one another if Judah does not respond to the prophet (which is how things work out), or alternatives between which the recalcitrant and the repentant will "), _c('em', [_vm._v("de facto")]), _vm._v(" choose. Whereas in v. 3, with hindsight, the future was closed, here it is open. “The choice before us,” Jeremiah would urge, is “repentance or ruin.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2112",
      "id": "footnote-2112-backlink"
    }
  }, [_c('sup', [_vm._v("51")])]), _vm._v(" And if or when God decides to demolish, demolition will happen. But when God decides to plant, planting will take place. Jeremiah’s audience might hope that the four negative verbs indicate Yahweh’s intention for the nations, which facilitates the action on Israel’s behalf indicated by the positive verbs."), _c('a', {
    attrs: {
      "href": "#/#footnote-2111",
      "id": "footnote-2111-backlink"
    }
  }, [_c('sup', [_vm._v("52")])]), _vm._v(" If anything, the opposite is the case."), _c('a', {
    attrs: {
      "href": "#/#footnote-2110",
      "id": "footnote-2110-backlink"
    }
  }, [_c('sup', [_vm._v("53")])]), _vm._v(" But subsequent chapters of the scroll will imply that the two possibilities applying to Judah indeed also apply to the nations."), _c('a', {
    attrs: {
      "href": "#/#footnote-2109",
      "id": "footnote-2109-backlink"
    }
  }, [_c('sup', [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With a side look at the spiritual teachers and theologians of his day, Jesus comments that any plant that his Father has not planted will be pulled up. He also declares that structures built on sand, not rock (that is, not built on obedience to his teaching), will be demolished. Indeed, he will consume it with the breath of his mouth. So his servant’s work had better take into account that the people of God is God’s planting, God’s building (Matt 7:25–27; 15:13; 2 Thess 2:8; 1 Cor 3:19)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2108",
      "id": "footnote-2108-backlink"
    }
  }, [_c('sup', [_vm._v("55")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-30"
    }
  }, [_vm._v("C. "), _c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("JEREMIAH REPORTS A MESSAGE FROM YAHWEH")]), _vm._v(": HE IS GOING TO DO WHAT HE HAS SAID ("), _c('span', {
    staticClass: "rh_char2"
  }, [_vm._v("1:11–12")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vq_prose"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("11")]), _vm._v("Yahweh’s message came to me: “What are you looking at, Jeremiah?” I said, “A watcher cane is what I’m looking at.” "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("12")]), _vm._v("Yahweh said to me, “You’ve done well in looking, because I’m keeping watch over "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("a")]), _vm._v(" my message, to act on it.” "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("b")])]), _vm._v(" "), _c('p', {
    staticClass: "verse_note1"
  }, [_vm._v("a. Syr, Tg have “hastening.”")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("b. MT has a marker here.")]), _vm._v(" "), _c('p', {
    staticClass: "para_grid"
  }, [_vm._v("See the introduction to vv. 4–10 above. These verses simply add a confirmation that Yahweh is definitely going to do what he said there. As the poetry added weight to the message in vv. 4–10 (it will do so again in vv. 17–19), here the quasi-visionary form, the questioning of the prophet, and the eventual responsive message from Yahweh have the same effect. To put it another way, in this subsection, v. 12b alone contains Yahweh’s message. In content, vv. 11–12a do nothing, but they make a significant contribution to the impact of the message. There is no indication that the report relates something that happened soon after the commission described in vv. 4–10; it would make sense somewhat later, when the question concerning Yahweh’s fulfilling his threats became pressing.")]), _vm._v(" "), _c('p', {
    staticClass: "para_section"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("11")]), _vm._v(" Jeremiah sees something of an everyday kind: a "), _c('em', [_vm._v("cane")]), _vm._v(" that one might use while walking; it happens to come from an almond tree, whose Hebrew name can also mean "), _c('em', [_vm._v("watcher")]), _vm._v(". Perhaps Jeremiah sees it only in his imagination, though that idea complicates things unnecessarily."), _c('a', {
    attrs: {
      "href": "#/#footnote-2107",
      "id": "footnote-2107-backlink"
    }
  }, [_c('sup', [_vm._v("56")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("12")]), _vm._v(" The almond tree blossoms in a way that heralds the approach of spring, and the Syriac version of the Story of Ahiqar (2:7) urges, “Be not in a hurry, like the almond tree, whose blossom is the first to appear, but whose fruit is the last to be eaten.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2106",
      "id": "footnote-2106-backlink"
    }
  }, [_c('sup', [_vm._v("57")])]), _vm._v(" But it seems unlikely that the Hebrew name of the almond tree ("), _c('em', [_vm._v("šāqēd")]), _vm._v(") actually means that it is watching ("), _c('em', [_vm._v("šāqad")]), _vm._v(") for spring, which makes little sense. Anyway, Jeremiah does not see a blossoming branch but a stick. More likely, his point depends on a paronomasia: the tree’s name happens to recall the word for "), _c('em', [_vm._v("keeping watch")]), _vm._v(". In connection with the six verbs in v. 10, Jeremiah will later speak of Yahweh keeping watch over Judah (31:28), though in the short term that watchfulness or keeping an eye on Judah will not be a comfort (cf. 44:27; Dan 9:14; see also Isa 29:20). “Keep watch” is not a comforting verb (see 5:6). Here the expression involves a metonymy: Yahweh is keeping watch over his message, which means he is paying attention to it and intends to act on it. In the arrangement of vv. 4–12, "), _c('em', [_vm._v("my message")]), _vm._v(" suggests the intention indicated by v. 10, so the metonymy extends the lack of specificity concerning the object of the verbs there. In the broader context of vv. 1–3 and of the chapters that will follow, the message would be that there is terrible trouble on its way but then wondrous renewal. The first will seem never to arrive, though eventually it does. The second will seem hopelessly implausible, and Jeremiah will not see it arrive. But Yahweh will be watching over both aspects of the message. He does not declare the intention to act soon. Rather, he is promising definitely to act in due course. The promise is significant in the context of there being the long gap between his declarations and his actions, to which Jeremiah periodically refers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("It is tempting for the church to think that it is responsible to see to its future. Here, watching is God’s responsibility, not Jeremiah’s. “He does not have to worry and wonder about the success of the word …; he is only to be faithful in speaking and embodying that word.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2105",
      "id": "footnote-2105-backlink"
    }
  }, [_c('sup', [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("If God’s people are selected for some special mission, if God’s people speak God’s word, and NOTHING HAPPENS, what then? What then? The answer that is preserved in this text … does not seem to answer the question. God’s response is that his word is his word! The prophet is to speak all God directs him to speak. The prophet is not to set himself as judge to determine whether God is fulfilling his word."), _c('a', {
    attrs: {
      "href": "#/#footnote-2104",
      "id": "footnote-2104-backlink"
    }
  }, [_c('sup', [_vm._v("59")])])]), _vm._v(" "), _c('h1', {
    staticClass: "sec2",
    attrs: {
      "id": "sec2-31"
    }
  }, [_vm._v("D. "), _c('span', {
    staticClass: "rh_char1"
  }, [_vm._v("JEREMIAH REPORTS A SECOND MESSAGE FROM YAHWEH")]), _vm._v(": HE INTENDS TO BRING DISASTER ON JUDAH, AND JEREMIAH MUST BE BOLD ("), _c('span', {
    staticClass: "rh_char2"
  }, [_vm._v("1:13–19")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "vq_prose"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("13")]), _vm._v("Yahweh’s message came to me a second time: “What are you looking at?” I said, “A fanned "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("a")]), _vm._v(" pot is what I’m looking at, its face facing from northward.” "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("b")]), _vm._v(" "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("14")]), _vm._v("Yahweh said to me, “From the north there will open out dire trouble on all the people who live in the country. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("c")]), _vm._v(" "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("15")]), _vm._v("Because here am I, calling to all the kin groups of the kingdoms to the north "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("d")]), _vm._v(" (Yahweh’s affirmation). They will come and put each one his throne "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("e")]), _vm._v(" at the opening to Jerusalem’s gateways, against all its walls all around, and against all Judah’s towns. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("16")]), _vm._v("I will speak out my authoritative decisions to them "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("f")]), _vm._v(" because of all their dire action in that they have abandoned me and burned offerings "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("g")]), _vm._v(" to other gods and bowed down to things their hands made. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("h")])]), _vm._v(" "), _c('p', {
    staticClass: "vq_10"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("17")]), _vm._v("So you—you are to belt around your hips,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("and set to and speak to them")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("everything that I myself will order you.")]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_vm._v("Don’t break down "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("i")]), _vm._v(" from before them,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("so that I don’t break you down "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("j")]), _vm._v(" before them.")]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("18")]), _vm._v("But I: here,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("I am making you today")]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_vm._v("A fortified town, an iron pillar, "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("k")])]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("bronze walls "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("l")]), _vm._v(" over against the entire country,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_vm._v("For Judah’s kings and for its officials,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_21"
  }, [_vm._v("for its priests "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("m")]), _vm._v(" and for the people of the country. "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("n")])]), _vm._v(" "), _c('p', {
    staticClass: "vq_20"
  }, [_c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("19")]), _vm._v("They will battle against you, but they will not win over you,")]), _vm._v(" "), _c('p', {
    staticClass: "vq_31"
  }, [_vm._v("because I will be with you (Yahweh’s affirmation) to snatch you away.” "), _c('span', {
    staticClass: "vq_ss"
  }, [_vm._v("o")])]), _vm._v(" "), _c('p', {
    staticClass: "verse_note1"
  }, [_vm._v("a. This expression involves another metonymy; it is the fire under the pot that is fanned.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("b. Lit. “its face from before northward.” While the expression is thus tortuous, its meaning is clear enough. In a word such as "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("āpônâ")]), _vm._v(", the apparently locative ending need not be pressed: "), _c('em', [_vm._v("mibbābelâ")]), _vm._v(" (27:16) simply means “from Babylon,” "), _c('em', [_vm._v("bәriblātâ")]), _vm._v(" (52:10) simply means “at Riblah” (GKC 90e); cf. v. 15.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("c. In light of vv. 4–10, readers might assume that "), _c('em', [_vm._v("hā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("āre")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _vm._v(" means “the world” (cf. 25:29, 30), but in vv. 15–16, Jeremiah is making a transition to talk about disaster for Judah (cf. the same phrase in 6:12; 10:18).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("d. The double phrase combines expressions that appear separately in 25:9 (and cf., e.g., 10:25; 25:26), and LXX omits "), _c('em', [_vm._v("the kin groups of")]), _vm._v(". In MT, kin groups ("), _c('em', [_vm._v("mišpā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(") appropriately arrive to deliver the authoritative decisions ("), _c('em', [_vm._v("mišpā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _vm._v(") in the next verse.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("e. This sentence involves a further metonymy: it is the kings rather than the kingdoms that will set up their thrones.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("f. MT has "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ôtām")]), _vm._v(", a second object for the verb, as in 4:12; 12:1 (cf. DG 94 remark 4; "), _c('em', [_vm._v("IBHS")]), _vm._v(" 10.3.1c); some medieval mss imply "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ittem")]), _vm._v(" (“with them”) as in 39:5; 52:9 ("), _c('em', [_vm._v("BHS")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("g. The verb may refer specifically to burning food offerings; so D. Edelman, “The Meaning of "), _c('em', [_vm._v("qi")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ēr")]), _vm._v(",” "), _c('em', [_vm._v("VT")]), _vm._v(" 35 (1985): 395–404.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("h. For MT’s plural "), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ăśê")]), _vm._v(", Vg implies singular "), _c('em', [_vm._v("ma")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("ăśēh")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("i. "), _c('em', [_vm._v("Tē")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("at")]), _vm._v(" from "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ātat")]), _vm._v(" might be "), _c('em', [_vm._v("qal")]), _vm._v(" (BDB) or "), _c('em', [_vm._v("niphal")]), _vm._v(" ("), _c('em', [_vm._v("HALOT")]), _vm._v(", "), _c('em', [_vm._v("DCH")]), _vm._v("); if it is "), _c('em', [_vm._v("niphal")]), _vm._v(", the meaning will be intransitive rather than passive.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("j. Vg “don’t be afraid … because I will not let you be fearful” is suggestive and profound, but “because” is not a plausible rendering of "), _c('em', [_vm._v("pen")]), _vm._v(", and if one translates "), _c('em', [_vm._v("pen")]), _vm._v(" “lest,” then “don’t be afraid … lest I make you fearful” makes poor sense. LXX “nor be terrified before them” also raises difficulties with the verb and with "), _c('em', [_vm._v("pen")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("k. LXX lacks "), _c('em', [_vm._v("an iron pillar")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("l. Possibly intensive: “a great bronze wall” (Lundbom, "), _c('em', [_vm._v("Jeremiah 1–20")]), _vm._v(", 245); LXX, Vg, Syr, Tg have singular as in 15:20.")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("m. Syr nicely adds prophets (cf. 2:26; 32:32) while LXX lacks "), _c('em', [_vm._v("for its priests")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("n. "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("Am hā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("āre")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _vm._v(" (cf. 34:19; 37:2; 52:25) may denote the Judahites in general or may be a technical term for landowners (see E. Lipiński, “"), _c('span', {
    staticClass: "hebrew",
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("עַם")]), _vm._v(" "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("am")]), _vm._v(",” "), _c('em', [_vm._v("TDOT")]), _vm._v(", 11:174–75).")]), _vm._v(" "), _c('p', {
    staticClass: "verse_note"
  }, [_vm._v("o. MT has a unit marker here.")]), _vm._v(" "), _c('p', {
    staticClass: "para_grid"
  }, [_vm._v("See the introduction to vv. 4–10 above. This further report of a message arising from something Jeremiah sees follows up the commission in vv. 4–10 and parallels vv. 11–12 in its question and answer form:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Jeremiah introduces the fact that Yahweh is speaking.")]), _vm._v(" "), _c('li', [_vm._v("Yahweh asks Jeremiah what he is looking at.")]), _vm._v(" "), _c('li', [_vm._v("Jeremiah gives the answer.")]), _vm._v(" "), _c('li', [_vm._v("Yahweh tells Jeremiah what the sight signifies.")])]), _vm._v(" "), _c('p', {
    staticClass: "para1"
  }, [_vm._v("Here, however, the initial comment on what Jeremiah is looking at, in v. 14, leads into a much longer explanation of the implications of what he has seen, in vv. 15–19. The report fulfills a different function from the one in vv. 11–12. It does more than confirm that Yahweh will act as he said; indeed, it fulfills a number of different functions:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("It indicates the means by which Yahweh will do as he said in exercising his authority over kingdoms to bring about a catastrophe in Judah (v. 15).")]), _vm._v(" "), _c('li', [_vm._v("It explains why he intends to take this action (v. 16).")]), _vm._v(" "), _c('li', [_vm._v("It reasserts his command to Jeremiah to pass on his message (v. 17).")]), _vm._v(" "), _c('li', [_vm._v("It promises that Yahweh will protect him as he does so, when people attack him (vv. 18–19).")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("As happened in vv. 11–12, the initial report of the quasi-visionary experience reveals Yahweh’s message only in its second part (v. 14), but the introduction (v. 13) contributes to the impact of the actual message. Like vv. 11–12, vv. 13–14 use prose to report the event, and vv. 15–16 continue in prose to report Yahweh’s expansion of his message. But his instructions and promises to Jeremiah himself (vv. 17–19) then take poetic form, as was the case in vv. 4–10. The poetry is even more prosaic than that in vv. 4–10, but the lines manifest rhythm, parallelism, and metaphor (see v. 18). After an opening tricolon, five bicola follow, the middle three being syntactically interdependent. Whereas Yahweh’s declarations of intent concerning Judah are thus expressed straightforwardly and factually in vv. 13–16, his instructions and promises are once more enhanced in their importance and eminence by their mildly poetic form in vv. 17–19.")]), _vm._v(" "), _c('p', {
    staticClass: "para_section"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("13")]), _vm._v(" Jeremiah again spots something (perhaps only in his imagination) that Yahweh uses to trigger an awareness of a message. Jeremiah sees a seething cooking pot on a fire with its opening facing toward him; he is aware that he is south of it. The reference to its face may suggest it is tilted and thus about to boil over, though there is no need for that assumption; the quasi-vision again operates verbally at least as much as visually, working first with an assonance between "), _c('em', [_vm._v("fanned")]), _vm._v(" ("), _c('em', [_vm._v("nāpûa")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(") and "), _c('em', [_vm._v("from northward")]), _vm._v(" ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("āpônâ")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("14")]), _vm._v(" In an extension of the assonance, Yahweh enables the pot to trigger an awareness that something is going to "), _c('em', [_vm._v("open out")]), _vm._v(" ("), _c('em', [_vm._v("pāta")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _vm._v(" "), _c('em', [_vm._v("niphal")]), _vm._v("). Opening is what gates, windows, a mouth, ears, or a fountain does, which makes one anticipate something good."), _c('a', {
    attrs: {
      "href": "#/#footnote-2103",
      "id": "footnote-2103-backlink"
    }
  }, [_c('sup', [_vm._v("60")])]), _vm._v(" But this pot is going to open out "), _c('em', [_vm._v("dire trouble")]), _vm._v(" that will overwhelm everyone. “Jeremiah threatens disaster, indeed only disaster.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2102",
      "id": "footnote-2102-backlink"
    }
  }, [_c('sup', [_vm._v("61")])]), _vm._v(" The picture complements the one in vv. 11–12. That earlier image simply affirmed that something was going to happen without indicating whether it was good or bad; this image resolves the ambiguity. The calamity will pour out from the north, the direction from which invaders commonly come. Assyria is in the north in Zeph 2:13; Babylon is in the north in Jeremiah; Media is implicitly in the north for Babylon itself in 50:9; and Gog is the north in Ezek 38:15. The multiple applications of the motif suggest that it combines political with supra-political reference and geographical with supra-geographical reference; "), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṣ")]), _c('em', [_vm._v("āpôn")]), _vm._v(" can suggest the divine abode."), _c('a', {
    attrs: {
      "href": "#/#footnote-2101",
      "id": "footnote-2101-backlink"
    }
  }, [_c('sup', [_vm._v("62")])]), _vm._v(" The northern threat for Judah will recur through Jer 1–13, though only in 20:4–6 will Babylon be named, and only in 25:9 will Babylon at last be identified as the invader from the north. But here, even now, “God testifies that the fire was already kindled in Chaldea and Assyria.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2100",
      "id": "footnote-2100-backlink"
    }
  }, [_c('sup', [_vm._v("63")])]), _vm._v(" Meanwhile, “the absence of a historical referent for the ‘boiling pot, tilted from the north,’ at the beginning of the book strikes an ominous note and is all the more fearsome for its lack of specificity. The threat from the north is greater than any human enemy. Boiling, burning fluid, tipped over and uncontrolled, advances upon Judah and Jerusalem with unstoppable horror.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2099",
      "id": "footnote-2099-backlink"
    }
  }, [_c('sup', [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("15")]), _vm._v(" Whereas vv. 11–12 incorporated only a one-line interpretation of the watcher cane, vv. 15–16 offer a more substantial amplification of the cooking pot. While the audience could assume even in vv. 13–14 that Jeremiah is talking about the nations as the victims of Yahweh’s attack, now its objects become explicit. Jeremiah’s rhetoric compares with that in Amos 1–2. First, open up the possibility of trouble coming for other people; then, when the Israelite audience is sitting pleased with itself, put the boot in."), _c('a', {
    attrs: {
      "href": "#/#footnote-2098",
      "id": "footnote-2098-backlink"
    }
  }, [_c('sup', [_vm._v("65")])]), _vm._v(" The picture is hyperbolic or mythic,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2097",
      "id": "footnote-2097-backlink"
    }
  }, [_c('sup', [_vm._v("66")])]), _vm._v(" though slightly reminiscent of the invasion by four northern kings in Gen 14; it imagines the arrival of an enhanced version of such a coalition. Prosaically speaking, a commander-in-chief sets down his royal seat outside a capital city that he intends to capture, and he has his officers take their places around the city’s "), _c('em', [_vm._v("walls")]), _vm._v(" and around the other fortified "), _c('em', [_vm._v("towns")]), _vm._v(" in the country. "), _c('em', [_vm._v("Jerusalem’s gateways")]), _vm._v(" could include the gateways of the temple courtyard (e.g., 7:2; 22:4), and the image of a pillar in v. 18 suggests the temple (e.g., 27:19; 52:17, 20–22). The commander-in-chief waits for the city to surrender when it runs out of food and water (if he has plenty of time) or orders an assault (if he wants to be able to move on to the next recalcitrant people) before walking in due course through the gates as the city’s conqueror. A northern king will do this in Jerusalem in 597 and in 587 (39:1–3).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("16a")]), _vm._v(" There is a further ambiguity to Jeremiah’s report. The idea of nations gathering around Jerusalem and planning to assault it recurs in the First Testament: see Isa 28–32; 36–37; Pss 46–48; Joel 3(4). In each case, in varying ways, the scenario works out differently than they expect, giving Jerusalem reason for relief and rejoicing as it turns out that the nations have gathered to be overwhelmed, not to overwhelm."), _c('a', {
    attrs: {
      "href": "#/#footnote-2096",
      "id": "footnote-2096-backlink"
    }
  }, [_c('sup', [_vm._v("67")])]), _vm._v(" Jeremiah’s audience could hear his vision report within one of these frameworks but then could be as mistaken as they imagine the nations being. The rhetoric again works against them. There is a further metaphorical aspect to the report. While a royal commander-in-chief may take a suitable seat on a campaign, a "), _c('em', [_vm._v("throne")]), _vm._v(" belongs in another context. It is where a king sits to exercise authority, to announce "), _c('em', [_vm._v("authoritative decisions")]), _vm._v(" ("), _c('em', [_vm._v("mišpā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _vm._v("), to issue judgments. It is for this reason that the king will sit on his throne outside Jerusalem. He is there to issue Yahweh’s judgment against the city, against "), _c('em', [_vm._v("them")]), _vm._v(". Yahweh’s bringing dire trouble (v. 14), in the sense of a horrifying and disastrous cataclysm, is a response to Judah’s "), _c('em', [_vm._v("dire action")]), _vm._v("—that is, their unfaithfulness, their wrongdoing. Jeremiah frequently uses the same word ("), _c('em', [_vm._v("rā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("â")]), _vm._v(") to denote both what is "), _c('em', [_vm._v("dire")]), _vm._v(" in the latter sense (the action) and what is "), _c('em', [_vm._v("dire")]), _vm._v(" in the former sense (the consequences), suggesting that the consequences issue “naturally” from the action or that Yahweh ensures that they do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("16b")]), _vm._v(" There are three overlapping charges against Judah. They "), _c('em', [_vm._v("have abandoned me")]), _vm._v(": they owed Yahweh faithfulness, and they have not shown it. This charge will recur. They have "), _c('em', [_vm._v("burned offerings to other gods")]), _vm._v(". The verb ("), _c('em', [_vm._v("qā")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ar piel")]), _vm._v(") comes from the word for incense ("), _c('em', [_vm._v("qә")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ṭ")]), _c('em', [_vm._v("ōret")]), _vm._v(") and strictly suggests the offering up of a sacrifice in flames accompanied by the fragrance of incense, but it functions by synecdoche to denote the entire process of sacrifice. And they have "), _c('em', [_vm._v("bowed down to things their hands made,")]), _vm._v(" contravening a fundamental requirement of Israel’s relationship with Yahweh (Exod 20:4–5); indeed, human religion is all humanly-made. All three charges have parallels in the critique Huldah issued to Hilkiah (2 Kgs 22:17), and all three will recur throughout the Jeremiah scroll (e.g., 2:13, 17, 19; 5:7, 19; 7:9; 8:2; 10:3, 9; 11:12, 13, 17; 13:10). “Idolatry” in the sense of “worship of false gods” is “fundamentally the most serious charge that any ancient Israelite could face.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2095",
      "id": "footnote-2095-backlink"
    }
  }, [_c('sup', [_vm._v("68")])]), _vm._v(" Yahweh is thus commissioning Jeremiah to confront Judah in connection with its faithlessness toward him rather than the people’s faithfulness toward one another; and the question with which the Jeremiah scroll faces the church is whether it is faithful toward God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("17a")]), _vm._v(" There is no break in Yahweh’s words and no suggestion of a formal transition from one section to another, but the last three verses in Jeremiah’s report lift their eyes to drive home the implications of the report for Jeremiah himself in a way that continues the theme of vv. 4–10. “To work,” Yahweh says."), _c('a', {
    attrs: {
      "href": "#/#footnote-2094",
      "id": "footnote-2094-backlink"
    }
  }, [_c('sup', [_vm._v("69")])]), _vm._v(" As a bidding addressed to Jeremiah, the words make a transition to poetry to underscore their importance for him. A prophet’s words such as the ones in vv. 13–16 can always give the impression of declaring something that is inevitably going to happen, but Jeremiah makes more explicit than other prophets that their fulfillment depends for good and ill on the response they receive (see 18:1–11). Jeremiah’s job is to declare Yahweh’s intentions so as to elicit a response. So he is to secure his clothing around himself to keep it from getting in his way (compare the English phrase “roll up your sleeves”) as he takes up the challenge Yahweh has put before him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("17b")]), _vm._v(" The first colon in Yahweh’s prohibition restates an earlier one:")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 8")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Don’t be afraid before them")])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "col25"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("v. 17")])]), _vm._v(" "), _c('td', {
    staticClass: "col70"
  }, [_c('p', {
    staticClass: "outline"
  }, [_vm._v("Don’t break down before them")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Earlier, the potential object of Jeremiah’s fear was the nations whose prophet he was to be. Here, the fear relates to Judah, of which the immediately preceding verses have now explicitly spoken."), _c('a', {
    attrs: {
      "href": "#/#footnote-2093",
      "id": "footnote-2093-backlink"
    }
  }, [_c('sup', [_vm._v("70")])]), _vm._v(" In v. 8, the exhortation included a promissory reassurance, which will recur in v. 19. In the meantime, if readers expect simple repetition, they get something different: a threatening warning. Like the English expression, "), _c('em', [_vm._v("break down")]), _vm._v(" ("), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ḥ")]), _c('em', [_vm._v("ātat")]), _vm._v(", "), _c('em', [_vm._v("niphal")]), _vm._v(" then "), _c('em', [_vm._v("hiphil")]), _vm._v(") can have both a physical and a psychological meaning. Yahweh works with both. If Jeremiah breaks down psychologically because of them (lit. “from their face/presence”), Yahweh will bring physical disaster on him through them (“to their face/presence”).")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("18")]), _vm._v(" But a promise backs up the exhortation. It takes the familiar form of a divine undertaking to protect and deliver,"), _c('a', {
    attrs: {
      "href": "#/#footnote-2092",
      "id": "footnote-2092-backlink"
    }
  }, [_c('sup', [_vm._v("71")])]), _vm._v(" which can address someone about to do battle, though here Jeremiah’s battle is a verbal one. Yahweh again speaks performatively. In the very act of speaking with Jeremiah in this way, Yahweh is acting on him psychologically and physically. Following the sequence in the pronouns in vv. 6–8, comprising Jeremiah’s “I,” then Yahweh’s “I” quoting Jeremiah, then Yahweh’s own “I,” a sequence recurs in Yahweh’s “I” (v. 15) followed by his “you” (referring to Jeremiah, v. 17) and his further “I” here. There is something Yahweh must do and something Jeremiah must do."), _c('a', {
    attrs: {
      "href": "#/#footnote-2091",
      "id": "footnote-2091-backlink"
    }
  }, [_c('sup', [_vm._v("72")])]), _vm._v(" Once again, Yahweh picks up the verb "), _c('em', [_vm._v("I am making")]), _vm._v(" (see v. 5). As well as making Jeremiah a prophet, he is necessarily making him invincible. Only here (and when Yahweh refers back to this moment in 6:27) is a "), _c('em', [_vm._v("fortified town")]), _vm._v(" a metaphor for a person. A fortified town (4:5; 5:17; 8:14; 34:7) is one with a wall that makes it hard to take, but it is not invincible, so perhaps that metaphor is insufficient. On the other hand, there is no such literal thing as "), _c('em', [_vm._v("an iron pillar")]), _vm._v(". Wooden pillars held up the Gaza temple, but they didn’t withstand Samson’s pushing (Judg 16:25–30). An iron pillar might be a different matter."), _c('a', {
    attrs: {
      "href": "#/#footnote-2090",
      "id": "footnote-2090-backlink"
    }
  }, [_c('sup', [_vm._v("73")])]), _vm._v(" There is also no such thing as "), _c('em', [_vm._v("bronze walls")]), _vm._v(". Again, regular stone walls can be penetrated (39:8; 50:15; 51:44), but bronze walls might be a different matter. These metaphorical ones will be capable of withstanding "), _c('em', [_vm._v("kings, officials, priests, and people")]), _vm._v(". Whereas the towns, pillars, and walls of Jerusalem and Judah will fall (v. 15), Jeremiah will not."), _c('a', {
    attrs: {
      "href": "#/#footnote-2089",
      "id": "footnote-2089-backlink"
    }
  }, [_c('sup', [_vm._v("74")])]), _vm._v(" “In contrast to Jerusalem, Jeramiah is the true invincible city.”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2088",
      "id": "footnote-2088-backlink"
    }
  }, [_c('sup', [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_c('span', {
    staticClass: "versenum"
  }, [_vm._v("19")]), _vm._v(" He is called to wage a "), _c('em', [_vm._v("battle")]), _vm._v(" for his people’s minds, and they will oppose him, but they will not overcome him."), _c('a', {
    attrs: {
      "href": "#/#footnote-2087",
      "id": "footnote-2087-backlink"
    }
  }, [_c('sup', [_vm._v("76")])]), _vm._v(" Jesus makes a similar promise to Peter (Matt 16:18)."), _c('a', {
    attrs: {
      "href": "#/#footnote-2086",
      "id": "footnote-2086-backlink"
    }
  }, [_c('sup', [_vm._v("77")])]), _vm._v(" Jeremiah will be under attack from Judah as Judah will be under attack from Babylon. Their fighting against him will link with his being a kind of embodiment of Yahweh’s word."), _c('a', {
    attrs: {
      "href": "#/#footnote-2085",
      "id": "footnote-2085-backlink"
    }
  }, [_c('sup', [_vm._v("78")])]), _vm._v(" They will oppose him because they are opposing Yahweh. The implicit reference to this dynamic is an aspect of the way the account of Jeremiah’s commission flags some central themes of the scroll."), _c('a', {
    attrs: {
      "href": "#/#footnote-2084",
      "id": "footnote-2084-backlink"
    }
  }, [_c('sup', [_vm._v("79")])]), _vm._v(" Once again, the first colon raises a question that the second has to answer. Jeremiah will stand not because of strength in him but because Yahweh is with him to rescue him, "), _c('em', [_vm._v("to snatch you away")]), _vm._v(". Yahweh exactly repeats v. 8b except for the order of words at the end, completing the repetition that was initiated in v. 17 but broken off in threatening fashion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("“There is no happier man … than the man who, having been called by God to be a spokesman for God, has been obedient to the heavenly vision and has answered the call with a resounding ‘Here am I. Send me!’ (Isa 6:8).”"), _c('a', {
    attrs: {
      "href": "#/#footnote-2083",
      "id": "footnote-2083-backlink"
    }
  }, [_c('sup', [_vm._v("80")])]), _vm._v(" Jeremiah does not claim that response here, but what follows speaks louder than the omission.")]), _vm._v(" "), _c('p', {
    staticClass: "image-f"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/foot.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2162-backlink",
      "id": "footnote-2162"
    }
  }, [_vm._v("1")]), _vm._v(". Y. Raz, “Jeremiah ‘Before the Womb’: On Fathers, Sons, and the Telos of Redaction in Jeremiah 1,” in Maier and Sharp, "), _c('em', [_vm._v("Prophecy and Power")]), _vm._v(", 91, 93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2161-backlink",
      "id": "footnote-2161"
    }
  }, [_vm._v("2")]), _vm._v(". Lundbom ("), _c('em', [_vm._v("Jeremiah 1–20")]), _vm._v(", 223–24) discusses possible locations.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2160-backlink",
      "id": "footnote-2160"
    }
  }, [_vm._v("3")]), _vm._v(". On whether Jeremiah is really an Ephraimite or a Judahite, see H. B. Huffmon, “Jeremiah of Anathoth,” in Chazan, Hallo, and Schiffman, "), _c('em', [_vm._v("Ki Baruch Hu")]), _vm._v(", 261–72.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2159-backlink",
      "id": "footnote-2159"
    }
  }, [_vm._v("4")]), _vm._v(". Duhm, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 2. But see A. P. Jassen, “The Rabbinic Construction of Jeremiah’s Lineage,” in "), _c('em', [_vm._v("Texts and Contexts of Jeremiah")]), _vm._v(", ed. K. Finsterbusch and A. Lange (Leuven: Peeters, 2016), 3–20.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2158-backlink",
      "id": "footnote-2158"
    }
  }, [_vm._v("5")]), _vm._v(". See further S. D. McBride, “Jeremiah and the Levitical Priests of Anathoth,” in "), _c('em', [_vm._v("Thus Says the Lord: Essays on the Former and Latter Prophets in Honor of Robert R. Wilson")]), _vm._v(", ed. J. J. Ahn and S. L. Cook, LHBOTS 502 (London: T&T Clark, 2009), 179–196.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2157-backlink",
      "id": "footnote-2157"
    }
  }, [_vm._v("6")]), _vm._v(". R. P. Carroll, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", OTL, 90–91.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2156-backlink",
      "id": "footnote-2156"
    }
  }, [_vm._v("7")]), _vm._v(". S. Herrmann, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 2 fascicles, Biblischer Kommentar: Altes Testament (Neukirchen: Neukirchener, 1986, 1990), 1:11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2155-backlink",
      "id": "footnote-2155"
    }
  }, [_vm._v("8")]), _vm._v(". G. Fischer, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 2 vols., Herders Theologischer Kommentar zum Alten Testament (Freiburg: Herder, 2005), 1:133.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2154-backlink",
      "id": "footnote-2154"
    }
  }, [_vm._v("9")]), _vm._v(". J. I. Lawler, “Word Event in Jeremiah,” in "), _c('em', [_vm._v("Inspired Speech: Prophecy in the Ancient Near East; Essays in Honor of Herbert B. Huffmon")]), _vm._v(", ed. J. Kaltner and L. Stulman, JSOTSup 378 (London: T&T Clark, 2004), 242.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2153-backlink",
      "id": "footnote-2153"
    }
  }, [_vm._v("10")]), _vm._v(". Fischer, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 1:127.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2152-backlink",
      "id": "footnote-2152"
    }
  }, [_vm._v("11")]), _vm._v(". D. Rom-Shiloni, "), _c('em', [_vm._v("Exclusive Inclusivity: Identity Conflicts Between the Exiles and the People Who Remained (6th–5th Centuries BCE)")]), _vm._v(", LHBOTS 543 (London: T&T Clark, 2013), 212.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2151-backlink",
      "id": "footnote-2151"
    }
  }, [_vm._v("12")]), _vm._v(". Origen of Alexandria, "), _c('em', [_vm._v("Homilies on Jeremiah and 1 Kings 28")]), _vm._v(", trans. John Clark Smith, The Fathers of the Church 97 (Washington: Catholic University of America, 1998), 4–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2150-backlink",
      "id": "footnote-2150"
    }
  }, [_vm._v("13")]), _vm._v(". See further H.-J. Stipp, “Die joschijanische Reform im Jeremiabuch,” in "), _c('em', [_vm._v("“Ich werde meinen Bund mit euch niemals brechen!” (Ri 2, 1): Festschrift für Walter Gross zum 70. Geburtstag")]), _vm._v(", ed. E. Gass and H.-J. Stipp, Herders Biblische Studien 62 (Freiburg: Herder, 2011), 101–29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2149-backlink",
      "id": "footnote-2149"
    }
  }, [_vm._v("14")]), _vm._v(". See D. Vieweger, "), _c('em', [_vm._v("Die Spezifik der Berufungsberichte Jeremias und Ezechiels im Umfeld")]), _vm._v(" "), _c('em', [_vm._v("ähnlicher Einheiten des Alten Testaments")]), _vm._v(", Beiträge zur Erforschung des Alten Testaents und des antike Judentums 6 (Frankfurt: Lang, 1986).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2148-backlink",
      "id": "footnote-2148"
    }
  }, [_vm._v("15")]), _vm._v(". P. D. Miller, “Jeremiah,” in "), _c('em', [_vm._v("The New Interpreter’s Bible")]), _vm._v(", ed. L. E. Keck, vol. 6 (Nashville: Abingdon, 2001). See further G. Wanke, “Jeremias Berufung (Jer 1,4–10),” in "), _c('em', [_vm._v("Alttestamentlicher Glaube und Biblische Theologie: Festschrift für Horst Dietrich Preuss zum 65. Geburtstag")]), _vm._v(", ed. J. Hausmann and H.-J. Zobel (Stuttgart: Kohlhammer, 1992), 132–44.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2147-backlink",
      "id": "footnote-2147"
    }
  }, [_vm._v("16")]), _vm._v(". P. E. Thompson, “Jeremiah 1:1–10,” "), _c('em', [_vm._v("Int")]), _vm._v(" 62 (2008): 66, 67, quoting F. Buechner, "), _c('em', [_vm._v("Wishful Thinking")]), _vm._v(" (New York: Harper, 1973), 118.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2146-backlink",
      "id": "footnote-2146"
    }
  }, [_vm._v("17")]), _vm._v(". E. Davis Lewin, “Arguing for Authority: A Rhetorical Study of Jeremiah 1.4–19 and 20.7–18,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 32 (1985): 107.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2145-backlink",
      "id": "footnote-2145"
    }
  }, [_vm._v("18")]), _vm._v(". P. C. Craigie, P. H. Kelley, and J. F. Drinkard, "), _c('em', [_vm._v("Jeremiah 1–25")]), _vm._v(", WBC 26 (Dallas: Word, 1991), 11–12.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2144-backlink",
      "id": "footnote-2144"
    }
  }, [_vm._v("19")]), _vm._v(". See E. R. Hayes, “The Role of Visionary Experiences for Establishing Prophetic Authority in Isaiah, Jeremiah and Ezekiel,” in "), _c('em', [_vm._v("“I Lifted My Eyes and Saw”: Reading Dream and Vision Reports in the Hebrew Bible")]), _vm._v(", ed. E. R. Hayes and L.-S. Tiemeyer, LHBOTS 584 (London: T&T Clark, 2014), 59–70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2143-backlink",
      "id": "footnote-2143"
    }
  }, [_vm._v("20")]), _vm._v(". McKane, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 1:9, summarizing Rudolph, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 9–10 (who says it’s as real as Paul on the Damascus road), and Weiser, about whose views McKane is hesitant (A. Weiser, "), _c('em', [_vm._v("Das Buch des Propheten Jeremia")]), _vm._v(", 2 vols, Das Alte Testament Deutsch [Göttingen: Vandenhoeck & Ruprecht, 1952]).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2142-backlink",
      "id": "footnote-2142"
    }
  }, [_vm._v("21")]), _vm._v(". Pixley, "), _c('em', [_vm._v("Jeremiah,")]), _vm._v(" 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2141-backlink",
      "id": "footnote-2141"
    }
  }, [_vm._v("22")]), _vm._v(". For theories regarding the development of Jer 1, see, e.g., J. Schreiner, “Jeremias Berufung (Jer 1,4–19): Eine Textanalyse,” in "), _c('em', [_vm._v("Homenaje a Juan Prado")]), _vm._v(", ed. L. Alvarez Verdes and E. J. Alonso Hernández (Madrid: CSIC, 1975), 131–45; B. Renaud, “Jér 1: Structure et Théologie de la Redaction,” in Bogaert, "), _c('em', [_vm._v("Livre de Jérémie")]), _vm._v(", 177–196; W. Thiel, “‘Vom Norden her wird das Unheil eröffnet’: Zu Jeremia 1,11–16,” in "), _c('em', [_vm._v("Prophet und Prophetenbuch: Festschrift für Otto Kaiser zum 65. Geburtstag")]), _vm._v(", ed. V. Fritz, K.-F. Pohlmann, and H.-C. Schmitt, BZAW 185 (Berlin: de Gruyter, 1989), 231–45; J. R. Lundbom, “Rhetorical Structures in Jeremiah 1,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 93 (1991): 193–210; C. J. Sharp, “The Call of Jeremiah and Diaspora Politics,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 119 (2000): 421–38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2140-backlink",
      "id": "footnote-2140"
    }
  }, [_vm._v("23")]), _vm._v(". J. M. Berridge, "), _c('em', [_vm._v("Prophet, People, and the Word of Yahweh: An Examination of Form and Content in the Proclamation of the Prophet Jeremiah")]), _vm._v(", Basel Studies of Theology 4 (Zurich: EVZ, 1970), 41.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2139-backlink",
      "id": "footnote-2139"
    }
  }, [_vm._v("24")]), _vm._v(". Rudolph, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2138-backlink",
      "id": "footnote-2138"
    }
  }, [_vm._v("25")]), _vm._v(". E. H. Roshwalb, “Jeremiah 1:4–10: ‘Lost and Found’ in Translation and a New Interpretation,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 34 (2010): 351–76.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2137-backlink",
      "id": "footnote-2137"
    }
  }, [_vm._v("26")]), _vm._v(". Berridge, "), _c('em', [_vm._v("Prophet, People, and the Word")]), _vm._v(", 29; contrast H. G. Reventlow, "), _c('em', [_vm._v("Liturgie und prophetisches Ich bei Jeremia")]), _vm._v(" (Gütersloh: Mohn, 1963), 70.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2136-backlink",
      "id": "footnote-2136"
    }
  }, [_vm._v("27")]), _vm._v(". See M. J. de Jong, “Why Jeremiah Is Not among the Prophets: An Analysis of the Terms "), _c('em', [_vm._v("nby")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _vm._v(" and "), _c('em', [_vm._v("nb")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʾ")]), _c('em', [_vm._v("ym")]), _vm._v(" in the Book of Jeremiah,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 35 (2011): 483–510; more broadly, see A. G. Auld, “Prophets through the Looking Glass: Between Writings and Moses,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 27 (1983): 3–23; “Prophets and Prophecy in Jeremiah and Kings,” ZAW 96 (1984): 66–82; cf., in response, T. W. Overholt, “Prophecy in History: The Social Reality of Intermediation,” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 48 (1990): 3–29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2135-backlink",
      "id": "footnote-2135"
    }
  }, [_vm._v("28")]), _vm._v(". Herrmann, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 1:58.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2134-backlink",
      "id": "footnote-2134"
    }
  }, [_vm._v("29")]), _vm._v(". R. P. Carroll, "), _c('em', [_vm._v("From Chaos to Covenant")]), _vm._v(", 53.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2133-backlink",
      "id": "footnote-2133"
    }
  }, [_vm._v("30")]), _vm._v(". H. Michaud, “La vocation du ‘prophète des nations,’” in "), _c('em', [_vm._v("Maqqel shaqedh: Hommage à Wilhelm Vischer")]), _vm._v(" (Montpelier: Castelnau, 1960), 161.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2132-backlink",
      "id": "footnote-2132"
    }
  }, [_vm._v("31")]), _vm._v(". C. J. Sharp, “Call of Jeremiah,” 421–38. Sharp sees them as reflecting two different political agendas.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2131-backlink",
      "id": "footnote-2131"
    }
  }, [_vm._v("32")]), _vm._v(". D. O. Idowu, “The Sovereignty of God in Jeremiah 1:4–10 and the Belief in Destiny among Yoruba People of Nigeria,” "), _c('em', [_vm._v("Practical Theology")]), _vm._v(" "), _c('em', [_vm._v("(Baptist College of Theology, Lagos)")]), _vm._v(" 9 (2016): 146–170.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2130-backlink",
      "id": "footnote-2130"
    }
  }, [_vm._v("33")]), _vm._v(". P. Volz, "), _c('em', [_vm._v("Der Prophet Jeremia")]), _vm._v(", Kommentar zum Alten Testament, 2nd ed., vol. 10 (Leipzig: Deicher, 1928), 5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2129-backlink",
      "id": "footnote-2129"
    }
  }, [_vm._v("34")]), _vm._v(". Y. Gitay, “The Projection of the Prophet: A Rhetorical Presentation of the Prophet Jeremiah (according to Jer 1:1–19),” in "), _c('em', [_vm._v("Prophecy and Prophets: The Diversity of Contemporary Issues in Scholarship")]), _vm._v(", ed. Y. Gitay, Semeia Studies 32 (Atlanta: Scholars, 1997), 45–46.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2128-backlink",
      "id": "footnote-2128"
    }
  }, [_vm._v("35")]), _vm._v(". See BDB.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2127-backlink",
      "id": "footnote-2127"
    }
  }, [_vm._v("36")]), _vm._v(". Jerome, "), _c('em', [_vm._v("Jeremiah,")]), _vm._v(" 4.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2126-backlink",
      "id": "footnote-2126"
    }
  }, [_vm._v("37")]), _vm._v(". B. A. Strawn, “Jeremiah’s In/effective Plea: Another Look at "), _c('em', [_vm._v("n")]), _c('span', {
    staticClass: "chari"
  }, [_vm._v("ʿ")]), _c('em', [_vm._v("r")]), _vm._v(" in Jeremiah i 6,” "), _c('em', [_vm._v("VT")]), _vm._v(" 65 (2005): 366–77.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2125-backlink",
      "id": "footnote-2125"
    }
  }, [_vm._v("38")]), _vm._v(". Fischer, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 1:134–35.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2124-backlink",
      "id": "footnote-2124"
    }
  }, [_vm._v("39")]), _vm._v(". H. L. Ellison, “The Prophecy of Jeremiah,” "), _c('em', [_vm._v("EvQ")]), _vm._v(" 31 (1959): 214.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2123-backlink",
      "id": "footnote-2123"
    }
  }, [_vm._v("40")]), _vm._v(". See H. P. Nasuti, “A Prophet to the Nations: Diachronic and Synchronic Readings of Jeremiah 1,” "), _c('em', [_vm._v("Hebrew Annual Review")]), _vm._v(" 10 (1986): 253–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2122-backlink",
      "id": "footnote-2122"
    }
  }, [_vm._v("41")]), _vm._v(". See, e.g., C. M. Maier, “Jeremia am Ende: Prophetie als Schriftgelehrsamkeit,” "), _c('em', [_vm._v("EvT")]), _vm._v(" 77 (2017), 51–53; G. Fischer also notes the differences between Jeremiah and Moses, in “Jeremiah—‘The Prophet Like Moses’?,” in Lundbom, Evans, and B. A. Anderson, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 45–66.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2121-backlink",
      "id": "footnote-2121"
    }
  }, [_vm._v("42")]), _vm._v(". Mastnjak, "), _c('em', [_vm._v("Deuteronomy")]), _vm._v(", 40–92.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2120-backlink",
      "id": "footnote-2120"
    }
  }, [_vm._v("43")]), _vm._v(". See, e.g., G. E. Yates, “Intertextuality and the Portrayal of Jeremiah the Prophet,” "), _c('em', [_vm._v("BSac")]), _vm._v(" 170 (2013): 288–93.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2119-backlink",
      "id": "footnote-2119"
    }
  }, [_vm._v("44")]), _vm._v(". W. H. Schmidt, "), _c('em', [_vm._v("Das Buch Jeremia")]), _vm._v(", 2 vols., Das Alte Testament Deutsch (Göttingen: Vandenhoeck & Ruprecht, 2008, 2013), 1:49.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2118-backlink",
      "id": "footnote-2118"
    }
  }, [_vm._v("45")]), _vm._v(". F. García López (“Élection-vocation d’Israël et de Jérémie,” "), _c('em', [_vm._v("VT")]), _vm._v(" 35 [1985]: 1–12) also compares the account of Israel’s election.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2117-backlink",
      "id": "footnote-2117"
    }
  }, [_vm._v("46")]), _vm._v(". J. A. Dearman, "), _c('em', [_vm._v("Jeremiah and Lamentations")]), _vm._v(", The NIV Application Commentary (Grand Rapids: Zondervan, 2002), on the passage.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2116-backlink",
      "id": "footnote-2116"
    }
  }, [_vm._v("47")]), _vm._v(". John Cassian, "), _c('em', [_vm._v("Conferences")]), _vm._v(" 14.3 (NPNF II, 11:436); cf. D. O. Wenthe, "), _c('em', [_vm._v("Jeremiah, Lamentations")]), _vm._v(", Ancient Christian Commentary on Scripture: Old Testament 12 (Downers Grove, IL: InterVarsity, 2009), 8.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2115-backlink",
      "id": "footnote-2115"
    }
  }, [_vm._v("48")]), _vm._v(". See G. H Wittenberg, “‘To Build and to Plant’ (Jer. 1:10): The Message of Jeremiah as a Source of Hope for the Exilic Community and Its Relevance for Community Building in South Africa,” "), _c('em', [_vm._v("Journal of Theology for Southern Africa")]), _vm._v(" 112 (2002): 57–67.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2114-backlink",
      "id": "footnote-2114"
    }
  }, [_vm._v("49")]), _vm._v(". W. Brueggemann, “Meditation Upon the Abyss: The Book of Jeremiah,” "), _c('em', [_vm._v("WW")]), _vm._v(" 22 (2002): 347.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2113-backlink",
      "id": "footnote-2113"
    }
  }, [_vm._v("50")]), _vm._v(". M. Fox, “Closer Look at Jeremiah 1:10 with Implications for (Re)Reading Jeremiah 1,” "), _c('em', [_vm._v("Didaskalia")]), _vm._v(" 22 (2011): 61–84.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2112-backlink",
      "id": "footnote-2112"
    }
  }, [_vm._v("51")]), _vm._v(". Berrigan, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 2.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2111-backlink",
      "id": "footnote-2111"
    }
  }, [_vm._v("52")]), _vm._v(". Cf. H. Bardtke, “Jeremia der Fremdvölkerprophet,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 53 (1935): 215.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2110-backlink",
      "id": "footnote-2110"
    }
  }, [_vm._v("53")]), _vm._v(". W. Vischer, “The Vocation of the Prophet to the Nations: An Exegesis of Jeremiah 1:4–10,” "), _c('em', [_vm._v("Int")]), _vm._v(" 9 (1955): 314.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2109-backlink",
      "id": "footnote-2109"
    }
  }, [_vm._v("54")]), _vm._v(". See Sharp, “Call of Jeremiah.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2108-backlink",
      "id": "footnote-2108"
    }
  }, [_vm._v("55")]), _vm._v(". Jerome, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 4–5.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2107-backlink",
      "id": "footnote-2107"
    }
  }, [_vm._v("56")]), _vm._v(". K. van der Toorn (“Did Jeremiah See Aaron’s Staff?” "), _c('em', [_vm._v("JSOT")]), _vm._v(" 43 [1989]: 83–94) suggests that he saw Aaron’s staff in the temple (Num 17:1–11[16–26]).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2106-backlink",
      "id": "footnote-2106"
    }
  }, [_vm._v("57")]), _vm._v(". Holladay, "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(", 1:37.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2105-backlink",
      "id": "footnote-2105"
    }
  }, [_vm._v("58")]), _vm._v(". Fretheim, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 52.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2104-backlink",
      "id": "footnote-2104"
    }
  }, [_vm._v("59")]), _vm._v(". W. E. March, “Jeremiah 1: Commission and Assurance,” "), _c('em', [_vm._v("Austin Seminary Bulletin")]), _vm._v(" 86 (1970): 29.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2103-backlink",
      "id": "footnote-2103"
    }
  }, [_vm._v("60")]), _vm._v(". Holladay, "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(", 1:40.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2102-backlink",
      "id": "footnote-2102"
    }
  }, [_vm._v("61")]), _vm._v(". W. H. Schmidt, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 1:60.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2101-backlink",
      "id": "footnote-2101"
    }
  }, [_vm._v("62")]), _vm._v(". Cf. D. J. Reimer, “The ‘Foe’ and the ‘North’ in Jeremiah,” "), _c('em', [_vm._v("ZAW")]), _vm._v(" 101 (1989): 223–32; D. S. Vanderhooft, "), _c('em', [_vm._v("The Neo-Babylonian Empire and Babylon in the Latter Prophets")]), _vm._v(", Harvard Semitic Monographs 59 (Atlanta: Scholars, 1999), 136–49. E. H. Roshwalb argues that the figure from the north "), _c('em', [_vm._v("is")]), _vm._v(" God (“Build-Up and Climax in Jeremiah’s Visions and Laments,” in "), _c('em', [_vm._v("Boundaries of the Ancient Near Eastern World: A Tribute to C. H. Gordon")]), _vm._v(", ed. M. Lubetski, JSOTSup 273 [Sheffield: Sheffield Academic, 1998], 111–35).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2100-backlink",
      "id": "footnote-2100"
    }
  }, [_vm._v("63")]), _vm._v(". Calvin, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", 1:50.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2099-backlink",
      "id": "footnote-2099"
    }
  }, [_vm._v("64")]), _vm._v(". K. M. O’Connor, “Jeremiah,” in "), _c('em', [_vm._v("The Oxford Bible Commentary")]), _vm._v(", ed. J. Barton and J. Muddiman (Oxford: Oxford University Press, 2007), 490.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2098-backlink",
      "id": "footnote-2098"
    }
  }, [_vm._v("65")]), _vm._v(". Cf. E. K. Holt’s broader argument in “The Meaning of an "), _c('em', [_vm._v("Inclusio:")]), _vm._v(" A Theological Interpretation of the Book of Jeremiah MT,” "), _c('em', [_vm._v("SJOT")]), _vm._v(" 17 (2013): 181–205.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2097-backlink",
      "id": "footnote-2097"
    }
  }, [_vm._v("66")]), _vm._v(". Duhm ("), _c('em', [_vm._v("Jeremia")]), _vm._v(", 12) calls it an “apocalyptic” motif associated with the expression of a “later dogmatic eschatology.”")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2096-backlink",
      "id": "footnote-2096"
    }
  }, [_vm._v("67")]), _vm._v(". R. P. Carroll, "), _c('em', [_vm._v("Jeremiah")]), _vm._v(", OTL, 106–8.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2095-backlink",
      "id": "footnote-2095"
    }
  }, [_vm._v("68")]), _vm._v(". Sharp, “Jeremiah,” 228.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2094-backlink",
      "id": "footnote-2094"
    }
  }, [_vm._v("69")]), _vm._v(". Volz, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 11.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2093-backlink",
      "id": "footnote-2093"
    }
  }, [_vm._v("70")]), _vm._v(". Nasuti, “A Prophet to the Nations,” 259.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2092-backlink",
      "id": "footnote-2092"
    }
  }, [_vm._v("71")]), _vm._v(". Holladay, "), _c('em', [_vm._v("Commentary on Jeremiah")]), _vm._v(", 1:31")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2091-backlink",
      "id": "footnote-2091"
    }
  }, [_vm._v("72")]), _vm._v(". Lundbom, "), _c('em', [_vm._v("Jeremiah 1–20")]), _vm._v(", 244–48.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2090-backlink",
      "id": "footnote-2090"
    }
  }, [_vm._v("73")]), _vm._v(". M. Görg, “Die ‘ehernen Säulen’ (1 Reg 7,15) und die ‘eiserne Säule’ (Jer 1,18),” in "), _c('em', [_vm._v("Prophetie und geschichtliche Wirklichkeit im Alten Israel: Festschrift für Siegfried Herrmann zum 65. Geburtstag")]), _vm._v(", ed. R. Liwak and S. Wagner (Stuttgart: Kohlhammer, 1991), 134–54.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2089-backlink",
      "id": "footnote-2089"
    }
  }, [_vm._v("74")]), _vm._v(". On the iconographic background to this imagery, see P. Riede, "), _c('em', [_vm._v("Ich mache dich zur festen Stadt: Zum Prophetenbild von Jeremia 1,18f und 15,20")]), _vm._v(", Forschung zur Bibel 121 (Würzburg: Echter, 2009).")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2088-backlink",
      "id": "footnote-2088"
    }
  }, [_vm._v("75")]), _vm._v(". Diamond, “Jeremiah,” 550.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2087-backlink",
      "id": "footnote-2087"
    }
  }, [_vm._v("76")]), _vm._v(". See further C. M. Maier, “Jeremiah as Yhwh’s Stronghold,” "), _c('em', [_vm._v("VT")]), _vm._v(" 64 (2014): 640–53; R. C. Bailey, “Jeremiah: Fortified City, Bronze Walls, and Iron Pillar against the Whole Land,” "), _c('em', [_vm._v("Hebrew Studies")]), _vm._v(" 57 (2016): 117–38.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2086-backlink",
      "id": "footnote-2086"
    }
  }, [_vm._v("77")]), _vm._v(". See B. T. Dahlberg, “The Typological Use of Jeremiah 1:4–19 in Matthew 16:13–23,” "), _c('em', [_vm._v("JBL")]), _vm._v(" 94 (1975): 73–80.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2085-backlink",
      "id": "footnote-2085"
    }
  }, [_vm._v("78")]), _vm._v(". H. Mottu, “Aux sources de notre vocation: Jérémie 1, 4–19,” "), _c('em', [_vm._v("Revue de théologie et de philosophie")]), _vm._v(" 32 (1982): 105.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2084-backlink",
      "id": "footnote-2084"
    }
  }, [_vm._v("79")]), _vm._v(". Herrmann, "), _c('em', [_vm._v("Jeremia")]), _vm._v(", 1:91.")]), _vm._v(" "), _c('p', {
    staticClass: "footnotes"
  }, [_c('a', {
    attrs: {
      "href": "#/#footnote-2083-backlink",
      "id": "footnote-2083"
    }
  }, [_vm._v("80")]), _vm._v(". R. Youngblood, “The Call of Jeremiah,” "), _c('em', [_vm._v("Criswell Theological Review")]), _vm._v(" 5 (1990): 108.")])])])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781467462471',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(142)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(144);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 144 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.e4ca5be7075986e8bf20.js